// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AccountActivitiesData, AccountActivitiesErrors, AccountActivitiesResponses, AccountContentData, AccountContentErrors, AccountContentResponses, AccountsAccountsTableManyData, AccountsAccountsTableManyErrors, AccountsAccountsTableManyResponses, AccountsAdvocatesByDomainManyData, AccountsAdvocatesByDomainManyErrors, AccountsAdvocatesByDomainManyResponses, AccountsReadData, AccountsReadErrors, AccountsReadResponses, AdminEmailComponentDeleteData, AdminEmailComponentDeleteErrors, AdminEmailComponentDeleteResponses, AdminEmailComponentsCreateData, AdminEmailComponentsCreateErrors, AdminEmailComponentsCreateResponses, AdminEmailComponentsReadManyData, AdminEmailComponentsReadManyErrors, AdminEmailComponentsReadManyResponses, AdminEmailComponentUpdateData, AdminEmailComponentUpdateErrors, AdminEmailComponentUpdateResponses, AdminEmailTemplateDeleteData, AdminEmailTemplateDeleteErrors, AdminEmailTemplateDeleteResponses, AdminEmailTemplatesCreateData, AdminEmailTemplatesCreateErrors, AdminEmailTemplatesCreateResponses, AdminEmailTemplatesReadManyData, AdminEmailTemplatesReadManyErrors, AdminEmailTemplatesReadManyResponses, AdminEmailTemplateUpdateData, AdminEmailTemplateUpdateErrors, AdminEmailTemplateUpdateResponses, AdminPromptsReadManyData, AdminPromptsReadManyErrors, AdminPromptsReadManyResponses, AdminPromptsUpdateData, AdminPromptsUpdateErrors, AdminPromptsUpdateResponses, AdminReferralsMilestoneRewardSettings2Data, AdminReferralsMilestoneRewardSettings2Errors, AdminReferralsMilestoneRewardSettings2Responses, AdminReferralsMilestoneRewardSettingsData, AdminReferralsMilestoneRewardSettingsErrors, AdminReferralsMilestoneRewardSettingsResponses, AdminReferralsReadData, AdminReferralsReadErrors, AdminReferralsReadManyData, AdminReferralsReadManyErrors, AdminReferralsReadManyResponses, AdminReferralsReadResponses, AdminReferralsStatsStatsData, AdminReferralsStatsStatsErrors, AdminReferralsStatsStatsResponses, AdminReferralsStatusData, AdminReferralsStatusErrors, AdminReferralsStatusResponses, AdminReferralsSyncLeadsData, AdminReferralsSyncLeadsErrors, AdminReferralsSyncLeadsResponses, AdminReferralsWorkatoLeadStatusWebhookData, AdminReferralsWorkatoLeadStatusWebhookErrors, AdminReferralsWorkatoLeadStatusWebhookResponses, AdminWebhookSubscriptionsCreateData, AdminWebhookSubscriptionsCreateErrors, AdminWebhookSubscriptionsCreateResponses, AdminWebhookSubscriptionsDeleteData, AdminWebhookSubscriptionsDeleteErrors, AdminWebhookSubscriptionsDeleteResponses, AdminWebhookSubscriptionsReadManyData, AdminWebhookSubscriptionsReadManyErrors, AdminWebhookSubscriptionsReadManyResponses, AdvocateScoresFanUserFanUserUuidHistoryData, AdvocateScoresFanUserFanUserUuidHistoryErrors, AdvocateScoresFanUserFanUserUuidHistoryResponses, AdvocateScoresGenerateData, AdvocateScoresGenerateErrors, AdvocateScoresGenerateResponses, AdvocateScoresListManyData, AdvocateScoresListManyErrors, AdvocateScoresListManyResponses, ApiTokensConnectionData, ApiTokensConnectionErrors, ApiTokensConnectionResponses, ApiTokensCreateData, ApiTokensCreateErrors, ApiTokensCreateResponses, ApiTokensDeleteData, ApiTokensDeleteErrors, ApiTokensDeleteResponses, ApiTokensReadManyData, ApiTokensReadManyErrors, ApiTokensReadManyResponses, ApiTokensUsageData, ApiTokensUsageErrors, ApiTokensUsageResponses, AuditLogsReadManyData, AuditLogsReadManyErrors, AuditLogsReadManyResponses, Auth0ConnectionLifecycleWebhookData, Auth0ConnectionLifecycleWebhookErrors, Auth0ConnectionLifecycleWebhookResponses, Auth0SsoTicketGenerateData, Auth0SsoTicketGenerateErrors, Auth0SsoTicketGenerateResponses, AuthsRequestPasswordResetData, AuthsRequestPasswordResetErrors, AuthsRequestPasswordResetResponses, AuthsResetPasswordData, AuthsResetPasswordErrors, AuthsResetPasswordResponses, BatchesExecuteData, BatchesExecuteErrors, BatchesExecuteResponses, BevyIntegrationEnableData, BevyIntegrationEnableErrors, BevyIntegrationEnableResponses, BrandApplicationFormsCreateData, BrandApplicationFormsCreateErrors, BrandApplicationFormsCreateResponses, BrandApplicationFormsPublicData, BrandApplicationFormsPublicErrors, BrandApplicationFormsPublicResponses, BrandApplicationFormsReadManyData, BrandApplicationFormsReadManyErrors, BrandApplicationFormsReadManyResponses, BrandApplicationsAllData, BrandApplicationsAllErrors, BrandApplicationsAllResponses, BrandApplicationsApplicantDeleteData, BrandApplicationsApplicantDeleteErrors, BrandApplicationsApplicantDeleteResponses, BrandApplicationsApplicantUpdateStatusData, BrandApplicationsApplicantUpdateStatusErrors, BrandApplicationsApplicantUpdateStatusResponses, BrandConfigReadByCodeData, BrandConfigReadByCodeErrors, BrandConfigReadByCodeResponses, BrandConfigsCsmLookupData, BrandConfigsCsmLookupErrors, BrandConfigsCsmLookupResponses, BrandConfigsEmailDnsHealthData, BrandConfigsEmailDnsHealthErrors, BrandConfigsEmailDnsHealthResponses, BrandConfigsEmbedMigrationData, BrandConfigsEmbedMigrationErrors, BrandConfigsEmbedMigrationResponses, BrandConfigsProgramTypeData, BrandConfigsProgramTypeErrors, BrandConfigsProgramTypeResponses, BrandConfigsReadData, BrandConfigsReadErrors, BrandConfigsReadResponses, BrandConfigsSurveyQuestionsManyData, BrandConfigsSurveyQuestionsManyErrors, BrandConfigsSurveyQuestionsManyResponses, BrandConfigsUpdateData, BrandConfigsUpdateErrors, BrandConfigsUpdateResponses, BrandEventsCreateData, BrandEventsCreateErrors, BrandEventsCreateResponses, BrandEventsDeleteData, BrandEventsDeleteErrors, BrandEventsDeleteResponses, BrandEventsReadData, BrandEventsReadErrors, BrandEventsReadManyData, BrandEventsReadManyErrors, BrandEventsReadManyResponses, BrandEventsReadResponses, BrandEventsUpdateData, BrandEventsUpdateErrors, BrandEventsUpdateResponses, BrandInternalEmailDomainsCreateData, BrandInternalEmailDomainsCreateErrors, BrandInternalEmailDomainsCreateResponses, BrandInternalEmailDomainsDeleteData, BrandInternalEmailDomainsDeleteErrors, BrandInternalEmailDomainsDeleteResponses, BrandInternalEmailDomainsReadManyData, BrandInternalEmailDomainsReadManyErrors, BrandInternalEmailDomainsReadManyResponses, BrandLevelBadgesDeleteData, BrandLevelBadgesDeleteErrors, BrandLevelBadgesDeleteResponses, BrandLevelBadgesUpdateData, BrandLevelBadgesUpdateErrors, BrandLevelBadgesUpdateResponses, BrandLevelRewardsDeleteData, BrandLevelRewardsDeleteErrors, BrandLevelRewardsDeleteResponses, BrandLevelRewardsUpdateData, BrandLevelRewardsUpdateErrors, BrandLevelRewardsUpdateResponses, BrandLevelsCreateBadgeData, BrandLevelsCreateBadgeErrors, BrandLevelsCreateBadgeResponses, BrandLevelsCreateData, BrandLevelsCreateErrors, BrandLevelsCreateResponses, BrandLevelsCreateRewardData, BrandLevelsCreateRewardErrors, BrandLevelsCreateRewardResponses, BrandLevelsDeleteData, BrandLevelsDeleteErrors, BrandLevelsDeleteResponses, BrandLevelsMeData, BrandLevelsMeErrors, BrandLevelsMeResponses, BrandLevelsPublicData, BrandLevelsPublicErrors, BrandLevelsPublicResponses, BrandLevelsReadData, BrandLevelsReadErrors, BrandLevelsReadManyData, BrandLevelsReadManyErrors, BrandLevelsReadManyResponses, BrandLevelsReadResponses, BrandLevelsUpdateData, BrandLevelsUpdateErrors, BrandLevelsUpdateResponses, BrandMissionFoldersConditionsSchemaData, BrandMissionFoldersConditionsSchemaErrors, BrandMissionFoldersConditionsSchemaResponses, BrandMissionFoldersCreateData, BrandMissionFoldersCreateErrors, BrandMissionFoldersCreateResponses, BrandMissionFoldersDeleteData, BrandMissionFoldersDeleteErrors, BrandMissionFoldersDeleteResponses, BrandMissionFoldersReadData, BrandMissionFoldersReadErrors, BrandMissionFoldersReadManyData, BrandMissionFoldersReadManyErrors, BrandMissionFoldersReadManyResponses, BrandMissionFoldersReadResponses, BrandMissionFoldersUpdateData, BrandMissionFoldersUpdateErrors, BrandMissionFoldersUpdateResponses, BrandMissionsAvailableManyData, BrandMissionsAvailableManyErrors, BrandMissionsAvailableManyResponses, BrandMissionsClearFolderManyData, BrandMissionsClearFolderManyErrors, BrandMissionsClearFolderManyResponses, BrandMissionsCloneData, BrandMissionsCloneErrors, BrandMissionsCloneResponses, BrandMissionsCreateData, BrandMissionsCreateErrors, BrandMissionsCreateResponses, BrandMissionsDeleteData, BrandMissionsDeleteErrors, BrandMissionsDeleteManyData, BrandMissionsDeleteManyErrors, BrandMissionsDeleteManyResponses, BrandMissionsDeleteResponses, BrandMissionsFanMissionsReadManyData, BrandMissionsFanMissionsReadManyErrors, BrandMissionsFanMissionsReadManyResponses, BrandMissionsFanUsersReadManyData, BrandMissionsFanUsersReadManyErrors, BrandMissionsFanUsersReadManyResponses, BrandMissionsManageTagsManyData, BrandMissionsManageTagsManyErrors, BrandMissionsManageTagsManyResponses, BrandMissionsMoveToFolderManyData, BrandMissionsMoveToFolderManyErrors, BrandMissionsMoveToFolderManyResponses, BrandMissionsOrganizationCountsManyData, BrandMissionsOrganizationCountsManyErrors, BrandMissionsOrganizationCountsManyResponses, BrandMissionsPinStatusData, BrandMissionsPinStatusErrors, BrandMissionsPinStatusResponses, BrandMissionsReadData, BrandMissionsReadErrors, BrandMissionsReadManyData, BrandMissionsReadManyErrors, BrandMissionsReadManyResponses, BrandMissionsReadResponses, BrandMissionsSchedulingDeclineUrlData, BrandMissionsSchedulingDeclineUrlErrors, BrandMissionsSchedulingDeclineUrlResponses, BrandMissionsSetOnLiveData, BrandMissionsSetOnLiveErrors, BrandMissionsSetOnLiveResponses, BrandMissionsSurveyAnswersCursorManyData, BrandMissionsSurveyAnswersCursorManyErrors, BrandMissionsSurveyAnswersCursorManyResponses, BrandMissionsSurveyAnswersReadManyData, BrandMissionsSurveyAnswersReadManyErrors, BrandMissionsSurveyAnswersReadManyResponses, BrandMissionsSurveyQuestionsCreateManyData, BrandMissionsSurveyQuestionsCreateManyErrors, BrandMissionsSurveyQuestionsCreateManyResponses, BrandMissionsSurveyQuestionsDeleteManyData, BrandMissionsSurveyQuestionsDeleteManyErrors, BrandMissionsSurveyQuestionsDeleteManyResponses, BrandMissionsSurveyQuestionsReadManyData, BrandMissionsSurveyQuestionsReadManyErrors, BrandMissionsSurveyQuestionsReadManyResponses, BrandMissionsTargetAdvocatesData, BrandMissionsTargetAdvocatesErrors, BrandMissionsTargetAdvocatesResponses, BrandMissionsTestimonialAnswersReadManyData, BrandMissionsTestimonialAnswersReadManyErrors, BrandMissionsTestimonialAnswersReadManyResponses, BrandMissionsTestimonialMissionQuestionAnswerCreateData, BrandMissionsTestimonialMissionQuestionAnswerCreateErrors, BrandMissionsTestimonialMissionQuestionAnswerCreateResponses, BrandMissionsTestimonialQuestionsReadManyData, BrandMissionsTestimonialQuestionsReadManyErrors, BrandMissionsTestimonialQuestionsReadManyResponses, BrandMissionsUpdateData, BrandMissionsUpdateErrors, BrandMissionsUpdateResponses, BrandMissionTagsCreateData, BrandMissionTagsCreateErrors, BrandMissionTagsCreateResponses, BrandMissionTagsDeleteData, BrandMissionTagsDeleteErrors, BrandMissionTagsDeleteResponses, BrandMissionTagsReadData, BrandMissionTagsReadErrors, BrandMissionTagsReadManyData, BrandMissionTagsReadManyErrors, BrandMissionTagsReadManyResponses, BrandMissionTagsReadResponses, BrandMissionTagsUpdateData, BrandMissionTagsUpdateErrors, BrandMissionTagsUpdateResponses, BrandReferenceRequestFanUsersActivateData, BrandReferenceRequestFanUsersActivateErrors, BrandReferenceRequestFanUsersActivateResponses, BrandReferenceRequestFanUsersDeclineData, BrandReferenceRequestFanUsersDeclineErrors, BrandReferenceRequestFanUsersDeclineResponses, BrandReferenceRequestFanUsersDeleteData, BrandReferenceRequestFanUsersDeleteErrors, BrandReferenceRequestFanUsersDeleteResponses, BrandReferenceRequestFanUsersManifestManyData, BrandReferenceRequestFanUsersManifestManyErrors, BrandReferenceRequestFanUsersManifestManyResponses, BrandReferenceRequestFanUsersPromoteData, BrandReferenceRequestFanUsersPromoteErrors, BrandReferenceRequestFanUsersPromoteResponses, BrandReferenceRequestFanUsersSupersedeData, BrandReferenceRequestFanUsersSupersedeErrors, BrandReferenceRequestFanUsersSupersedeResponses, BrandReferenceRequestFanUsersSyncManyData, BrandReferenceRequestFanUsersSyncManyErrors, BrandReferenceRequestFanUsersSyncManyResponses, BrandReferenceRequestFanUsersUpdateData, BrandReferenceRequestFanUsersUpdateErrors, BrandReferenceRequestFanUsersUpdateResponses, BrandReferenceRequestsAdvocateAnalysisData, BrandReferenceRequestsAdvocateAnalysisErrors, BrandReferenceRequestsAdvocateAnalysisResponses, BrandReferenceRequestsAskAboutAdvocateData, BrandReferenceRequestsAskAboutAdvocateErrors, BrandReferenceRequestsAskAboutAdvocateResponses, BrandReferenceRequestsBrandReferenceRequestFanUserCreateData, BrandReferenceRequestsBrandReferenceRequestFanUserCreateErrors, BrandReferenceRequestsBrandReferenceRequestFanUserCreateResponses, BrandReferenceRequestsBrandReferenceRequestFanUserSetData, BrandReferenceRequestsBrandReferenceRequestFanUserSetErrors, BrandReferenceRequestsBrandReferenceRequestFanUserSetResponses, BrandReferenceRequestsDeleteData, BrandReferenceRequestsDeleteErrors, BrandReferenceRequestsDeleteResponses, BrandReferenceRequestsDraftMatchFiltersData, BrandReferenceRequestsDraftMatchFiltersErrors, BrandReferenceRequestsDraftMatchFiltersResponses, BrandReferenceRequestsFunnelData, BrandReferenceRequestsFunnelErrors, BrandReferenceRequestsFunnelResponses, BrandReferenceRequestsLegacyReferenceRequestData, BrandReferenceRequestsLegacyReferenceRequestErrors, BrandReferenceRequestsLegacyReferenceRequestResponses, BrandReferenceRequestsManagerInfoWebhookData, BrandReferenceRequestsManagerInfoWebhookErrors, BrandReferenceRequestsManagerInfoWebhookResponses, BrandReferenceRequestsManifestManyData, BrandReferenceRequestsManifestManyErrors, BrandReferenceRequestsManifestManyResponses, BrandReferenceRequestsMatchAdvocatesData, BrandReferenceRequestsMatchAdvocatesErrors, BrandReferenceRequestsMatchAdvocatesResponses, BrandReferenceRequestsMatchExplanationsData, BrandReferenceRequestsMatchExplanationsErrors, BrandReferenceRequestsMatchExplanationsResponses, BrandReferenceRequestsNoteCreateData, BrandReferenceRequestsNoteCreateErrors, BrandReferenceRequestsNoteCreateResponses, BrandReferenceRequestsNotesReadManyData, BrandReferenceRequestsNotesReadManyErrors, BrandReferenceRequestsNotesReadManyResponses, BrandReferenceRequestsPinnedAdvocatesData, BrandReferenceRequestsPinnedAdvocatesErrors, BrandReferenceRequestsPinnedAdvocatesResponses, BrandReferenceRequestsReadData, BrandReferenceRequestsReadErrors, BrandReferenceRequestsReadManyData, BrandReferenceRequestsReadManyErrors, BrandReferenceRequestsReadManyResponses, BrandReferenceRequestsReadResponses, BrandReferenceRequestsSchedulingCancelData, BrandReferenceRequestsSchedulingCancelErrors, BrandReferenceRequestsSchedulingCancelResponses, BrandReferenceRequestsSchedulingCreateMeetingData, BrandReferenceRequestsSchedulingCreateMeetingErrors, BrandReferenceRequestsSchedulingCreateMeetingResponses, BrandReferenceRequestsSchedulingDeclineData, BrandReferenceRequestsSchedulingDeclineErrors, BrandReferenceRequestsSchedulingDeclineResponses, BrandReferenceRequestsSchedulingLinkData, BrandReferenceRequestsSchedulingLinkErrors, BrandReferenceRequestsSchedulingLinkResponses, BrandReferenceRequestsSchedulingReadSlotsReferenceIdData, BrandReferenceRequestsSchedulingReadSlotsReferenceIdErrors, BrandReferenceRequestsSchedulingReadSlotsReferenceIdResponses, BrandReferenceRequestsSchedulingRejectData, BrandReferenceRequestsSchedulingRejectErrors, BrandReferenceRequestsSchedulingRejectResponses, BrandReferenceRequestsSchedulingSubmitSlotData, BrandReferenceRequestsSchedulingSubmitSlotErrors, BrandReferenceRequestsSchedulingSubmitSlotResponses, BrandReferenceRequestsSyncManyData, BrandReferenceRequestsSyncManyErrors, BrandReferenceRequestsSyncManyResponses, BrandReferenceRequestsTimelineEntriesReadManyData, BrandReferenceRequestsTimelineEntriesReadManyErrors, BrandReferenceRequestsTimelineEntriesReadManyResponses, BrandReferenceRequestsTransitionData, BrandReferenceRequestsTransitionErrors, BrandReferenceRequestsTransitionResponses, BrandReferenceRequestsTriggerRequestNotificationWorkflowData, BrandReferenceRequestsTriggerRequestNotificationWorkflowErrors, BrandReferenceRequestsTriggerRequestNotificationWorkflowResponses, BrandReferenceRequestsUpdateData, BrandReferenceRequestsUpdateErrors, BrandReferenceRequestsUpdateResponses, BrandRewardsCreateData, BrandRewardsCreateErrors, BrandRewardsCreateResponses, BrandRewardsReadData, BrandRewardsReadErrors, BrandRewardsReadManyData, BrandRewardsReadManyErrors, BrandRewardsReadManyResponses, BrandRewardsReadResponses, BrandRewardsRedeemData, BrandRewardsRedeemErrors, BrandRewardsRedeemResponses, BrandRewardsRemoveBackgroundData, BrandRewardsRemoveBackgroundErrors, BrandRewardsRemoveBackgroundResponses, BrandRewardsUpdateData, BrandRewardsUpdateErrors, BrandRewardsUpdateResponses, BrandSendingDomainsActivateData, BrandSendingDomainsActivateErrors, BrandSendingDomainsActivateResponses, BrandSendingDomainsCreateData, BrandSendingDomainsCreateErrors, BrandSendingDomainsCreateResponses, BrandSendingDomainsHaltData, BrandSendingDomainsHaltErrors, BrandSendingDomainsHaltResponses, BrandSendingDomainsPauseData, BrandSendingDomainsPauseErrors, BrandSendingDomainsPauseResponses, BrandSendingDomainsReadData, BrandSendingDomainsReadErrors, BrandSendingDomainsReadManyData, BrandSendingDomainsReadManyErrors, BrandSendingDomainsReadManyResponses, BrandSendingDomainsReadResponses, BrandSendingDomainsResumeBrandData, BrandSendingDomainsResumeBrandErrors, BrandSendingDomainsResumeBrandResponses, BrandSendingDomainsResumeData, BrandSendingDomainsResumeErrors, BrandSendingDomainsResumeResponses, BrandSendingDomainsUpdateData, BrandSendingDomainsUpdateErrors, BrandSendingDomainsUpdateResponses, BrandSendingDomainsVerifyData, BrandSendingDomainsVerifyErrors, BrandSendingDomainsVerifyResponses, BrandSignupConfigsReadData, BrandSignupConfigsReadErrors, BrandSignupConfigsReadResponses, BrandSignupConfigsUpdateData, BrandSignupConfigsUpdateErrors, BrandSignupConfigsUpdateResponses, BrandSignupRulesConditionsSchemaData, BrandSignupRulesConditionsSchemaErrors, BrandSignupRulesConditionsSchemaResponses, BrandSignupRulesCreateData, BrandSignupRulesCreateErrors, BrandSignupRulesCreateResponses, BrandSignupRulesDeleteData, BrandSignupRulesDeleteErrors, BrandSignupRulesDeleteResponses, BrandSignupRulesReadManyData, BrandSignupRulesReadManyErrors, BrandSignupRulesReadManyResponses, BrandSignupRulesUpdateData, BrandSignupRulesUpdateErrors, BrandSignupRulesUpdateResponses, BrandsLookupData, BrandsLookupErrors, BrandsLookupResponses, BrandsMineManyData, BrandsMineManyErrors, BrandsMineManyResponses, BrandsPickerManyData, BrandsPickerManyErrors, BrandsPickerManyResponses, BrandsReadData, BrandsReadErrors, BrandsReadManyData, BrandsReadManyErrors, BrandsReadManyResponses, BrandsReadResponses, BrandsSignupAuditData, BrandsSignupAuditErrors, BrandsSignupAuditResponses, BrandsUgcApproveData, BrandsUgcApproveErrors, BrandsUgcApproveResponses, BrandsUgcDeclineData, BrandsUgcDeclineErrors, BrandsUgcDeclineResponses, BrandsUserGeneratedContentsManyData, BrandsUserGeneratedContentsManyErrors, BrandsUserGeneratedContentsManyResponses, BrandUserInvitationsTokenData, BrandUserInvitationsTokenErrors, BrandUserInvitationsTokenResponses, BrandUsersDeleteData, BrandUsersDeleteErrors, BrandUsersDeleteResponses, BrandUsersInviteData, BrandUsersInviteErrors, BrandUsersInviteResponses, BrandUsersMeData, BrandUsersMeErrors, BrandUsersMeResponses, BrandUsersMeUpdateData, BrandUsersMeUpdateErrors, BrandUsersMeUpdateResponses, BrandUsersReadManyData, BrandUsersReadManyErrors, BrandUsersReadManyResponses, BrandUsersRegisterData, BrandUsersRegisterErrors, BrandUsersRegisterResponses, BrandUsersWorkspacesSelectData, BrandUsersWorkspacesSelectErrors, BrandUsersWorkspacesSelectResponses, CachesClearData, CachesClearErrors, CachesClearResponses, ChangelogHandoffsCreateData, ChangelogHandoffsCreateErrors, ChangelogHandoffsCreateResponses, ChatConfigsReadData, ChatConfigsReadErrors, ChatConfigsReadResponses, ChatConfigsUpdateData, ChatConfigsUpdateErrors, ChatConfigsUpdateResponses, ChatMembersReadData, ChatMembersReadErrors, ChatMembersReadResponses, ChatMessageReportsMineData, ChatMessageReportsMineErrors, ChatMessageReportsMineResponses, ChatMessageReportsReadManyData, ChatMessageReportsReadManyErrors, ChatMessageReportsReadManyResponses, ChatMessageReportsUpdateData, ChatMessageReportsUpdateErrors, ChatMessageReportsUpdateResponses, ChatMessagesReportData, ChatMessagesReportErrors, ChatMessagesReportResponses, ChatPreferencesReadData, ChatPreferencesReadErrors, ChatPreferencesReadResponses, ChatPreferencesUpdateData, ChatPreferencesUpdateErrors, ChatPreferencesUpdateResponses, ChatsLinkPreviewData, ChatsLinkPreviewErrors, ChatsLinkPreviewResponses, ChatsPresenceData, ChatsPresenceErrors, ChatsPresenceResponses, ChatsTokenData, ChatsTokenErrors, ChatsTokenResponses, ChatWebhookData, ChatWebhookErrors, ChatWebhookResponses, CommentsCommentCreateData, CommentsCommentCreateErrors, CommentsCommentCreateResponses, CommentsDeleteData, CommentsDeleteErrors, CommentsDeleteResponses, CommentsLikeData, CommentsLikeErrors, CommentsLikeResponses, CommentsUnlikeData, CommentsUnlikeErrors, CommentsUnlikeResponses, CommentsUpdateData, CommentsUpdateErrors, CommentsUpdateResponses, ConversationsCreateData, ConversationsCreateErrors, ConversationsCreateResponses, ConversationsMessagesReadManyData, ConversationsMessagesReadManyErrors, ConversationsMessagesReadManyResponses, ConversationsReadData, ConversationsReadErrors, ConversationsReadManyData, ConversationsReadManyErrors, ConversationsReadManyResponses, ConversationsReadResponses, ConversationsUpdateData, ConversationsUpdateErrors, ConversationsUpdateResponses, CronJobsCreateData, CronJobsCreateErrors, CronJobsCreateResponses, CronJobsDeleteData, CronJobsDeleteErrors, CronJobsDeleteResponses, CronJobsReadData, CronJobsReadErrors, CronJobsReadManyData, CronJobsReadManyErrors, CronJobsReadManyResponses, CronJobsReadResponses, CronJobsTriggerData, CronJobsTriggerErrors, CronJobsTriggerResponses, CronJobsUpdateData, CronJobsUpdateErrors, CronJobsUpdateResponses, CustomFieldDefinitionsCreateData, CustomFieldDefinitionsCreateErrors, CustomFieldDefinitionsCreateResponses, CustomFieldDefinitionsDeleteData, CustomFieldDefinitionsDeleteErrors, CustomFieldDefinitionsDeleteResponses, CustomFieldDefinitionsReadManyData, CustomFieldDefinitionsReadManyErrors, CustomFieldDefinitionsReadManyResponses, CustomFieldDefinitionsSystemData, CustomFieldDefinitionsSystemErrors, CustomFieldDefinitionsSystemResponses, CustomFieldDefinitionsUpdateData, CustomFieldDefinitionsUpdateErrors, CustomFieldDefinitionsUpdateResponses, EmailComponentsCreateData, EmailComponentsCreateErrors, EmailComponentsCreateResponses, EmailComponentsDeleteData, EmailComponentsDeleteErrors, EmailComponentsDeleteResponses, EmailComponentsReadManyData, EmailComponentsReadManyErrors, EmailComponentsReadManyResponses, EmailComponentsUpdateData, EmailComponentsUpdateErrors, EmailComponentsUpdateResponses, EmailNotificationPreferencesReadData, EmailNotificationPreferencesReadErrors, EmailNotificationPreferencesReadResponses, EmailNotificationPreferencesUpdateData, EmailNotificationPreferencesUpdateErrors, EmailNotificationPreferencesUpdatePreferencesData, EmailNotificationPreferencesUpdatePreferencesErrors, EmailNotificationPreferencesUpdatePreferencesResponses, EmailNotificationPreferencesUpdateResponses, EmailSuppressionsCreateData, EmailSuppressionsCreateErrors, EmailSuppressionsCreateResponses, EmailSuppressionsReadMeData, EmailSuppressionsReadMeErrors, EmailSuppressionsReadMeResponses, EmailSuppressionsReadPreferencesData, EmailSuppressionsReadPreferencesErrors, EmailSuppressionsReadPreferencesResponses, EmailSuppressionsUpdateMeData, EmailSuppressionsUpdateMeErrors, EmailSuppressionsUpdateMeResponses, EmailSuppressionsUpdatePreferencesData, EmailSuppressionsUpdatePreferencesErrors, EmailSuppressionsUpdatePreferencesResponses, EmailTemplatesDeleteData, EmailTemplatesDeleteErrors, EmailTemplatesDeleteResponses, EmailTemplatesReadManyData, EmailTemplatesReadManyErrors, EmailTemplatesReadManyResponses, EviInstallLinkStartData, EviInstallLinkStartErrors, EviOAuthCallbackData, EviOAuthCallbackErrors, FanApplicationsCreateData, FanApplicationsCreateErrors, FanApplicationsCreateResponses, FanApplicationsReadByEmailData, FanApplicationsReadByEmailErrors, FanApplicationsReadByEmailResponses, FanBadgesMeData, FanBadgesMeErrors, FanBadgesMeResponses, FanEventsReadData, FanEventsReadErrors, FanEventsReadManyData, FanEventsReadManyErrors, FanEventsReadManyResponses, FanEventsReadResponses, FanMissionsCreateData, FanMissionsCreateErrors, FanMissionsCreateManualData, FanMissionsCreateManualErrors, FanMissionsCreateManualResponses, FanMissionsCreateResponses, FanMissionsDeleteData, FanMissionsDeleteErrors, FanMissionsDeleteManualData, FanMissionsDeleteManualErrors, FanMissionsDeleteManualResponses, FanMissionsDeleteResponses, FanMissionsDismissRejectionData, FanMissionsDismissRejectionErrors, FanMissionsDismissRejectionResponses, FanMissionsManifestManyData, FanMissionsManifestManyErrors, FanMissionsManifestManyResponses, FanMissionsStartTestimonialData, FanMissionsStartTestimonialErrors, FanMissionsStartTestimonialResponses, FanMissionsSubmissionsManyData, FanMissionsSubmissionsManyErrors, FanMissionsSubmissionsManyResponses, FanMissionsSyncManyData, FanMissionsSyncManyErrors, FanMissionsSyncManyResponses, FanMissionsTestimonialAnswerData, FanMissionsTestimonialAnswerErrors, FanMissionsTestimonialAnswerResponses, FanMissionsUpdateData, FanMissionsUpdateErrors, FanMissionsUpdateManualData, FanMissionsUpdateManualErrors, FanMissionsUpdateManualResponses, FanMissionsUpdateResponses, FanPointsLedgerData, FanPointsLedgerErrors, FanPointsLedgerResponses, FanRewardsApproveData, FanRewardsApproveErrors, FanRewardsApproveResponses, FanRewardsMeData, FanRewardsMeErrors, FanRewardsMeResponses, FanRewardsReadManyData, FanRewardsReadManyErrors, FanRewardsReadManyResponses, FanRewardsRejectData, FanRewardsRejectErrors, FanRewardsRejectResponses, FanUserEnrichmentsDeleteData, FanUserEnrichmentsDeleteErrors, FanUserEnrichmentsDeleteResponses, FanUserEnrichmentsIngestData, FanUserEnrichmentsIngestErrors, FanUserEnrichmentsIngestResponses, FanUserEnrichmentsUpdateData, FanUserEnrichmentsUpdateErrors, FanUserEnrichmentsUpdateResponses, FanUsersAdjustPointsData, FanUsersAdjustPointsErrors, FanUsersAdjustPointsResponses, FanUsersAdvocateStatusChangeData, FanUsersAdvocateStatusChangeErrors, FanUsersAdvocateStatusChangeResponses, FanUsersAnalyticsData, FanUsersAnalyticsErrors, FanUsersAnalyticsResponses, FanUsersBanData, FanUsersBanErrors, FanUsersBanResponses, FanUsersBulkBanManyData, FanUsersBulkBanManyErrors, FanUsersBulkBanManyResponses, FanUsersBulkEraseManyData, FanUsersBulkEraseManyErrors, FanUsersBulkEraseManyResponses, FanUsersBulkGdprDeleteManyData, FanUsersBulkGdprDeleteManyErrors, FanUsersBulkGdprDeleteManyResponses, FanUsersBulkImportData, FanUsersBulkImportErrors, FanUsersBulkImportResponses, FanUsersBulkUnbanManyData, FanUsersBulkUnbanManyErrors, FanUsersBulkUnbanManyResponses, FanUsersCheckBanStatusData, FanUsersCheckBanStatusErrors, FanUsersCheckBanStatusResponses, FanUsersCreateData, FanUsersCreateErrors, FanUsersCreateResponses, FanUsersDirectoryManyData, FanUsersDirectoryManyErrors, FanUsersDirectoryManyResponses, FanUsersEmbedData, FanUsersEmbedErrors, FanUsersEmbedResponses, FanUsersFanUserEnrichmentsCreateData, FanUsersFanUserEnrichmentsCreateErrors, FanUsersFanUserEnrichmentsCreateResponses, FanUsersFanUserEnrichmentsReadManyData, FanUsersFanUserEnrichmentsReadManyErrors, FanUsersFanUserEnrichmentsReadManyResponses, FanUsersFanUserEnrichmentsRefreshData, FanUsersFanUserEnrichmentsRefreshErrors, FanUsersFanUserEnrichmentsRefreshResponses, FanUsersFanUsersBulkCreateData, FanUsersFanUsersBulkCreateErrors, FanUsersFanUsersBulkCreateResponses, FanUsersFanUserUuidActivityData, FanUsersFanUserUuidActivityErrors, FanUsersFanUserUuidActivityResponses, FanUsersGdprDeleteData, FanUsersGdprDeleteErrors, FanUsersGdprDeleteResponses, FanUsersJoinSegmentData, FanUsersJoinSegmentErrors, FanUsersJoinSegmentResponses, FanUsersLeaderboardData, FanUsersLeaderboardErrors, FanUsersLeaderboardResponses, FanUsersLiftBanBlockData, FanUsersLiftBanBlockErrors, FanUsersLiftBanBlockResponses, FanUsersManifestManyData, FanUsersManifestManyErrors, FanUsersManifestManyResponses, FanUsersMeData, FanUsersMeErrors, FanUsersMembersTableFilterOptionsManyData, FanUsersMembersTableFilterOptionsManyErrors, FanUsersMembersTableFilterOptionsManyResponses, FanUsersMembersTableManyData, FanUsersMembersTableManyErrors, FanUsersMembersTableManyResponses, FanUsersMeResponses, FanUsersMergeData, FanUsersMergeErrors, FanUsersMergeResponses, FanUsersMeUpdateData, FanUsersMeUpdateErrors, FanUsersMeUpdateResponses, FanUsersNoteCreateData, FanUsersNoteCreateErrors, FanUsersNoteCreateResponses, FanUsersNotesReadManyData, FanUsersNotesReadManyErrors, FanUsersNotesReadManyResponses, FanUsersProfileData, FanUsersProfileErrors, FanUsersProfileResponses, FanUsersReadManyData, FanUsersReadManyErrors, FanUsersReadManyResponses, FanUsersReferenceOptInManyData, FanUsersReferenceOptInManyErrors, FanUsersReferenceOptInManyResponses, FanUsersRegisterData, FanUsersRegisterErrors, FanUsersRegisterResponses, FanUsersResolvedFieldsData, FanUsersResolvedFieldsErrors, FanUsersResolvedFieldsResponses, FanUsersSetCustomFieldData, FanUsersSetCustomFieldErrors, FanUsersSetCustomFieldResponses, FanUsersSyncManyData, FanUsersSyncManyErrors, FanUsersSyncManyResponses, FanUsersTokenData, FanUsersTokenErrors, FanUsersTokenResponses, FanUsersUnbanData, FanUsersUnbanErrors, FanUsersUnbanResponses, FanUsersUpdateData, FanUsersUpdateErrors, FanUsersUpdateResponses, FeaturedFanUsersCreateData, FeaturedFanUsersCreateErrors, FeaturedFanUsersCreateResponses, FeaturedFanUsersDeleteData, FeaturedFanUsersDeleteErrors, FeaturedFanUsersDeleteResponses, FeaturedFanUsersReadManyData, FeaturedFanUsersReadManyErrors, FeaturedFanUsersReadManyResponses, FilesImageProxyData, FilesImageProxyErrors, FilesImageProxyResponses, FilesPresignedUrlData, FilesPresignedUrlErrors, FilesPresignedUrlResponses, ForumGroupsGroupForumUsersReadManyData, ForumGroupsGroupForumUsersReadManyErrors, ForumGroupsGroupForumUsersReadManyResponses, ForumGroupsJoinData, ForumGroupsJoinErrors, ForumGroupsJoinResponses, ForumGroupsLeaveData, ForumGroupsLeaveErrors, ForumGroupsLeaveResponses, ForumGroupsLinkGroupsData, ForumGroupsLinkGroupsErrors, ForumGroupsLinkGroupsResponses, ForumGroupsMarkSeenData, ForumGroupsMarkSeenErrors, ForumGroupsMarkSeenResponses, ForumGroupsPostCreateData, ForumGroupsPostCreateErrors, ForumGroupsPostCreateResponses, ForumGroupsPostsReadManyData, ForumGroupsPostsReadManyErrors, ForumGroupsPostsReadManyResponses, ForumGroupsReadData, ForumGroupsReadErrors, ForumGroupsReadManyData, ForumGroupsReadManyErrors, ForumGroupsReadManyResponses, ForumGroupsReadResponses, ForumGroupsVisitsManyData, ForumGroupsVisitsManyErrors, ForumGroupsVisitsManyResponses, ForumUsersActivityData, ForumUsersActivityErrors, ForumUsersActivityResponses, ForumUsersForumGroupsReadManyData, ForumUsersForumGroupsReadManyErrors, ForumUsersForumGroupsReadManyResponses, ForumUsersInitData, ForumUsersInitErrors, ForumUsersInitResponses, ForumUsersMeData, ForumUsersMeErrors, ForumUsersMeResponses, ForumUsersReadData, ForumUsersReadErrors, ForumUsersReadResponses, ForumUsersSearchManyData, ForumUsersSearchManyErrors, ForumUsersSearchManyResponses, GongsAdvocacyClipsSearchManyData, GongsAdvocacyClipsSearchManyErrors, GongsAdvocacyClipsSearchManyResponses, GongsTrimVideoData, GongsTrimVideoErrors, GongsTrimVideoResponses, GroupsAddMatchingData, GroupsAddMatchingErrors, GroupsAddMatchingResponses, GroupsAddMembersData, GroupsAddMembersErrors, GroupsAddMembersResponses, GroupsConditionsSchemaData, GroupsConditionsSchemaErrors, GroupsConditionsSchemaResponses, GroupsCreateData, GroupsCreateErrors, GroupsCreateResponses, GroupsDegradedData, GroupsDegradedErrors, GroupsDegradedResponses, GroupsDeleteData, GroupsDeleteErrors, GroupsDeleteResponses, GroupsEstimatedReachData, GroupsEstimatedReachErrors, GroupsEstimatedReachResponses, GroupsFanUsersReadManyData, GroupsFanUsersReadManyErrors, GroupsFanUsersReadManyResponses, GroupsGenerateConditionsData, GroupsGenerateConditionsErrors, GroupsGenerateConditionsResponses, GroupsReadData, GroupsReadErrors, GroupsReadManyData, GroupsReadManyErrors, GroupsReadManyResponses, GroupsReadResponses, GroupsReconcileData, GroupsReconcileErrors, GroupsReconcileResponses, GroupsRemoveManualMemberData, GroupsRemoveManualMemberErrors, GroupsRemoveManualMemberResponses, GroupsRemoveMembersData, GroupsRemoveMembersErrors, GroupsRemoveMembersResponses, GroupsUpdateData, GroupsUpdateErrors, GroupsUpdateResponses, HubspotDisconnectData, HubspotDisconnectErrors, HubspotDisconnectResponses, HubspotOauthAuthorizeData, HubspotOauthAuthorizeErrors, HubspotOauthAuthorizeResponses, HubspotOauthCallbackData, HubspotOauthCallbackErrors, HubspotOauthCompleteData, HubspotOauthCompleteErrors, HubspotOauthCompleteResponses, HubspotWebhookProxyData, HubspotWebhookProxyErrors, HubspotWebhookProxyResponses, ImpersonationSessionsCreateData, ImpersonationSessionsCreateErrors, ImpersonationSessionsCreateResponses, IntegrationMapsAccountFieldsManyData, IntegrationMapsAccountFieldsManyErrors, IntegrationMapsAccountFieldsManyResponses, IntegrationMapsAddAliasesData, IntegrationMapsAddAliasesErrors, IntegrationMapsAddAliasesResponses, IntegrationMapsAllFieldsManyData, IntegrationMapsAllFieldsManyErrors, IntegrationMapsAllFieldsManyResponses, IntegrationMapsCreateData, IntegrationMapsCreateErrors, IntegrationMapsCreateResponses, IntegrationMapsDeleteData, IntegrationMapsDeleteErrors, IntegrationMapsDeleteResponses, IntegrationMapsPromoteAliasData, IntegrationMapsPromoteAliasErrors, IntegrationMapsPromoteAliasResponses, IntegrationMapsReadManyData, IntegrationMapsReadManyErrors, IntegrationMapsReadManyResponses, IntegrationMapsRemoveAliasesData, IntegrationMapsRemoveAliasesErrors, IntegrationMapsRemoveAliasesResponses, IntegrationMapsUpdateData, IntegrationMapsUpdateErrors, IntegrationMapsUpdateResponses, IntegrationSourcesConfigureImportData, IntegrationSourcesConfigureImportErrors, IntegrationSourcesConfigureImportResponses, IntegrationSourcesCreateData, IntegrationSourcesCreateErrors, IntegrationSourcesCreateResponses, IntegrationSourcesDeleteData, IntegrationSourcesDeleteErrors, IntegrationSourcesDeleteResponses, IntegrationSourcesImportData, IntegrationSourcesImportErrors, IntegrationSourcesImportResponses, IntegrationSourcesReadManyData, IntegrationSourcesReadManyErrors, IntegrationSourcesReadManyResponses, IntegrationSourcesSalesforceOpportunitySweepData, IntegrationSourcesSalesforceOpportunitySweepErrors, IntegrationSourcesSalesforceOpportunitySweepResponses, IntegrationSourcesSetSyncDirectionData, IntegrationSourcesSetSyncDirectionErrors, IntegrationSourcesSetSyncDirectionResponses, IntegrationSourcesUpdateData, IntegrationSourcesUpdateErrors, IntegrationSourcesUpdateResponses, InternalsCheckInvitationData, InternalsCheckInvitationErrors, InternalsCheckInvitationResponses, InternalsDeriveFanUsersData, InternalsDeriveFanUsersErrors, InternalsDeriveFanUsersResponses, InternalsPostLoginProvisionData, InternalsPostLoginProvisionErrors, InternalsPostLoginProvisionResponses, JobsCreateData, JobsCreateErrors, JobsCreateResponses, LegacyAdvocatesByMissionReadData, LegacyAdvocatesByMissionReadErrors, LegacyAdvocatesByMissionReadResponses, LegacyBrandConfigReadData, LegacyBrandConfigReadErrors, LegacyBrandConfigReadResponses, LegacyOpportunityByIdReadData, LegacyOpportunityByIdReadErrors, LegacyOpportunityByIdReadResponses, MailgunEventsWebhookData, MailgunEventsWebhookErrors, MailgunEventsWebhookResponses, MentionsNotifyData, MentionsNotifyErrors, MentionsNotifyResponses, MjmlEmailTemplatesCreateData, MjmlEmailTemplatesCreateErrors, MjmlEmailTemplatesCreateResponses, MjmlEmailTemplatesDeleteData, MjmlEmailTemplatesDeleteErrors, MjmlEmailTemplatesDeleteResponses, MjmlEmailTemplatesPreflightData, MjmlEmailTemplatesPreflightErrors, MjmlEmailTemplatesPreflightResponses, MjmlEmailTemplatesPreviewData, MjmlEmailTemplatesPreviewErrors, MjmlEmailTemplatesPreviewResponses, MjmlEmailTemplatesReadManyData, MjmlEmailTemplatesReadManyErrors, MjmlEmailTemplatesReadManyResponses, MjmlEmailTemplatesRuleSurfaceData, MjmlEmailTemplatesRuleSurfaceErrors, MjmlEmailTemplatesRuleSurfaceResponses, MjmlEmailTemplatesUpdateData, MjmlEmailTemplatesUpdateErrors, MjmlEmailTemplatesUpdateResponses, NewRelicsQueryData, NewRelicsQueryErrors, NewRelicsQueryResponses, NotesDeleteData, NotesDeleteErrors, NotesDeleteResponses, NotificationsNotificationLogsReadManyData, NotificationsNotificationLogsReadManyErrors, NotificationsNotificationLogsReadManyResponses, NotificationsReadManyData, NotificationsReadManyErrors, NotificationsReadManyResponses, NotificationsRetriggerData, NotificationsRetriggerErrors, NotificationsRetriggerResponses, NotificationsRetriggerRewardNotificationsData, NotificationsRetriggerRewardNotificationsErrors, NotificationsRetriggerRewardNotificationsResponses, NotificationsSendData, NotificationsSendErrors, NotificationsSendResponses, NotificationsWeeklyDigestData, NotificationsWeeklyDigestErrors, NotificationsWeeklyDigestReadData, NotificationsWeeklyDigestReadErrors, NotificationsWeeklyDigestReadResponses, NotificationsWeeklyDigestReplaceData, NotificationsWeeklyDigestReplaceErrors, NotificationsWeeklyDigestReplaceResponses, NotificationsWeeklyDigestResponses, OembedsReadData, OembedsReadErrors, OembedsReadResponses, OmniEmbedUrlData, OmniEmbedUrlErrors, OmniEmbedUrlResponses, OmniKpiTileData, OmniKpiTileErrors, OmniKpiTileResponses, OmniProvisionData, OmniProvisionErrors, OmniProvisionResponses, OpportunitiesBrandReferenceRequestCreateData, OpportunitiesBrandReferenceRequestCreateErrors, OpportunitiesBrandReferenceRequestCreateResponses, OpportunitiesBrandReferenceRequestsManualManyData, OpportunitiesBrandReferenceRequestsManualManyErrors, OpportunitiesBrandReferenceRequestsManualManyResponses, OpportunitiesCreateData, OpportunitiesCreateErrors, OpportunitiesCreateResponses, OpportunitiesCursorManyData, OpportunitiesCursorManyErrors, OpportunitiesCursorManyResponses, OpportunitiesDeleteData, OpportunitiesDeleteErrors, OpportunitiesDeleteResponses, OpportunitiesManifestManyData, OpportunitiesManifestManyErrors, OpportunitiesManifestManyResponses, OpportunitiesReadData, OpportunitiesReadErrors, OpportunitiesReadManyData, OpportunitiesReadManyErrors, OpportunitiesReadManyResponses, OpportunitiesReadResponses, OpportunitiesSyncManyData, OpportunitiesSyncManyErrors, OpportunitiesSyncManyResponses, OpportunitiesUpdateData, OpportunitiesUpdateErrors, OpportunitiesUpdateResponses, OtpsSendData, OtpsSendErrors, OtpsSendResponses, OtpsVerifyData, OtpsVerifyErrors, OtpsVerifyResponses, PlatformAlertDestinationsCreateData, PlatformAlertDestinationsCreateErrors, PlatformAlertDestinationsCreateResponses, PlatformAlertDestinationsDeleteData, PlatformAlertDestinationsDeleteErrors, PlatformAlertDestinationsDeleteResponses, PlatformAlertDestinationsReadManyData, PlatformAlertDestinationsReadManyErrors, PlatformAlertDestinationsReadManyResponses, PlatformAlertDestinationsUpdateData, PlatformAlertDestinationsUpdateErrors, PlatformAlertDestinationsUpdateResponses, PlatformAlertIncidentsAcknowledgeData, PlatformAlertIncidentsAcknowledgeErrors, PlatformAlertIncidentsAcknowledgeResponses, PlatformAlertIncidentsAssignData, PlatformAlertIncidentsAssignErrors, PlatformAlertIncidentsAssignResponses, PlatformAlertIncidentsNoteCreateData, PlatformAlertIncidentsNoteCreateErrors, PlatformAlertIncidentsNoteCreateResponses, PlatformAlertIncidentsReadData, PlatformAlertIncidentsReadErrors, PlatformAlertIncidentsReadManyData, PlatformAlertIncidentsReadManyErrors, PlatformAlertIncidentsReadManyResponses, PlatformAlertIncidentsReadResponses, PlatformAlertIncidentsResolveData, PlatformAlertIncidentsResolveErrors, PlatformAlertIncidentsResolveResponses, PlatformAlertIncidentsTimelineEntriesReadManyData, PlatformAlertIncidentsTimelineEntriesReadManyErrors, PlatformAlertIncidentsTimelineEntriesReadManyResponses, PlatformAlertRulesConditionsSchemaData, PlatformAlertRulesConditionsSchemaErrors, PlatformAlertRulesConditionsSchemaResponses, PlatformAlertRulesCreateData, PlatformAlertRulesCreateErrors, PlatformAlertRulesCreateResponses, PlatformAlertRulesDeleteData, PlatformAlertRulesDeleteErrors, PlatformAlertRulesDeleteResponses, PlatformAlertRulesDryRunData, PlatformAlertRulesDryRunDraftData, PlatformAlertRulesDryRunDraftErrors, PlatformAlertRulesDryRunDraftResponses, PlatformAlertRulesDryRunErrors, PlatformAlertRulesDryRunResponses, PlatformAlertRulesModelConditionsSchemaData, PlatformAlertRulesModelConditionsSchemaErrors, PlatformAlertRulesModelConditionsSchemaResponses, PlatformAlertRulesReadData, PlatformAlertRulesReadErrors, PlatformAlertRulesReadManyData, PlatformAlertRulesReadManyErrors, PlatformAlertRulesReadManyResponses, PlatformAlertRulesReadResponses, PlatformAlertRulesUpdateData, PlatformAlertRulesUpdateErrors, PlatformAlertRulesUpdateResponses, PostsCommentCreateData, PostsCommentCreateErrors, PostsCommentCreateResponses, PostsCommentsReadManyData, PostsCommentsReadManyErrors, PostsCommentsReadManyResponses, PostsDeleteData, PostsDeleteErrors, PostsDeleteResponses, PostsLikeData, PostsLikeErrors, PostsLikeResponses, PostsMoveToGroupData, PostsMoveToGroupErrors, PostsMoveToGroupResponses, PostsPinData, PostsPinErrors, PostsPinResponses, PostsReadData, PostsReadErrors, PostsReadManyData, PostsReadManyErrors, PostsReadManyResponses, PostsReadResponses, PostsSubscribeData, PostsSubscribeErrors, PostsSubscribeResponses, PostsSubscriptionsManyData, PostsSubscriptionsManyErrors, PostsSubscriptionsManyResponses, PostsUnlikeData, PostsUnlikeErrors, PostsUnlikeResponses, PostsUnsubscribeData, PostsUnsubscribeErrors, PostsUnsubscribeResponses, PostsUnvoteData, PostsUnvoteErrors, PostsUnvoteResponses, PostsUpdateData, PostsUpdateErrors, PostsUpdateResponses, PostsVoteData, PostsVoteErrors, PostsVoteResponses, PrivacyRequestsDeleteData, PrivacyRequestsDeleteErrors, PrivacyRequestsDeleteResponses, PrivacyRequestsLookupData, PrivacyRequestsLookupErrors, PrivacyRequestsLookupResponses, PromptsCreateData, PromptsCreateErrors, PromptsCreateResponses, PromptsReadManyData, PromptsReadManyErrors, PromptsReadManyResponses, PromptsUpdateData, PromptsUpdateErrors, PromptsUpdateResponses, RainfocusConnectionUpsertData, RainfocusConnectionUpsertErrors, RainfocusConnectionUpsertResponses, RainfocusInsiderStatusData, RainfocusInsiderStatusErrors, RainfocusInsiderStatusResponses, ReferenceOptInsImportData, ReferenceOptInsImportErrors, ReferenceOptInsImportResponses, ReferralsCreateData, ReferralsCreateErrors, ReferralsCreateResponses, ReferralsMineManyData, ReferralsMineManyErrors, ReferralsMineManyResponses, SalesforceOpportunityVisibilityReadData, SalesforceOpportunityVisibilityReadErrors, SalesforceOpportunityVisibilityReadResponses, SalesforcePicklistValuesReadData, SalesforcePicklistValuesReadErrors, SalesforcePicklistValuesReadResponses, SavedViewsCreateData, SavedViewsCreateErrors, SavedViewsCreateResponses, SavedViewsDeleteData, SavedViewsDeleteErrors, SavedViewsDeleteResponses, SavedViewsReadManyData, SavedViewsReadManyErrors, SavedViewsReadManyResponses, SavedViewsUpdateData, SavedViewsUpdateErrors, SavedViewsUpdateResponses, SignupGuardsSignupGuardsCheckData, SignupGuardsSignupGuardsCheckErrors, SignupGuardsSignupGuardsCheckResponses, SlackEviInstallLinkCreateData, SlackEviInstallLinkCreateErrors, SlackEviInstallLinkCreateResponses, SlackEviInstallLinkRevokeData, SlackEviInstallLinkRevokeErrors, SlackEviInstallLinkRevokeResponses, SlackInstallStartData, SlackInstallStartErrors, SlackInstallStartResponses, SlackOAuthCallbackData, SlackOAuthCallbackErrors, SlacksChannelsListData, SlacksChannelsListErrors, SlacksChannelsListResponses, SlacksChannelsReadManyData, SlacksChannelsReadManyErrors, SlacksChannelsReadManyResponses, SlacksStatusData, SlacksStatusErrors, SlacksStatusResponses, UnsubscribeEmailOneClickData, UnsubscribeEmailOneClickErrors, UnsubscribeEmailOneClickResponses, UnsubscribeEmailVerifyData, UnsubscribeEmailVerifyErrors, UnsubscribeEmailVerifyResponses, UserEvidencesProxyData, UserEvidencesProxyErrors, UserEvidencesProxyResponses, UsersMeData, UsersMeErrors, UsersMeResponses, UsersReadManyData, UsersReadManyErrors, UsersReadManyResponses, VideoRendersProgressData, VideoRendersProgressErrors, VideoRendersProgressResponses, VideoRendersStartData, VideoRendersStartErrors, VideoRendersStartResponses, WebexIntegrationEnableData, WebexIntegrationEnableErrors, WebexIntegrationEnableResponses, WebhookSubscriptionsCreateData, WebhookSubscriptionsCreateErrors, WebhookSubscriptionsCreateResponses, WebhookSubscriptionsDeleteData, WebhookSubscriptionsDeleteErrors, WebhookSubscriptionsDeleteResponses, WebhookSubscriptionsInfoData, WebhookSubscriptionsInfoErrors, WebhookSubscriptionsInfoResponses, WebhookSubscriptionsReadManyData, WebhookSubscriptionsReadManyErrors, WebhookSubscriptionsReadManyResponses, WebhookSubscriptionsReplayData, WebhookSubscriptionsReplayErrors, WebhookSubscriptionsReplayResponses, WebhookSubscriptionsUpdateData, WebhookSubscriptionsUpdateErrors, WebhookSubscriptionsUpdateResponses, WorkflowsCreateData, WorkflowsCreateErrors, WorkflowsCreateResponses, WorkflowsExecuteData, WorkflowsExecuteErrors, WorkflowsExecuteResponses, WorkflowsReadByWorkflowIdData, WorkflowsReadByWorkflowIdErrors, WorkflowsReadByWorkflowIdResponses, WorkflowsReadData, WorkflowsReadErrors, WorkflowsReadResponses, WorkflowsUpdateData, WorkflowsUpdateErrors, WorkflowsUpdateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Sends a password reset email to the user with a secure token link.
 */
export const authsRequestPasswordReset = <ThrowOnError extends boolean = false>(options: Options<AuthsRequestPasswordResetData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthsRequestPasswordResetResponses, AuthsRequestPasswordResetErrors, ThrowOnError>({
        url: '/auth/requestPasswordReset',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resets the user password using a valid reset token from email.
 */
export const authsResetPassword = <ThrowOnError extends boolean = false>(options: Options<AuthsResetPasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthsResetPasswordResponses, AuthsResetPasswordErrors, ThrowOnError>({
        url: '/auth/resetPassword',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Receive an Ably chat message batch
 *
 * Ably batch webhook, authenticated by the x-ably-signature HMAC over the raw body.
 */
export const chatWebhook = <ThrowOnError extends boolean = false>(options: Options<ChatWebhookData, ThrowOnError>) => {
    return (options.client ?? client).post<ChatWebhookResponses, ChatWebhookErrors, ThrowOnError>({
        url: '/api/v2/chat/webhook',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Complete a Slack app install
 *
 * Slack OAuth redirect target for the legacy Slack app. Always answers with a browser redirect.
 */
export const slackOAuthCallback = <ThrowOnError extends boolean = false>(options?: Options<SlackOAuthCallbackData, ThrowOnError>) => {
    return (options?.client ?? client).get<unknown, SlackOAuthCallbackErrors, ThrowOnError>({
        url: '/api/v2/slack/oauth/callback',
        ...options
    });
};

/**
 * Complete an Evi Slack app install
 *
 * Slack OAuth redirect target for the Evi app. Always answers with a browser redirect.
 */
export const eviOAuthCallback = <ThrowOnError extends boolean = false>(options?: Options<EviOAuthCallbackData, ThrowOnError>) => {
    return (options?.client ?? client).get<unknown, EviOAuthCallbackErrors, ThrowOnError>({
        url: '/api/v2/slack/evi/oauth/callback',
        ...options
    });
};

/**
 * Open a durable Evi install link
 *
 * Resolves a durable install-link token and redirects the browser into Slack OAuth.
 */
export const eviInstallLinkStart = <ThrowOnError extends boolean = false>(options: Options<EviInstallLinkStartData, ThrowOnError>) => {
    return (options.client ?? client).get<unknown, EviInstallLinkStartErrors, ThrowOnError>({
        url: '/api/v2/slack/evi/install/{token}',
        ...options
    });
};

/**
 * Receive Auth0 log-stream connection lifecycle events
 *
 * Auth0 log-stream webhook, authenticated by the shared Authorization secret. Answers 500 when every connection in the batch failed, so Auth0 redelivers.
 */
export const auth0ConnectionLifecycleWebhook = <ThrowOnError extends boolean = false>(options: Options<Auth0ConnectionLifecycleWebhookData, ThrowOnError>) => {
    return (options.client ?? client).post<Auth0ConnectionLifecycleWebhookResponses, Auth0ConnectionLifecycleWebhookErrors, ThrowOnError>({
        url: '/api/v2/integrations/auth0/connectionLifecycleWebhook',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Receive a Mailgun event webhook
 *
 * Mailgun delivery-event webhook, authenticated by the payload signature. 200 and 406 end delivery; every other status (401, 413, 503) is retried by Mailgun.
 */
export const mailgunEventsWebhook = <ThrowOnError extends boolean = false>(options: Options<MailgunEventsWebhookData, ThrowOnError>) => {
    return (options.client ?? client).post<MailgunEventsWebhookResponses, MailgunEventsWebhookErrors, ThrowOnError>({
        url: '/api/v2/integrations/mailgun/eventsWebhook',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Receive a HubSpot install approval
 *
 * HubSpot OAuth redirect target. Takes the single-use install state minted by the authorize endpoint and parks the approval behind a one-time handle, then redirects to Brand → Integrations with it. Nothing is exchanged or connected here: the signed-in admin who started the install finishes it through POST /oauth/complete.
 */
export const hubspotOauthCallback = <ThrowOnError extends boolean = false>(options?: Options<HubspotOauthCallbackData, ThrowOnError>) => {
    return (options?.client ?? client).get<unknown, HubspotOauthCallbackErrors, ThrowOnError>({
        url: '/api/v2/integrations/hubspot/oauth/callback',
        ...options
    });
};

/**
 * Write a webhook delivery back to HubSpot
 *
 * Internal delivery target for HubSpot webhook subscriptions. Takes our signed webhook body, writes the record's UserEvidence fields to its HubSpot contact or deal, and answers 204 when there is nothing to write.
 */
export const hubspotWebhookProxy = <ThrowOnError extends boolean = false>(options: Options<HubspotWebhookProxyData, ThrowOnError>) => {
    return (options.client ?? client).post<HubspotWebhookProxyResponses, HubspotWebhookProxyErrors, ThrowOnError>({
        url: '/api/v2/integrations/hubspot/webhookProxy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Check if a pending invitation exists for an email
 *
 * Called by the Auth0 Pre User Registration Action to gate-keep signups. Protected by internal service token.
 */
export const internalsCheckInvitation = <ThrowOnError extends boolean = false>(options: Options<InternalsCheckInvitationData, ThrowOnError>) => {
    return (options.client ?? client).get<InternalsCheckInvitationResponses, InternalsCheckInvitationErrors, ThrowOnError>({
        url: '/api/internal/checkInvitation',
        ...options
    });
};

/**
 * Provision user and build claims for Auth0 Post-Login Action
 *
 * Called by the Auth0 Post-Login Action to look up or create a BrandUser and return JWT claims. Protected by internal service token, not JWT.
 */
export const internalsPostLoginProvision = <ThrowOnError extends boolean = false>(options: Options<InternalsPostLoginProvisionData, ThrowOnError>) => {
    return (options.client ?? client).post<InternalsPostLoginProvisionResponses, InternalsPostLoginProvisionErrors, ThrowOnError>({
        url: '/api/internal/postLoginProvision',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Evaluate signup guards for a brand + email (no side effects)
 *
 * Evaluates configured BrandSignupRule rules for a brand and email. Returns the first non-allow decision, or allow if no rules deny. No side effects — callers are responsible for any user / Auth0 mutations based on the result.
 */
export const signupGuardsSignupGuardsCheck = <ThrowOnError extends boolean = false>(options: Options<SignupGuardsSignupGuardsCheckData, ThrowOnError>) => {
    return (options.client ?? client).post<SignupGuardsSignupGuardsCheckResponses, SignupGuardsSignupGuardsCheckErrors, ThrowOnError>({
        url: '/api/internal/signupGuardsCheck',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk-create fan users from a Salesforce/Workato contact import. Idempotent upsert by email; provisions ForumUser + public-group enrollment. Does NOT create Auth0 users or reconcile dynamic segments (handled separately). Internal service-to-service only.
 */
export const fanUsersFanUsersBulkCreate = <ThrowOnError extends boolean = false>(options: Options<FanUsersFanUsersBulkCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersFanUsersBulkCreateResponses, FanUsersFanUsersBulkCreateErrors, ThrowOnError>({
        url: '/api/internal/fanUsersBulkCreate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Re-derive derived integration maps for fans whose enrichment inputs changed
 *
 * Called by legacy-api after its raw-SQL writes (Workato enrichment sync, /create-enrichment, profile and address edits), which bypass the Prisma hooks that normally schedule derivation. Protected by internal service token, not JWT.
 */
export const internalsDeriveFanUsers = <ThrowOnError extends boolean = false>(options: Options<InternalsDeriveFanUsersData, ThrowOnError>) => {
    return (options.client ?? client).post<InternalsDeriveFanUsersResponses, InternalsDeriveFanUsersErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Internal-Service-Token',
                type: 'apiKey'
            }
        ],
        url: '/api/internal/deriveFanUsers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Tell RainFocus whether an address belongs to an active Cisco Insider member
 *
 * Called by RainFocus when an attendee registers for Cisco Live, and for ad-hoc checks. Answers "Yes" for an active Cisco Insider member and "No" otherwise; any failure on our side is a 5xx so RainFocus's retry can recover, never a "No". Restricted to RainFocus's egress IPs plus the key in x-api-key.
 */
export const rainfocusInsiderStatus = <ThrowOnError extends boolean = false>(options: Options<RainfocusInsiderStatusData, ThrowOnError>) => {
    return (options.client ?? client).post<RainfocusInsiderStatusResponses, RainfocusInsiderStatusErrors, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/integrations/rainfocus/insider-status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Returns oEmbed 1.0 JSON with iframe snippet containing {{email}} and {{token}} placeholders
 */
export const oembedsRead = <ThrowOnError extends boolean = false>(options: Options<OembedsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<OembedsReadResponses, OembedsReadErrors, ThrowOnError>({
        url: '/api/v2/oembed',
        ...options
    });
};

/**
 * Verifies a signed unsubscribe token without mutating unsubscribe state.
 */
export const unsubscribeEmailVerify = <ThrowOnError extends boolean = false>(options: Options<UnsubscribeEmailVerifyData, ThrowOnError>) => {
    return (options.client ?? client).get<UnsubscribeEmailVerifyResponses, UnsubscribeEmailVerifyErrors, ThrowOnError>({
        url: '/api/v2/unsubscribe/{uuid}',
        ...options
    });
};

/**
 * Records a one-click email unsubscribe request from a signed unsubscribe token.
 */
export const unsubscribeEmailOneClick = <ThrowOnError extends boolean = false>(options: Options<UnsubscribeEmailOneClickData, ThrowOnError>) => {
    return (options.client ?? client).post<UnsubscribeEmailOneClickResponses, UnsubscribeEmailOneClickErrors, ThrowOnError>({
        url: '/api/v2/unsubscribe/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update activity email preferences using an email preferences link
 *
 * Updates an existing EmailNotificationPreference.
 */
export const emailNotificationPreferencesUpdatePreferences = <ThrowOnError extends boolean = false>(options: Options<EmailNotificationPreferencesUpdatePreferencesData, ThrowOnError>) => {
    return (options.client ?? client).patch<EmailNotificationPreferencesUpdatePreferencesResponses, EmailNotificationPreferencesUpdatePreferencesErrors, ThrowOnError>({
        url: '/api/v2/emailNotificationPreference/preferences',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Read email subscriptions using an email preferences link
 *
 * Retrieves an existing EmailSuppression.
 */
export const emailSuppressionsReadPreferences = <ThrowOnError extends boolean = false>(options?: Options<EmailSuppressionsReadPreferencesData, ThrowOnError>) => {
    return (options?.client ?? client).get<EmailSuppressionsReadPreferencesResponses, EmailSuppressionsReadPreferencesErrors, ThrowOnError>({
        url: '/api/v2/emailSuppression/preferences',
        ...options
    });
};

/**
 * Update email subscriptions using an email preferences link
 *
 * Updates an existing EmailSuppression.
 */
export const emailSuppressionsUpdatePreferences = <ThrowOnError extends boolean = false>(options: Options<EmailSuppressionsUpdatePreferencesData, ThrowOnError>) => {
    return (options.client ?? client).patch<EmailSuppressionsUpdatePreferencesResponses, EmailSuppressionsUpdatePreferencesErrors, ThrowOnError>({
        url: '/api/v2/emailSuppression/preferences',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Returns the canonical system field spec grouped by targetModel (e.g. the SFDC dynamic reference request form fields)
 */
export const customFieldDefinitionsSystem = <ThrowOnError extends boolean = false>(options?: Options<CustomFieldDefinitionsSystemData, ThrowOnError>) => {
    return (options?.client ?? client).get<CustomFieldDefinitionsSystemResponses, CustomFieldDefinitionsSystemErrors, ThrowOnError>({
        url: '/api/v2/customFieldDefinitions/system',
        ...options
    });
};

/**
 * Start an embed session for a community member. Called server-to-server by the brand’s community platform with an embed-scoped brand API token; returns iframe markup carrying a short-lived session.
 */
export const fanUsersEmbed = <ThrowOnError extends boolean = false>(options: Options<FanUsersEmbedData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersEmbedResponses, FanUsersEmbedErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/embed',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Legacy managed-package compat: 200-noop for the deprecated manager-info webhook.
 *
 * Performs managerInfoWebhook action on BrandReferenceRequest.
 */
export const brandReferenceRequestsManagerInfoWebhook = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsManagerInfoWebhookData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsManagerInfoWebhookResponses, BrandReferenceRequestsManagerInfoWebhookErrors, ThrowOnError>({
        url: '/api/v1/salesforce/managerInfoWebhook',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Search Gong advocacy clips
 *
 * Perform semantic search across stored Gong advocacy clips (positive customer moments). Returns video-ready results with direct clip URLs, timestamps, and sentiment data. Uses advanced reranking for improved accuracy.
 */
export const gongsAdvocacyClipsSearchMany = <ThrowOnError extends boolean = false>(options?: Options<GongsAdvocacyClipsSearchManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<GongsAdvocacyClipsSearchManyResponses, GongsAdvocacyClipsSearchManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/gong/advocacyClips/search',
        ...options
    });
};

/**
 * Trim and upload a video clip
 *
 * Trim one of the caller's brand's Gong advocacy clip videos to the given start and end times, then upload the trimmed clip to S3. The video URL must be a clip video stored for the caller's brand.
 */
export const gongsTrimVideo = <ThrowOnError extends boolean = false>(options: Options<GongsTrimVideoData, ThrowOnError>) => {
    return (options.client ?? client).post<GongsTrimVideoResponses, GongsTrimVideoErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/gong/trimVideo',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a new advocacy mission (a campaign or task that advocates complete) for the brand, including its reward, audience and mission type. Use this to "create a mission" or "launch a new campaign".
 */
export const brandMissionsCreate = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandMissionsCreateResponses, BrandMissionsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/brandMissions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update an existing advocacy mission (campaign) — edit its name, reward, budget, audience, questions or schedule. Use this to "edit a mission" or "change a campaign's reward or targeting".
 */
export const brandMissionsUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandMissionsUpdateResponses, BrandMissionsUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/brandMissions/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Proxy requests to UserEvidence API to avoid CORS/COEP issues.
 */
export const userEvidencesProxy = <ThrowOnError extends boolean = false>(options: Options<UserEvidencesProxyData, ThrowOnError>) => {
    return (options.client ?? client).post<UserEvidencesProxyResponses, UserEvidencesProxyErrors, ThrowOnError>({
        url: '/api/v2/userEvidence/proxy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generate a self-service SSO setup link for the current brand
 *
 * Mints an Auth0 self-service SSO ticket for the authenticated brand and returns a customer-facing setup link. target selects which application the resulting connection is enabled on (advocate hub or admin portal). Links are short-lived; regenerate by calling again. Equivalent to the dashboard "Generate Ticket" flow.
 */
export const auth0SsoTicketGenerate = <ThrowOnError extends boolean = false>(options: Options<Auth0SsoTicketGenerateData, ThrowOnError>) => {
    return (options.client ?? client).post<Auth0SsoTicketGenerateResponses, Auth0SsoTicketGenerateErrors, ThrowOnError>({
        url: '/api/v2/integrations/auth0/ssoTicket',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Build the HubSpot consent URL for the current brand
 *
 * Mints a single-use install state bound to the authenticated brand and admin, and returns the HubSpot consent URL to send the admin to. This is the only entry point to a HubSpot install: the brand the app lands on is the one signed into the state here, never something the callback is told.
 */
export const hubspotOauthAuthorize = <ThrowOnError extends boolean = false>(options?: Options<HubspotOauthAuthorizeData, ThrowOnError>) => {
    return (options?.client ?? client).get<HubspotOauthAuthorizeResponses, HubspotOauthAuthorizeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrations/hubspot/authorize',
        ...options
    });
};

/**
 * Finish a HubSpot install the signed-in admin started
 *
 * Takes the one-time handle the callback redirected with. Only the admin who started the install, signed in to the same brand, can finish it: the code is exchanged, the portal connected to that brand and each brand field mapped onto a portal property, creating the ones the portal lacks.
 */
export const hubspotOauthComplete = <ThrowOnError extends boolean = false>(options: Options<HubspotOauthCompleteData, ThrowOnError>) => {
    return (options.client ?? client).post<HubspotOauthCompleteResponses, HubspotOauthCompleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrations/hubspot/oauth/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Disconnect the brand's HubSpot portal
 *
 * Releases the portal so it can be connected again, by this brand or another, drops the stored tokens and forgets which portal records the brand was linked to. The field maps are kept for the next install.
 */
export const hubspotDisconnect = <ThrowOnError extends boolean = false>(options?: Options<HubspotDisconnectData, ThrowOnError>) => {
    return (options?.client ?? client).post<HubspotDisconnectResponses, HubspotDisconnectErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrations/hubspot/disconnect',
        ...options
    });
};

/**
 * Enable Bevy integration for the current brand
 *
 * Creates a BrandIntegrations row (platform bevy) if missing and upserts default event-registration read mappings for the legacy Workato /workato/stream enrichments pipeline. Returns workatoIntegrationID to configure in Workato.
 */
export const bevyIntegrationEnable = <ThrowOnError extends boolean = false>(options?: Options<BevyIntegrationEnableData, ThrowOnError>) => {
    return (options?.client ?? client).post<BevyIntegrationEnableResponses, BevyIntegrationEnableErrors, ThrowOnError>({
        url: '/api/v2/integrations/bevy/enable',
        ...options
    });
};

/**
 * Mint a short-lived signed Omni embed URL for the current brand's Omni user
 *
 * Signs an Omni SSO embed login URL as the brand's single Omni user. Identity, brand entity, user attributes and roles are derived server-side, and the roles (view or create) follow the brand's create flag. The body only selects the surface: the builder's entity folder, a reporting tab, which the server maps to an Omni dashboard, or Omni's AI chat.
 */
export const omniEmbedUrl = <ThrowOnError extends boolean = false>(options: Options<OmniEmbedUrlData, ThrowOnError>) => {
    return (options.client ?? client).post<OmniEmbedUrlResponses, OmniEmbedUrlErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrations/omni/embedUrl',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Provision the current brand's Omni embed user and entity ahead of its first login
 *
 * Upserts the brand's single Omni embed user, entity folder and entity group with the same identity, labels and roles the embed signer uses, then stamps BrandConfig.omniProvisionedAt the first time. Safe to repeat. Superadmin only.
 */
export const omniProvision = <ThrowOnError extends boolean = false>(options?: Options<OmniProvisionData, ThrowOnError>) => {
    return (options?.client ?? client).post<OmniProvisionResponses, OmniProvisionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrations/omni/provision',
        ...options
    });
};

/**
 * Read a shared Omni dashboard KPI tile's value for the current brand
 *
 * Runs the tile's saved query in Omni as the brand's embed user, so the value equals the same tile in the embedded dashboard. The server maps the tile key to a shared dashboard query; the client never names an Omni document or query. A 404 with code OMNI_DASHBOARD_NOT_CONFIGURED or OMNI_EMBED_USER_NOT_FOUND means the tile is not configured for this brand; a null value means Omni has no data for the range; days is the range applied, or null when the tile ran on its own saved range.
 */
export const omniKpiTile = <ThrowOnError extends boolean = false>(options: Options<OmniKpiTileData, ThrowOnError>) => {
    return (options.client ?? client).get<OmniKpiTileResponses, OmniKpiTileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrations/omni/kpiTile',
        ...options
    });
};

/**
 * Connect or update the brand's RainFocus API profile
 *
 * Stores the RainFocus org ID and apiProfile key on the brand's RainFocus integration source, sealing the key. The key is never returned. Superadmin only.
 */
export const rainfocusConnectionUpsert = <ThrowOnError extends boolean = false>(options: Options<RainfocusConnectionUpsertData, ThrowOnError>) => {
    return (options.client ?? client).put<RainfocusConnectionUpsertResponses, RainfocusConnectionUpsertErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrations/rainfocus/connection',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Read Salesforce picklist values for a field
 *
 * Live-fetches the allowed (active) picklist values for a given object/field on the current brand’s connected Salesforce, for seeding a CustomFieldDefinition’s fieldConfig.options at setup time (fetch-not-store). Cached in Redis for 1h per object; pass forceRefresh=true to bypass. Returns 409 when Salesforce is not connected for the brand. durableId/entityParticleId are deliberately omitted in v1 — there is no store for them and rename-tracking belongs to the sync layer (ZLT-3709).
 */
export const salesforcePicklistValuesRead = <ThrowOnError extends boolean = false>(options: Options<SalesforcePicklistValuesReadData, ThrowOnError>) => {
    return (options.client ?? client).get<SalesforcePicklistValuesReadResponses, SalesforcePicklistValuesReadErrors, ThrowOnError>({
        url: '/api/v2/integrations/salesforce/picklistValues',
        ...options
    });
};

/**
 * Check whether the Salesforce integration user can see an Opportunity
 *
 * Counts, as the package’s integration user, the Opportunities that the brand’s connected Salesforce lets that user see. Returns `not_readable` when Salesforce does not make the Opportunity object available to that user, `none_visible` when the count is 0, and `at_least_one_visible` otherwise. The count goes to the API log, not to this response. Cached in Redis for 1h; pass forceRefresh=true to bypass. 409 when Salesforce is not connected or its credentials fail; 422 when Salesforce rejects the query (a non-auth 4xx); 502 when Salesforce is unreachable, failing (5xx), rate-limiting, or answers in an unexpected shape.
 */
export const salesforceOpportunityVisibilityRead = <ThrowOnError extends boolean = false>(options?: Options<SalesforceOpportunityVisibilityReadData, ThrowOnError>) => {
    return (options?.client ?? client).get<SalesforceOpportunityVisibilityReadResponses, SalesforceOpportunityVisibilityReadErrors, ThrowOnError>({
        url: '/api/v2/integrations/salesforce/opportunityVisibility',
        ...options
    });
};

/**
 * Enable Webex integration for the current brand
 *
 * Creates a BrandIntegrations row (platform Webex) if missing and upserts default meeting-attendance read mappings for the legacy Workato /workato/stream enrichments pipeline. Returns workatoIntegrationID to configure in Workato.
 */
export const webexIntegrationEnable = <ThrowOnError extends boolean = false>(options?: Options<WebexIntegrationEnableData, ThrowOnError>) => {
    return (options?.client ?? client).post<WebexIntegrationEnableResponses, WebexIntegrationEnableErrors, ThrowOnError>({
        url: '/api/v2/integrations/webex/enable',
        ...options
    });
};

/**
 * Retrieve a paginated list of accounts grouped by email domain with advocacy scores and activity data.
 */
export const accountsAccountsTableMany = <ThrowOnError extends boolean = false>(options?: Options<AccountsAccountsTableManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<AccountsAccountsTableManyResponses, AccountsAccountsTableManyErrors, ThrowOnError>({
        url: '/api/v2/accounts/accountsTable',
        ...options
    });
};

/**
 * Retrieve aggregated activities for all advocates in an account domain.
 */
export const accountActivities = <ThrowOnError extends boolean = false>(options: Options<AccountActivitiesData, ThrowOnError>) => {
    return (options.client ?? client).get<AccountActivitiesResponses, AccountActivitiesErrors, ThrowOnError>({
        url: '/api/v2/accounts/{domain}/activities',
        ...options
    });
};

/**
 * Retrieve aggregated content/submissions for all advocates in an account domain.
 */
export const accountContent = <ThrowOnError extends boolean = false>(options: Options<AccountContentData, ThrowOnError>) => {
    return (options.client ?? client).get<AccountContentResponses, AccountContentErrors, ThrowOnError>({
        url: '/api/v2/accounts/{domain}/content',
        ...options
    });
};

/**
 * Retrieve account detail for a specific domain including advocates and recent activities.
 */
export const accountsRead = <ThrowOnError extends boolean = false>(options: Options<AccountsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<AccountsReadResponses, AccountsReadErrors, ThrowOnError>({
        url: '/api/v2/accounts/{domain}',
        ...options
    });
};

/**
 * Return the list of fan-user advocates whose email matches one of the requested domains.
 */
export const accountsAdvocatesByDomainMany = <ThrowOnError extends boolean = false>(options: Options<AccountsAdvocatesByDomainManyData, ThrowOnError>) => {
    return (options.client ?? client).post<AccountsAdvocatesByDomainManyResponses, AccountsAdvocatesByDomainManyErrors, ThrowOnError>({
        url: '/api/v2/accounts/advocatesByDomain',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generate advocate scores for all fanUsers in a brand using AI analysis. Can run synchronously for small batches or enqueue a background job for full brand processing. Pass brandID in body for unauthenticated testing.
 */
export const advocateScoresGenerate = <ThrowOnError extends boolean = false>(options: Options<AdvocateScoresGenerateData, ThrowOnError>) => {
    return (options.client ?? client).post<AdvocateScoresGenerateResponses, AdvocateScoresGenerateErrors, ThrowOnError>({
        url: '/api/v2/advocateScores/generate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Read advocate scores for a brand with pagination and filtering. By default returns only the latest score per fanUser.
 */
export const advocateScoresListMany = <ThrowOnError extends boolean = false>(options?: Options<AdvocateScoresListManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdvocateScoresListManyResponses, AdvocateScoresListManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/advocateScores/list',
        ...options
    });
};

/**
 * Read score history for a specific fanUser to track changes over time (deltas).
 */
export const advocateScoresFanUserFanUserUuidHistory = <ThrowOnError extends boolean = false>(options: Options<AdvocateScoresFanUserFanUserUuidHistoryData, ThrowOnError>) => {
    return (options.client ?? client).get<AdvocateScoresFanUserFanUserUuidHistoryResponses, AdvocateScoresFanUserFanUserUuidHistoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/advocateScores/fanUser/{fanUserUuid}/history',
        ...options
    });
};

/**
 * List and filter the brand's audit log — the record of admin actions taken in the account, with the actor, action and affected subject. Filter and sort to answer "view the audit log" or "who did what". `changedField` narrows to entries whose diff touched one field, e.g. an advocate's status history.
 */
export const auditLogsReadMany = <ThrowOnError extends boolean = false>(options?: Options<AuditLogsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<AuditLogsReadManyResponses, AuditLogsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/auditLogs',
        ...options
    });
};

/**
 * Execute multiple API requests in batches with interpolation support.
 */
export const batchesExecute = <ThrowOnError extends boolean = false>(options: Options<BatchesExecuteData, ThrowOnError>) => {
    return (options.client ?? client).post<BatchesExecuteResponses, BatchesExecuteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/batch/execute',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * The public application form for a brand, looked up by brand code or name: the brand's uuid, its form branding, and its fields (the shared defaults plus the brand's own). Unauthenticated; used by the hosted apply page.
 */
export const brandApplicationFormsPublic = <ThrowOnError extends boolean = false>(options: Options<BrandApplicationFormsPublicData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandApplicationFormsPublicResponses, BrandApplicationFormsPublicErrors, ThrowOnError>({
        url: '/api/v2/brandApplicationForms/public',
        ...options
    });
};

/**
 * List all application form field definitions for the brand.
 */
export const brandApplicationFormsReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandApplicationFormsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandApplicationFormsReadManyResponses, BrandApplicationFormsReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandApplicationForms',
        ...options
    });
};

/**
 * Sync (create/update/delete) application form field definitions for the brand.
 */
export const brandApplicationFormsCreate = <ThrowOnError extends boolean = false>(options: Options<BrandApplicationFormsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandApplicationFormsCreateResponses, BrandApplicationFormsCreateErrors, ThrowOnError>({
        url: '/api/v2/brandApplicationForms',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieve all applicants for the brand grouped by status (pending, approved, declined), each with their application form responses in `fields`.
 */
export const brandApplicationsAll = <ThrowOnError extends boolean = false>(options?: Options<BrandApplicationsAllData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandApplicationsAllResponses, BrandApplicationsAllErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandApplications/all',
        ...options
    });
};

/**
 * Deletes all of an applicant's submissions (Applications + FanApplications rows) for the current brand, identified by email.
 */
export const brandApplicationsApplicantDelete = <ThrowOnError extends boolean = false>(options: Options<BrandApplicationsApplicantDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandApplicationsApplicantDeleteResponses, BrandApplicationsApplicantDeleteErrors, ThrowOnError>({
        url: '/api/v2/brandApplications/applicants',
        ...options
    });
};

/**
 * Approve or deny an applicant for the current brand. Persists isApproved, creates the FanUser on approval, reconciles dynamic-segment membership, and best-effort fires the notification (failure is logged but does not roll back the status change).
 */
export const brandApplicationsApplicantUpdateStatus = <ThrowOnError extends boolean = false>(options: Options<BrandApplicationsApplicantUpdateStatusData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandApplicationsApplicantUpdateStatusResponses, BrandApplicationsApplicantUpdateStatusErrors, ThrowOnError>({
        url: '/api/v2/brandApplications/applicants/updateStatus',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Read the caller's brand config
 *
 * The full config of the caller's own brand, including the staff-only fields the public lookup leaves out, and whether UserEvidence is connected. The brand comes from the caller's session. Credentials are never returned.
 */
export const brandConfigsRead = <ThrowOnError extends boolean = false>(options?: Options<BrandConfigsReadData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandConfigsReadResponses, BrandConfigsReadErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandConfig',
        ...options
    });
};

/**
 * Get brand info by code
 *
 * Returns brand name and icon by brand code. Public endpoint - no authentication required.
 */
export const brandConfigReadByCode = <ThrowOnError extends boolean = false>(options: Options<BrandConfigReadByCodeData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandConfigReadByCodeResponses, BrandConfigReadByCodeErrors, ThrowOnError>({
        url: '/api/v2/brandConfig/by-code/{code}',
        ...options
    });
};

/**
 * Updates BrandConfig settings including CSM field and reference request settings
 */
export const brandConfigsUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandConfigsUpdateResponses, BrandConfigsUpdateErrors, ThrowOnError>({
        url: '/api/v2/brandConfig/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieves account fields from IntegrationMap for the current brand
 */
export const integrationMapsAccountFieldsMany = <ThrowOnError extends boolean = false>(options?: Options<IntegrationMapsAccountFieldsManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<IntegrationMapsAccountFieldsManyResponses, IntegrationMapsAccountFieldsManyErrors, ThrowOnError>({
        url: '/api/v2/brandConfig/accountFields',
        ...options
    });
};

/**
 * Retrieves all fields from IntegrationMap for the current brand
 */
export const integrationMapsAllFieldsMany = <ThrowOnError extends boolean = false>(options?: Options<IntegrationMapsAllFieldsManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<IntegrationMapsAllFieldsManyResponses, IntegrationMapsAllFieldsManyErrors, ThrowOnError>({
        url: '/api/v2/brandConfig/allFields',
        ...options
    });
};

/**
 * Retrieves all survey questions for the current brand
 */
export const brandConfigsSurveyQuestionsMany = <ThrowOnError extends boolean = false>(options?: Options<BrandConfigsSurveyQuestionsManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandConfigsSurveyQuestionsManyResponses, BrandConfigsSurveyQuestionsManyErrors, ThrowOnError>({
        url: '/api/v2/brandConfig/surveyQuestions',
        ...options
    });
};

/**
 * Lookup CSM value for a user in a segment
 *
 * Looks up the CSM value from FanUserEnrichment using the configured csmField from BrandConfig and IntegrationMap, for a segment the authenticated brand owns. Answers 404 for a segment belonging to another brand. The brand comes from the caller's session, never from the requested segment.
 */
export const brandConfigsCsmLookup = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsCsmLookupData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandConfigsCsmLookupResponses, BrandConfigsCsmLookupErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandConfig/csmLookup',
        ...options
    });
};

/**
 * Returns the effective program type for the current fan user, accounting for segment overrides
 */
export const brandConfigsProgramType = <ThrowOnError extends boolean = false>(options?: Options<BrandConfigsProgramTypeData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandConfigsProgramTypeResponses, BrandConfigsProgramTypeErrors, ThrowOnError>({
        url: '/api/v2/brandConfig/programType',
        ...options
    });
};

/**
 * Live DNS/DKIM health of the brand's email sender domain
 *
 * Looks up the DKIM (<selector>._domainkey.<domain>) and SPF TXT records live in DNS for the caller's brand email configuration and compares them to what the platform signs with. The brand comes from the caller's session.
 */
export const brandConfigsEmailDnsHealth = <ThrowOnError extends boolean = false>(options?: Options<BrandConfigsEmailDnsHealthData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandConfigsEmailDnsHealthResponses, BrandConfigsEmailDnsHealthErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandConfig/emailDnsHealth',
        ...options
    });
};

/**
 * List the current user's conversations.
 */
export const conversationsReadMany = <ThrowOnError extends boolean = false>(options?: Options<ConversationsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<ConversationsReadManyResponses, ConversationsReadManyErrors, ThrowOnError>({
        url: '/api/v2/conversation',
        ...options
    });
};

/**
 * Create or get-or-create a DM or group conversation.
 */
export const conversationsCreate = <ThrowOnError extends boolean = false>(options: Options<ConversationsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<ConversationsCreateResponses, ConversationsCreateErrors, ThrowOnError>({
        url: '/api/v2/conversation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update a group conversation name or image. Only brand users (admins) can update.
 */
export const conversationsUpdate = <ThrowOnError extends boolean = false>(options: Options<ConversationsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<ConversationsUpdateResponses, ConversationsUpdateErrors, ThrowOnError>({
        url: '/api/v2/conversation/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get paginated message history for a conversation.
 */
export const conversationsMessagesReadMany = <ThrowOnError extends boolean = false>(options: Options<ConversationsMessagesReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<ConversationsMessagesReadManyResponses, ConversationsMessagesReadManyErrors, ThrowOnError>({
        url: '/api/v2/conversation/{uuid}/messages',
        ...options
    });
};

/**
 * Mark a conversation as read by updating lastReadAt to now.
 */
export const conversationsRead = <ThrowOnError extends boolean = false>(options: Options<ConversationsReadData, ThrowOnError>) => {
    return (options.client ?? client).post<ConversationsReadResponses, ConversationsReadErrors, ThrowOnError>({
        url: '/api/v2/conversation/{uuid}/read',
        ...options
    });
};

/**
 * List all reported chat messages for the current brand. Admin only.
 */
export const chatMessageReportsReadMany = <ThrowOnError extends boolean = false>(options?: Options<ChatMessageReportsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<ChatMessageReportsReadManyResponses, ChatMessageReportsReadManyErrors, ThrowOnError>({
        url: '/api/v2/chatMessageReport',
        ...options
    });
};

/**
 * Mark a report as reviewed or dismissed. Admin only.
 */
export const chatMessageReportsUpdate = <ThrowOnError extends boolean = false>(options: Options<ChatMessageReportsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<ChatMessageReportsUpdateResponses, ChatMessageReportsUpdateErrors, ThrowOnError>({
        url: '/api/v2/chatMessageReport/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Returns Ably serials of messages the current user has reported in a conversation.
 */
export const chatMessageReportsMine = <ThrowOnError extends boolean = false>(options: Options<ChatMessageReportsMineData, ThrowOnError>) => {
    return (options.client ?? client).get<ChatMessageReportsMineResponses, ChatMessageReportsMineErrors, ThrowOnError>({
        url: '/api/v2/chatMessageReport/mine',
        ...options
    });
};

/**
 * Report a chat message for violating community guidelines.
 */
export const chatMessagesReport = <ThrowOnError extends boolean = false>(options: Options<ChatMessagesReportData, ThrowOnError>) => {
    return (options.client ?? client).post<ChatMessagesReportResponses, ChatMessagesReportErrors, ThrowOnError>({
        url: '/api/v2/chatMessage/{uuid}/report',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Read the chat configuration for the current brand.
 */
export const chatConfigsRead = <ThrowOnError extends boolean = false>(options?: Options<ChatConfigsReadData, ThrowOnError>) => {
    return (options?.client ?? client).get<ChatConfigsReadResponses, ChatConfigsReadErrors, ThrowOnError>({
        url: '/api/v2/chatConfig',
        ...options
    });
};

/**
 * Update the chat configuration for the current brand.
 */
export const chatConfigsUpdate = <ThrowOnError extends boolean = false>(options: Options<ChatConfigsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<ChatConfigsUpdateResponses, ChatConfigsUpdateErrors, ThrowOnError>({
        url: '/api/v2/chatConfig',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Read the DM preferences for the authenticated user.
 */
export const chatPreferencesRead = <ThrowOnError extends boolean = false>(options?: Options<ChatPreferencesReadData, ThrowOnError>) => {
    return (options?.client ?? client).get<ChatPreferencesReadResponses, ChatPreferencesReadErrors, ThrowOnError>({
        url: '/api/v2/chatPreferences',
        ...options
    });
};

/**
 * Update the DM preferences for the authenticated user.
 */
export const chatPreferencesUpdate = <ThrowOnError extends boolean = false>(options: Options<ChatPreferencesUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<ChatPreferencesUpdateResponses, ChatPreferencesUpdateErrors, ThrowOnError>({
        url: '/api/v2/chatPreferences',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List brand team admins and fan user members available for chat.
 */
export const chatMembersRead = <ThrowOnError extends boolean = false>(options?: Options<ChatMembersReadData, ThrowOnError>) => {
    return (options?.client ?? client).get<ChatMembersReadResponses, ChatMembersReadErrors, ThrowOnError>({
        url: '/api/v2/chatMember',
        ...options
    });
};

/**
 * Generate an Ably Chat token for the current user.
 */
export const chatsToken = <ThrowOnError extends boolean = false>(options?: Options<ChatsTokenData, ThrowOnError>) => {
    return (options?.client ?? client).post<ChatsTokenResponses, ChatsTokenErrors, ThrowOnError>({
        url: '/api/v2/chat/token',
        ...options
    });
};

/**
 * Update the current user's online presence for chat notifications.
 */
export const chatsPresence = <ThrowOnError extends boolean = false>(options?: Options<ChatsPresenceData, ThrowOnError>) => {
    return (options?.client ?? client).post<ChatsPresenceResponses, ChatsPresenceErrors, ThrowOnError>({
        url: '/api/v2/chat/presence',
        ...options
    });
};

/**
 * Fetches Open Graph metadata for a given URL server-side.
 */
export const chatsLinkPreview = <ThrowOnError extends boolean = false>(options: Options<ChatsLinkPreviewData, ThrowOnError>) => {
    return (options.client ?? client).get<ChatsLinkPreviewResponses, ChatsLinkPreviewErrors, ThrowOnError>({
        url: '/api/v2/chat/linkPreview',
        ...options
    });
};

/**
 * Delete several advocacy missions (campaigns) by UUID in one transaction. Soft-deletes each mission and its survey questions; a uuid outside the brand, or already deleted, is skipped.
 */
export const brandMissionsDeleteMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsDeleteManyData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandMissionsDeleteManyResponses, BrandMissionsDeleteManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandMissions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List and filter the brand's advocacy missions (campaigns and tasks that advocates complete). Returns each mission with its reward, type, folder, tags, audience and engagement stats (views, likes, submissions, reward redemptions). Filter by folder, tag, or segment and search/sort via searchFields. Use this to answer "list all missions", "show my campaigns", or "which missions are live".
 */
export const brandMissionsReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandMissionsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandMissionsReadManyResponses, BrandMissionsReadManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions',
        ...options
    });
};

/**
 * Retrieves a list of BrandMissions.
 */
export const brandMissionsAvailableMany = <ThrowOnError extends boolean = false>(options?: Options<BrandMissionsAvailableManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandMissionsAvailableManyResponses, BrandMissionsAvailableManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/available',
        ...options
    });
};

/**
 * Returns folder/tag/smart-folder counts for the organization sidebar
 */
export const brandMissionsOrganizationCountsMany = <ThrowOnError extends boolean = false>(options?: Options<BrandMissionsOrganizationCountsManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandMissionsOrganizationCountsManyResponses, BrandMissionsOrganizationCountsManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/organizationCounts',
        ...options
    });
};

/**
 * Delete an advocacy mission (campaign) by UUID. Soft-deletes the mission and its survey questions. Use this to "delete" or "remove a mission".
 */
export const brandMissionsDelete = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandMissionsDeleteResponses, BrandMissionsDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandMissions/{uuid}',
        ...options
    });
};

/**
 * Get brand mission details
 *
 * Returns a BrandMission with joined details. Public missions are accessible without auth.
 */
export const brandMissionsRead = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandMissionsReadResponses, BrandMissionsReadErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/{uuid}',
        ...options
    });
};

/**
 * Publish an advocacy mission (campaign) — marks a BrandMission as live (isLive=1, isDraft=0, isScheduled=0). Optionally triggers a workflow with the mission audience. Use this to "publish" or "set a mission live".
 */
export const brandMissionsSetOnLive = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsSetOnLiveData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandMissionsSetOnLiveResponses, BrandMissionsSetOnLiveErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandMissions/{uuid}/setOnLive',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Clone (duplicate/copy) an advocacy mission into a new draft with a new name, optionally retargeted to a segment.
 */
export const brandMissionsClone = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsCloneData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandMissionsCloneResponses, BrandMissionsCloneErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandMissions/{uuid}/clone',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Target an advocacy mission at a specific set of advocates by email, replacing the mission's audience. Use this to "send a mission to specific advocates" or "set who receives a campaign".
 */
export const brandMissionsTargetAdvocates = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsTargetAdvocatesData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandMissionsTargetAdvocatesResponses, BrandMissionsTargetAdvocatesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandMissions/{uuid}/targetAdvocates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Updates the pinned status of a brand mission
 */
export const brandMissionsPinStatus = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsPinStatusData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandMissionsPinStatusResponses, BrandMissionsPinStatusErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/{uuid}/pinStatus',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Returns a per-recipient signed decline URL for the authenticated advocate, for the mission at `/{uuid}`.
 */
export const brandMissionsSchedulingDeclineUrl = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsSchedulingDeclineUrlData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandMissionsSchedulingDeclineUrlResponses, BrandMissionsSchedulingDeclineUrlErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/{uuid}/schedulingDeclineUrl',
        ...options
    });
};

/**
 * Assigns one or more missions to a folder
 */
export const brandMissionsMoveToFolderMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsMoveToFolderManyData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandMissionsMoveToFolderManyResponses, BrandMissionsMoveToFolderManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/moveToFolder',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Clears folder assignments from one or more missions
 */
export const brandMissionsClearFolderMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsClearFolderManyData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandMissionsClearFolderManyResponses, BrandMissionsClearFolderManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/clearFolder',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Adds, removes, or syncs mission tags for one or more missions
 */
export const brandMissionsManageTagsMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsManageTagsManyData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandMissionsManageTagsManyResponses, BrandMissionsManageTagsManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/manageTags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the survey answers of a brand mission
 *
 * List the survey answers (responses) that advocates submitted for one survey brand mission. Each item is one advocate's submission: the advocate, its review status (approved, pending or rejected; null on a row whose status was never written), and each question they answered with their answers. Drafts are never listed. Submissions are always listed newest first; the orderBy parameter is ignored. Paginated by submission, up to 20 per page. A resubmitted submission can list answers from more than one attempt for one question. Each answer has its own created_at, which usually tells the attempts apart. For older multi-select answers, attempts can share one date, and a later attempt can show only the options it added, not the ones an earlier attempt also picked, so its list can be incomplete. The list order of answers is not date order. Answers are listed only under the questions the mission has now: if the brand removed a question after advocates answered it, or a submitted answer never matched a question, those answers are not returned and nothing marks them missing. Pass fanUserUuid to get one advocate's answers. Use for "what did people answer in survey X", "survey results", "survey responses".
 */
export const brandMissionsSurveyAnswersReadMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsSurveyAnswersReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandMissionsSurveyAnswersReadManyResponses, BrandMissionsSurveyAnswersReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandMissions/{uuid}/surveyAnswers',
        ...options
    });
};

/**
 * List the survey answers of a brand mission, walked by cursor
 *
 * Cursor-paginated sibling of GET /v2/brandMissions/{uuid}/surveyAnswers: same items, same draft exclusion and the same fanUserUuid filter, but walked via an opaque cursor instead of page/pageSize. The walk order is the primary key (fanMissionID desc): stable for a full traversal, but not submission-date order — a resubmitted or reused row keeps its old low id with a fresh createdAt. The offset route orders by createdAt desc, uuid desc. Use this for scan-style traversal of every submission; the offset route stays for page-at-a-time reading.
 */
export const brandMissionsSurveyAnswersCursorMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsSurveyAnswersCursorManyData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandMissionsSurveyAnswersCursorManyResponses, BrandMissionsSurveyAnswersCursorManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandMissions/{uuid}/surveyAnswers/cursor',
        ...options
    });
};

/**
 * Deletes all survey questions for a specific brand mission
 */
export const brandMissionsSurveyQuestionsDeleteMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsSurveyQuestionsDeleteManyData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandMissionsSurveyQuestionsDeleteManyResponses, BrandMissionsSurveyQuestionsDeleteManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/{uuid}/surveyQuestions',
        ...options
    });
};

/**
 * Get survey questions for a mission
 *
 * Retrieves all survey questions for a specific brand mission
 */
export const brandMissionsSurveyQuestionsReadMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsSurveyQuestionsReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandMissionsSurveyQuestionsReadManyResponses, BrandMissionsSurveyQuestionsReadManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/{uuid}/surveyQuestions',
        ...options
    });
};

/**
 * Create survey questions for a mission
 *
 * Creates survey questions for a specific brand mission
 */
export const brandMissionsSurveyQuestionsCreateMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsSurveyQuestionsCreateManyData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandMissionsSurveyQuestionsCreateManyResponses, BrandMissionsSurveyQuestionsCreateManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/{uuid}/surveyQuestions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Submit testimonial answers for a brand mission. Replaces any existing testimonial submissions.
 */
export const brandMissionsTestimonialMissionQuestionAnswerCreate = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsTestimonialMissionQuestionAnswerCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandMissionsTestimonialMissionQuestionAnswerCreateResponses, BrandMissionsTestimonialMissionQuestionAnswerCreateErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/{uuid}/testimonialMissionQuestionAnswers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get testimonial questions for a brand mission
 *
 * Retrieves all testimonial questions for a particular brand mission, including primary color from brand config
 */
export const brandMissionsTestimonialQuestionsReadMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsTestimonialQuestionsReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandMissionsTestimonialQuestionsReadManyResponses, BrandMissionsTestimonialQuestionsReadManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/{uuid}/testimonialQuestions',
        ...options
    });
};

/**
 * Get testimonial answers for a brand mission for a particular fan mission
 *
 * Retrieves all testimonial question answers (video/audio clips) for a particular brand mission, optionally filtered by fan mission
 */
export const brandMissionsTestimonialAnswersReadMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsTestimonialAnswersReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandMissionsTestimonialAnswersReadManyResponses, BrandMissionsTestimonialAnswersReadManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/{uuid}/testimonialAnswers',
        ...options
    });
};

/**
 * Get user submissions for a particular brand mission
 *
 * Retrieves all fan mission submissions. Use isApproved to filter by status (true/false/all), hasMedia to filter for submissions with media.
 */
export const brandMissionsFanMissionsReadMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsFanMissionsReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandMissionsFanMissionsReadManyResponses, BrandMissionsFanMissionsReadManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/{uuid}/fanMissions',
        ...options
    });
};

/**
 * Get eligible fan users for a brand mission
 *
 * Retrieves all eligible fan users for this brand mission (based on groupID/userIDs), with their fanMissions array. Use hideCompleted=true to only show users who have not yet submitted.
 */
export const brandMissionsFanUsersReadMany = <ThrowOnError extends boolean = false>(options: Options<BrandMissionsFanUsersReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandMissionsFanUsersReadManyResponses, BrandMissionsFanUsersReadManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/{uuid}/fanUsers',
        ...options
    });
};

/**
 * Get pending UGC submissions for review
 *
 * Retrieves all user-generated content submissions that are pending review for the authenticated brand. Includes submission details, user information, and aggregate user statistics (points, groups, acceptance rate).
 */
export const brandsUserGeneratedContentsMany = <ThrowOnError extends boolean = false>(options?: Options<BrandsUserGeneratedContentsManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandsUserGeneratedContentsManyResponses, BrandsUserGeneratedContentsManyErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/brands/userGeneratedContents',
        ...options
    });
};

/**
 * Get the latest signup-rule audit behind a mission submission
 *
 * Returns the most recent BrandSignupAudit row for the submission's fan user, scoped to the authenticated brand, so a reviewer can see the CCL/SSO context behind a Welcome-mission qual. `data` is null when no audit exists.
 */
export const brandsSignupAudit = <ThrowOnError extends boolean = false>(options: Options<BrandsSignupAuditData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandsSignupAuditResponses, BrandsSignupAuditErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/brands/signupAudit',
        ...options
    });
};

/**
 * Decline a mission submission (manual review)
 *
 * Declines a Welcome/UGC submission from the Approve Engagements board. When the mission runs the brand signup rules, the member is also banned — matching the automatic signup-rules deny. For referral missions the referral status is set to REJECTED. Brand-scoped via the authenticated brand user.
 */
export const brandsUgcDecline = <ThrowOnError extends boolean = false>(options: Options<BrandsUgcDeclineData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandsUgcDeclineResponses, BrandsUgcDeclineErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/brands/ugcDecline',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Approve a mission submission (manual review)
 *
 * Approves a Welcome/UGC submission from the Approve Engagements board, awarding the reward points and recording the reviewer. For referral missions the referral status is set to ACCEPTED. Brand-scoped via the authenticated brand user. Symmetric twin of ugcDecline.
 */
export const brandsUgcApprove = <ThrowOnError extends boolean = false>(options: Options<BrandsUgcApproveData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandsUgcApproveResponses, BrandsUgcApproveErrors, ThrowOnError>({
        url: '/api/v2/brandMissions/brands/ugcApprove',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get conditions schema for the smart-folder builder
 *
 * Returns the smart-folder conditions surface with brand-scoped option sets hydrated (regular folders, tags, mission frequencies).
 */
export const brandMissionFoldersConditionsSchema = <ThrowOnError extends boolean = false>(options?: Options<BrandMissionFoldersConditionsSchemaData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandMissionFoldersConditionsSchemaResponses, BrandMissionFoldersConditionsSchemaErrors, ThrowOnError>({
        url: '/api/v2/brandMissionFolders/conditionsSchema',
        ...options
    });
};

/**
 * List the brand's mission folders (used to organize campaigns), including any smart-folder conditions. Use this to "list mission folders" or "show campaign folders".
 */
export const brandMissionFoldersReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandMissionFoldersReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandMissionFoldersReadManyResponses, BrandMissionFoldersReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandMissionFolders',
        ...options
    });
};

/**
 * Create a folder for organizing the brand's advocacy missions (campaigns). Supports regular folders and smart folders with auto-matching conditions. Use this to "create a mission folder" or "add a campaign folder".
 */
export const brandMissionFoldersCreate = <ThrowOnError extends boolean = false>(options: Options<BrandMissionFoldersCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandMissionFoldersCreateResponses, BrandMissionFoldersCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandMissionFolders',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Deletes a mission folder
 */
export const brandMissionFoldersDelete = <ThrowOnError extends boolean = false>(options: Options<BrandMissionFoldersDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandMissionFoldersDeleteResponses, BrandMissionFoldersDeleteErrors, ThrowOnError>({
        url: '/api/v2/brandMissionFolders/{uuid}',
        ...options
    });
};

/**
 * Retrieves a mission folder by UUID
 */
export const brandMissionFoldersRead = <ThrowOnError extends boolean = false>(options: Options<BrandMissionFoldersReadData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandMissionFoldersReadResponses, BrandMissionFoldersReadErrors, ThrowOnError>({
        url: '/api/v2/brandMissionFolders/{uuid}',
        ...options
    });
};

/**
 * Updates a mission folder
 */
export const brandMissionFoldersUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandMissionFoldersUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandMissionFoldersUpdateResponses, BrandMissionFoldersUpdateErrors, ThrowOnError>({
        url: '/api/v2/brandMissionFolders/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the brand's mission tags (labels used to categorize campaigns), optionally filtered by name. Use this to "list mission tags" or "show campaign labels".
 */
export const brandMissionTagsReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandMissionTagsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandMissionTagsReadManyResponses, BrandMissionTagsReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandMissionTags',
        ...options
    });
};

/**
 * Create a tag for labeling and grouping the brand's advocacy missions (campaigns). Use this to "create a mission tag" or "add a campaign label".
 */
export const brandMissionTagsCreate = <ThrowOnError extends boolean = false>(options: Options<BrandMissionTagsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandMissionTagsCreateResponses, BrandMissionTagsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandMissionTags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Deletes a mission tag
 */
export const brandMissionTagsDelete = <ThrowOnError extends boolean = false>(options: Options<BrandMissionTagsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandMissionTagsDeleteResponses, BrandMissionTagsDeleteErrors, ThrowOnError>({
        url: '/api/v2/brandMissionTags/{uuid}',
        ...options
    });
};

/**
 * Retrieves a mission tag by UUID
 */
export const brandMissionTagsRead = <ThrowOnError extends boolean = false>(options: Options<BrandMissionTagsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandMissionTagsReadResponses, BrandMissionTagsReadErrors, ThrowOnError>({
        url: '/api/v2/brandMissionTags/{uuid}',
        ...options
    });
};

/**
 * Updates a mission tag
 */
export const brandMissionTagsUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandMissionTagsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandMissionTagsUpdateResponses, BrandMissionTagsUpdateErrors, ThrowOnError>({
        url: '/api/v2/brandMissionTags/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the brand's own email domains — members on them are treated as the brand's staff in reporting.
 */
export const brandInternalEmailDomainsReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandInternalEmailDomainsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandInternalEmailDomainsReadManyResponses, BrandInternalEmailDomainsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandInternalEmailDomains',
        ...options
    });
};

/**
 * Add one of the brand's own email domains (e.g. kyriba.com). Members on it count as the brand's staff and are left out of reporting and reference matching unless a report asks for them. Public providers (gmail.com…) are refused. Idempotent.
 */
export const brandInternalEmailDomainsCreate = <ThrowOnError extends boolean = false>(options: Options<BrandInternalEmailDomainsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandInternalEmailDomainsCreateResponses, BrandInternalEmailDomainsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandInternalEmailDomains',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Remove one of the brand's internal email domains by UUID.
 */
export const brandInternalEmailDomainsDelete = <ThrowOnError extends boolean = false>(options: Options<BrandInternalEmailDomainsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandInternalEmailDomainsDeleteResponses, BrandInternalEmailDomainsDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandInternalEmailDomains/{uuid}',
        ...options
    });
};

/**
 * Read the brand's signup config (per-brand singleton). `null` means no row: the mission-submission path then skips the rules and leaves the submission for review, while the internal signupGuardsCheck endpoint falls back to defaultAction 'approve'.
 */
export const brandSignupConfigsRead = <ThrowOnError extends boolean = false>(options?: Options<BrandSignupConfigsReadData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandSignupConfigsReadResponses, BrandSignupConfigsReadErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandSignupConfig',
        ...options
    });
};

/**
 * Set the brand's signup config (per-brand singleton) — creates the row on first write.
 */
export const brandSignupConfigsUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandSignupConfigsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandSignupConfigsUpdateResponses, BrandSignupConfigsUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandSignupConfig',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get conditions schema for the signup-rule builder
 *
 * Returns the signup-context field surface for the rule builder, shaped per brand (SSO attribute vocabulary) and per requested hydratorType.
 */
export const brandSignupRulesConditionsSchema = <ThrowOnError extends boolean = false>(options?: Options<BrandSignupRulesConditionsSchemaData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandSignupRulesConditionsSchemaResponses, BrandSignupRulesConditionsSchemaErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandSignupRules/conditionsSchema',
        ...options
    });
};

/**
 * List the brand's signup rules. They do not run at signup: they are evaluated on submissions to a mission whose auto-approval is set to signupRules, and on the internal signupGuardsCheck advisory endpoint.
 */
export const brandSignupRulesReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandSignupRulesReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandSignupRulesReadManyResponses, BrandSignupRulesReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandSignupRules',
        ...options
    });
};

/**
 * Create a signup rule. Conditions are validated against the brand's signup context surface before the rule is saved.
 */
export const brandSignupRulesCreate = <ThrowOnError extends boolean = false>(options: Options<BrandSignupRulesCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandSignupRulesCreateResponses, BrandSignupRulesCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandSignupRules',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a signup rule by UUID. Hard delete — the model has no soft-delete column; decision history lives on BrandSignupAudit snapshots.
 */
export const brandSignupRulesDelete = <ThrowOnError extends boolean = false>(options: Options<BrandSignupRulesDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandSignupRulesDeleteResponses, BrandSignupRulesDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandSignupRules/{uuid}',
        ...options
    });
};

/**
 * Update a signup rule. Changed conditions re-run the same save-time validation as create.
 */
export const brandSignupRulesUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandSignupRulesUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandSignupRulesUpdateResponses, BrandSignupRulesUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandSignupRules/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all brands
 *
 * Returns the list of all brands with their configuration. Requires super admin permissions.
 */
export const brandsReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandsReadManyResponses, BrandsReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brands',
        ...options
    });
};

/**
 * Get brand details
 *
 * Returns a Brand with its config. Query by uuid, brandID, or code (a brand code or name). Priority: uuid > brandID > code.
 */
export const brandsLookup = <ThrowOnError extends boolean = false>(options?: Options<BrandsLookupData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandsLookupResponses, BrandsLookupErrors, ThrowOnError>({
        url: '/api/v2/brands/lookup',
        ...options
    });
};

/**
 * List brands for the environment brand picker
 *
 * Returns uuid and name for every brand, for the advocate-portal brand picker on the no-brand fallback screen. Available in every environment except production, where it 404s.
 */
export const brandsPickerMany = <ThrowOnError extends boolean = false>(options?: Options<BrandsPickerManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandsPickerManyResponses, BrandsPickerManyErrors, ThrowOnError>({
        url: '/api/v2/brands/picker',
        ...options
    });
};

/**
 * List the brands the signed-in person belongs to
 *
 * The brands this person is an advocate at, with the name, logo and primary colour needed to show them a choice. Answers which brand before one is known, so it carries no brand of its own. A person with one brand gets one row; the caller decides whether that is worth showing.
 */
export const brandsMineMany = <ThrowOnError extends boolean = false>(options?: Options<BrandsMineManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandsMineManyResponses, BrandsMineManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brands/mine',
        ...options
    });
};

/**
 * Get a brand
 *
 * Returns a Brand with its config, by uuid, or by the column named in `lookup` (code, brandName or brandID).
 */
export const brandsRead = <ThrowOnError extends boolean = false>(options: Options<BrandsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandsReadResponses, BrandsReadErrors, ThrowOnError>({
        url: '/api/v2/brands/{uuid}',
        ...options
    });
};

/**
 * Read invitation token
 *
 * Reads an invitation token and returns invitation details for form pre-population. Does not consume the token.
 */
export const brandUserInvitationsToken = <ThrowOnError extends boolean = false>(options: Options<BrandUserInvitationsTokenData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandUserInvitationsTokenResponses, BrandUserInvitationsTokenErrors, ThrowOnError>({
        url: '/api/v2/brandUserInvitations/{token}',
        ...options
    });
};

/**
 * Creates a new Comment for a Comment.
 */
export const commentsCommentCreate = <ThrowOnError extends boolean = false>(options: Options<CommentsCommentCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<CommentsCommentCreateResponses, CommentsCommentCreateErrors, ThrowOnError>({
        url: '/api/v2/comment/{uuid}/comments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Deletes an existing Comment.
 */
export const commentsDelete = <ThrowOnError extends boolean = false>(options: Options<CommentsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<CommentsDeleteResponses, CommentsDeleteErrors, ThrowOnError>({
        url: '/api/v2/comment/{uuid}',
        ...options
    });
};

/**
 * Updates an existing Comment.
 */
export const commentsUpdate = <ThrowOnError extends boolean = false>(options: Options<CommentsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<CommentsUpdateResponses, CommentsUpdateErrors, ThrowOnError>({
        url: '/api/v2/comment/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Performs like action on Comment.
 */
export const commentsLike = <ThrowOnError extends boolean = false>(options: Options<CommentsLikeData, ThrowOnError>) => {
    return (options.client ?? client).post<CommentsLikeResponses, CommentsLikeErrors, ThrowOnError>({
        url: '/api/v2/comment/{uuid}/like',
        ...options
    });
};

/**
 * Performs unlike action on Comment.
 */
export const commentsUnlike = <ThrowOnError extends boolean = false>(options: Options<CommentsUnlikeData, ThrowOnError>) => {
    return (options.client ?? client).post<CommentsUnlikeResponses, CommentsUnlikeErrors, ThrowOnError>({
        url: '/api/v2/comment/{uuid}/unlike',
        ...options
    });
};

/**
 * Retrieve all saved views for the current brand
 */
export const savedViewsReadMany = <ThrowOnError extends boolean = false>(options?: Options<SavedViewsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<SavedViewsReadManyResponses, SavedViewsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/v2/savedViews',
        ...options
    });
};

/**
 * Create a new saved view
 */
export const savedViewsCreate = <ThrowOnError extends boolean = false>(options: Options<SavedViewsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<SavedViewsCreateResponses, SavedViewsCreateErrors, ThrowOnError>({
        url: '/api/v2/savedViews',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a saved view (soft delete)
 */
export const savedViewsDelete = <ThrowOnError extends boolean = false>(options: Options<SavedViewsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<SavedViewsDeleteResponses, SavedViewsDeleteErrors, ThrowOnError>({
        url: '/api/v2/savedViews/{uuid}',
        ...options
    });
};

/**
 * Update a saved view
 */
export const savedViewsUpdate = <ThrowOnError extends boolean = false>(options: Options<SavedViewsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<SavedViewsUpdateResponses, SavedViewsUpdateErrors, ThrowOnError>({
        url: '/api/v2/savedViews/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the brand's custom field definitions: the fields stored on advocates (targetModel FanUsers), on deals (Opportunity), and the fields of the brand's reference request form (BrandReferenceRequest). Pass targetModel to get one group only. Read targetModel=BrandReferenceRequest before you create a reference request. Each field has its label, whether it is required, whether it is read-only, and a showIf when it applies only to some answers. Use for "list custom fields", "what advocate attributes exist", "show custom properties", "what does the reference request form ask for".
 */
export const customFieldDefinitionsReadMany = <ThrowOnError extends boolean = false>(options?: Options<CustomFieldDefinitionsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<CustomFieldDefinitionsReadManyResponses, CustomFieldDefinitionsReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/customFieldDefinition',
        ...options
    });
};

/**
 * Create a custom field definition — a custom attribute (e.g. company, tier, region) stored on advocates. Use for "add a custom field", "define a new advocate attribute", "create a custom property".
 */
export const customFieldDefinitionsCreate = <ThrowOnError extends boolean = false>(options: Options<CustomFieldDefinitionsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<CustomFieldDefinitionsCreateResponses, CustomFieldDefinitionsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/customFieldDefinition',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Soft delete a custom field definition by UUID.
 */
export const customFieldDefinitionsDelete = <ThrowOnError extends boolean = false>(options: Options<CustomFieldDefinitionsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<CustomFieldDefinitionsDeleteResponses, CustomFieldDefinitionsDeleteErrors, ThrowOnError>({
        url: '/api/v2/customFieldDefinition/{uuid}',
        ...options
    });
};

/**
 * Update an existing custom field definition.
 */
export const customFieldDefinitionsUpdate = <ThrowOnError extends boolean = false>(options: Options<CustomFieldDefinitionsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<CustomFieldDefinitionsUpdateResponses, CustomFieldDefinitionsUpdateErrors, ThrowOnError>({
        url: '/api/v2/customFieldDefinition/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Read the person behind the signed-in session
 *
 * The person this session belongs to, independent of any brand. Answers "who am I" rather than "who am I at this brand", so it carries no brand of its own and a ban at one brand does not hide it. Returns 404 while a session has no person row yet, which is the state until memberships are linked to one.
 */
export const usersMe = <ThrowOnError extends boolean = false>(options?: Options<UsersMeData, ThrowOnError>) => {
    return (options?.client ?? client).get<UsersMeResponses, UsersMeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/users/me',
        ...options
    });
};

/**
 * List the people this brand holds any record of, one row per person, with every handle the brand has on them: their advocate memberships, their admin accounts, and the reference records where they are the prospect. Filter by `email` to answer "do you hold this address" — an empty page means no record of that person, which is the question a privacy request asks.
 */
export const usersReadMany = <ThrowOnError extends boolean = false>(options?: Options<UsersReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<UsersReadManyResponses, UsersReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/users',
        ...options
    });
};

/**
 * Suppress an email address for this brand — the generic, source-agnostic do-not-contact write. Intended for external list managers (Securiti via Workato, Mailchimp, …) calling with an org API token: the token binds the brand and attributes the write, so no integration-specific endpoint exists per source. The row applies to this brand; send-time policy determines which categories it suppresses. Until SendMessage-Writer, SendEmail-Writer and Scheduler are redeployed with the scoped policy, this endpoint also cascades to the legacy global suppression store. Idempotent: alreadySuppressed is true only when both stores already held the suppression; a missing legacy row is repaired without repeating notes or events.
 */
export const emailSuppressionsCreate = <ThrowOnError extends boolean = false>(options: Options<EmailSuppressionsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<EmailSuppressionsCreateResponses, EmailSuppressionsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/emailSuppression',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get email subscriptions for the current member
 *
 * Retrieves an existing EmailSuppression.
 */
export const emailSuppressionsReadMe = <ThrowOnError extends boolean = false>(options?: Options<EmailSuppressionsReadMeData, ThrowOnError>) => {
    return (options?.client ?? client).get<EmailSuppressionsReadMeResponses, EmailSuppressionsReadMeErrors, ThrowOnError>({
        url: '/api/v2/emailSuppression/me',
        ...options
    });
};

/**
 * Update email subscriptions for the current member
 *
 * Embed sessions can only read email subscriptions. Other sessions can change brand email consent, for one bucket or for all buckets. Email code, email link, SSO, and password sessions can also lift an existing global opt-out.
 */
export const emailSuppressionsUpdateMe = <ThrowOnError extends boolean = false>(options: Options<EmailSuppressionsUpdateMeData, ThrowOnError>) => {
    return (options.client ?? client).patch<EmailSuppressionsUpdateMeResponses, EmailSuppressionsUpdateMeErrors, ThrowOnError>({
        url: '/api/v2/emailSuppression/me',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Connection health: the caller token’s brand + integration source, and webhook health per model.
 */
export const apiTokensConnection = <ThrowOnError extends boolean = false>(options?: Options<ApiTokensConnectionData, ThrowOnError>) => {
    return (options?.client ?? client).get<ApiTokensConnectionResponses, ApiTokensConnectionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/apiToken/connection',
        ...options
    });
};

/**
 * List the brand integration tokens for the brand (key material redacted).
 */
export const apiTokensReadMany = <ThrowOnError extends boolean = false>(options?: Options<ApiTokensReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<ApiTokensReadManyResponses, ApiTokensReadManyErrors, ThrowOnError>({
        url: '/api/v2/apiToken',
        ...options
    });
};

/**
 * Mint a brand integration token. The raw key is returned once and never again.
 */
export const apiTokensCreate = <ThrowOnError extends boolean = false>(options: Options<ApiTokensCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<ApiTokensCreateResponses, ApiTokensCreateErrors, ThrowOnError>({
        url: '/api/v2/apiToken',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Per-brand MCP usage summary: each token's call totals plus a per-tool breakdown over the window.
 */
export const apiTokensUsage = <ThrowOnError extends boolean = false>(options?: Options<ApiTokensUsageData, ThrowOnError>) => {
    return (options?.client ?? client).get<ApiTokensUsageResponses, ApiTokensUsageErrors, ThrowOnError>({
        url: '/api/v2/apiToken/usage',
        ...options
    });
};

/**
 * Revoke (delete) a brand token by UUID.
 */
export const apiTokensDelete = <ThrowOnError extends boolean = false>(options: Options<ApiTokensDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<ApiTokensDeleteResponses, ApiTokensDeleteErrors, ThrowOnError>({
        url: '/api/v2/apiToken/{uuid}',
        ...options
    });
};

/**
 * List the brand's own MJML email components plus the platform library.
 */
export const emailComponentsReadMany = <ThrowOnError extends boolean = false>(options?: Options<EmailComponentsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<EmailComponentsReadManyResponses, EmailComponentsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/emailComponent',
        ...options
    });
};

/**
 * Create a reusable MJML email component — a building block that can be embedded in the brand's email templates. Use for "create an email component", "add a reusable email block".
 */
export const emailComponentsCreate = <ThrowOnError extends boolean = false>(options: Options<EmailComponentsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<EmailComponentsCreateResponses, EmailComponentsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/emailComponent',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a reusable MJML email component by UUID. Use for "delete an email component", "remove a reusable email block".
 */
export const emailComponentsDelete = <ThrowOnError extends boolean = false>(options: Options<EmailComponentsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<EmailComponentsDeleteResponses, EmailComponentsDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/emailComponent/{uuid}',
        ...options
    });
};

/**
 * Update a reusable MJML email component (its slug, MJML, or locale). Use for "edit an email component", "change a reusable email block".
 */
export const emailComponentsUpdate = <ThrowOnError extends boolean = false>(options: Options<EmailComponentsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<EmailComponentsUpdateResponses, EmailComponentsUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/emailComponent/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get email notification preferences
 *
 * Get the current user's email notification preferences. Auto-creates defaults if none exist.
 */
export const emailNotificationPreferencesRead = <ThrowOnError extends boolean = false>(options?: Options<EmailNotificationPreferencesReadData, ThrowOnError>) => {
    return (options?.client ?? client).get<EmailNotificationPreferencesReadResponses, EmailNotificationPreferencesReadErrors, ThrowOnError>({
        url: '/api/v2/emailNotificationPreference',
        ...options
    });
};

/**
 * Update email notification preferences
 *
 * Update one or more email notification preferences for the current user.
 */
export const emailNotificationPreferencesUpdate = <ThrowOnError extends boolean = false>(options: Options<EmailNotificationPreferencesUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<EmailNotificationPreferencesUpdateResponses, EmailNotificationPreferencesUpdateErrors, ThrowOnError>({
        url: '/api/v2/emailNotificationPreference',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the MJML email templates available to the brand — its own rows plus the platform defaults it inherits, each tagged with its ownerTier.
 */
export const mjmlEmailTemplatesReadMany = <ThrowOnError extends boolean = false>(options?: Options<MjmlEmailTemplatesReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<MjmlEmailTemplatesReadManyResponses, MjmlEmailTemplatesReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/v2/emailTemplate',
        ...options
    });
};

/**
 * Create an MJML email template for the brand.
 */
export const mjmlEmailTemplatesCreate = <ThrowOnError extends boolean = false>(options: Options<MjmlEmailTemplatesCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<MjmlEmailTemplatesCreateResponses, MjmlEmailTemplatesCreateErrors, ThrowOnError>({
        url: '/api/v2/emailTemplate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Soft delete an MJML email template by UUID.
 */
export const mjmlEmailTemplatesDelete = <ThrowOnError extends boolean = false>(options: Options<MjmlEmailTemplatesDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<MjmlEmailTemplatesDeleteResponses, MjmlEmailTemplatesDeleteErrors, ThrowOnError>({
        url: '/api/v2/emailTemplate/{uuid}',
        ...options
    });
};

/**
 * Update an MJML email template.
 */
export const mjmlEmailTemplatesUpdate = <ThrowOnError extends boolean = false>(options: Options<MjmlEmailTemplatesUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<MjmlEmailTemplatesUpdateResponses, MjmlEmailTemplatesUpdateErrors, ThrowOnError>({
        url: '/api/v2/emailTemplate/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Render MJML to HTML with sample data for a live authoring preview (no persistence).
 */
export const mjmlEmailTemplatesPreview = <ThrowOnError extends boolean = false>(options: Options<MjmlEmailTemplatesPreviewData, ThrowOnError>) => {
    return (options.client ?? client).post<MjmlEmailTemplatesPreviewResponses, MjmlEmailTemplatesPreviewErrors, ThrowOnError>({
        url: '/api/v2/emailTemplate/preview',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Deliverability preflight for a draft: renders it with sample data and reports content findings (subject, preheader, unsubscribe link, image alt text, tokens that do not resolve, spam-trigger phrases). Observation only — nothing is persisted or blocked.
 */
export const mjmlEmailTemplatesPreflight = <ThrowOnError extends boolean = false>(options: Options<MjmlEmailTemplatesPreflightData, ThrowOnError>) => {
    return (options.client ?? client).post<MjmlEmailTemplatesPreflightResponses, MjmlEmailTemplatesPreflightErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/emailTemplate/preflight',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Composed authoring lens (recipient ∪ sender ∪ the slug's context) + brand-scoped option sets for the conditional-block builder.
 */
export const mjmlEmailTemplatesRuleSurface = <ThrowOnError extends boolean = false>(options: Options<MjmlEmailTemplatesRuleSurfaceData, ThrowOnError>) => {
    return (options.client ?? client).post<MjmlEmailTemplatesRuleSurfaceResponses, MjmlEmailTemplatesRuleSurfaceErrors, ThrowOnError>({
        url: '/api/v2/emailTemplate/ruleSurface',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the brand's email templates (brand-owned + shared platform) minus the ones this brand has dismissed.
 */
export const emailTemplatesReadMany = <ThrowOnError extends boolean = false>(options?: Options<EmailTemplatesReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<EmailTemplatesReadManyResponses, EmailTemplatesReadManyErrors, ThrowOnError>({
        url: '/api/v2/emailTemplates',
        ...options
    });
};

/**
 * Delete an email template. Brand-owned templates are hard-deleted; shared platform templates are dismissed for the calling brand only, leaving the shared row intact for every other brand.
 */
export const emailTemplatesDelete = <ThrowOnError extends boolean = false>(options: Options<EmailTemplatesDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<EmailTemplatesDeleteResponses, EmailTemplatesDeleteErrors, ThrowOnError>({
        url: '/api/v2/emailTemplates/{uuid}',
        ...options
    });
};

/**
 * List the brand's own AI prompts — the guidance it adds after the platform prompt for each key (e.g. referenceMatch for drafting reference match criteria).
 */
export const promptsReadMany = <ThrowOnError extends boolean = false>(options?: Options<PromptsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<PromptsReadManyResponses, PromptsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/prompt',
        ...options
    });
};

/**
 * Create the brand's prompt for a key. A brand holds at most one prompt per key; a second create is a 409.
 */
export const promptsCreate = <ThrowOnError extends boolean = false>(options: Options<PromptsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<PromptsCreateResponses, PromptsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/prompt',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update the text of one of the brand's own prompts.
 */
export const promptsUpdate = <ThrowOnError extends boolean = false>(options: Options<PromptsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<PromptsUpdateResponses, PromptsUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/prompt/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a fan user enrichment by UUID.
 */
export const fanUserEnrichmentsDelete = <ThrowOnError extends boolean = false>(options: Options<FanUserEnrichmentsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<FanUserEnrichmentsDeleteResponses, FanUserEnrichmentsDeleteErrors, ThrowOnError>({
        url: '/api/v2/fanUserEnrichment/{uuid}',
        ...options
    });
};

/**
 * Update a fan user enrichment by UUID.
 */
export const fanUserEnrichmentsUpdate = <ThrowOnError extends boolean = false>(options: Options<FanUserEnrichmentsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<FanUserEnrichmentsUpdateResponses, FanUserEnrichmentsUpdateErrors, ThrowOnError>({
        url: '/api/v2/fanUserEnrichment/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Write an integration’s field values for members of the token’s brand, matched by address inside the brand. A field missing from a record clears that member’s value for it.
 */
export const fanUserEnrichmentsIngest = <ThrowOnError extends boolean = false>(options: Options<FanUserEnrichmentsIngestData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUserEnrichmentsIngestResponses, FanUserEnrichmentsIngestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUserEnrichment/ingest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Soft-deletes a note by UUID. Only the note's author, or a superadmin, may delete it.
 */
export const notesDelete = <ThrowOnError extends boolean = false>(options: Options<NotesDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<NotesDeleteResponses, NotesDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/note/{uuid}',
        ...options
    });
};

/**
 * Retrieves application data for a user by email. Used to pre-fill onboarding forms with existing application data.
 */
export const fanApplicationsReadByEmail = <ThrowOnError extends boolean = false>(options: Options<FanApplicationsReadByEmailData, ThrowOnError>) => {
    return (options.client ?? client).get<FanApplicationsReadByEmailResponses, FanApplicationsReadByEmailErrors, ThrowOnError>({
        url: '/api/v2/fanApplications/byEmail',
        ...options
    });
};

/**
 * Submit an application to a brand from its public application form. Unauthenticated: the brand comes from `brandUuid`, every answer must name a field of that brand's form, and the brand's application logic may auto-approve the applicant. Always 204 on success, whatever the outcome.
 */
export const fanApplicationsCreate = <ThrowOnError extends boolean = false>(options: Options<FanApplicationsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<FanApplicationsCreateResponses, FanApplicationsCreateErrors, ThrowOnError>({
        url: '/api/v2/fanApplications',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the authenticated fan's submission history
 *
 * Returns the authenticated fan's mission submissions with derived status (pending/approved/rejected), brand name, mission name, and feedback. Rejected submissions are included.
 */
export const fanMissionsSubmissionsMany = <ThrowOnError extends boolean = false>(options?: Options<FanMissionsSubmissionsManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanMissionsSubmissionsManyResponses, FanMissionsSubmissionsManyErrors, ThrowOnError>({
        url: '/api/v2/fanMissions/submissions',
        ...options
    });
};

/**
 * Cursor-paginated full read of fan missions (managed-package backstop for dropped webhooks).
 */
export const fanMissionsSyncMany = <ThrowOnError extends boolean = false>(options?: Options<FanMissionsSyncManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanMissionsSyncManyResponses, FanMissionsSyncManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanMissions/sync',
        ...options
    });
};

/**
 * Cursor-paginated id + version manifest of fan missions for scan/diff (no full payloads).
 */
export const fanMissionsManifestMany = <ThrowOnError extends boolean = false>(options?: Options<FanMissionsManifestManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanMissionsManifestManyResponses, FanMissionsManifestManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanMissions/manifest',
        ...options
    });
};

/**
 * Start (or resume) a video testimonial for the authenticated fan
 *
 * Opens the draft FanMission the recorder writes answers into. Idempotent per fan and mission: an existing draft is returned, a pending or already-approved one-off submission is reported as alreadySubmitted.
 */
export const fanMissionsStartTestimonial = <ThrowOnError extends boolean = false>(options: Options<FanMissionsStartTestimonialData, ThrowOnError>) => {
    return (options.client ?? client).post<FanMissionsStartTestimonialResponses, FanMissionsStartTestimonialErrors, ThrowOnError>({
        url: '/api/v2/fanMissions/startTestimonial',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Record one testimonial answer on the authenticated fan's submission
 *
 * Stores the recorded media for one question, rebuilds the submission's mediaURL array in question order and moves a draft to pending once every question has an answer.
 */
export const fanMissionsTestimonialAnswer = <ThrowOnError extends boolean = false>(options: Options<FanMissionsTestimonialAnswerData, ThrowOnError>) => {
    return (options.client ?? client).post<FanMissionsTestimonialAnswerResponses, FanMissionsTestimonialAnswerErrors, ThrowOnError>({
        url: '/api/v2/fanMissions/{uuid}/testimonialAnswer',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Submit a mission as the authenticated advocate
 *
 * Creates a new submission for the mission. Refused with 409 once the advocate has used every submission the mission allows within its frequency period, or when the mission has no budget left.
 */
export const fanMissionsCreate = <ThrowOnError extends boolean = false>(options: Options<FanMissionsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<FanMissionsCreateResponses, FanMissionsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanMissions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Log a manual advocate activity
 *
 * Logs an admin-recorded activity as a FanMission on the brand's MANUAL-type mission.
 */
export const fanMissionsCreateManual = <ThrowOnError extends boolean = false>(options: Options<FanMissionsCreateManualData, ThrowOnError>) => {
    return (options.client ?? client).post<FanMissionsCreateManualResponses, FanMissionsCreateManualErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanMissions/createManual',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete the authenticated fan's pending submission
 *
 * Deletes one of the authenticated fan's mission submissions. Returns 404 if the submission does not belong to the authenticated fan.
 */
export const fanMissionsDelete = <ThrowOnError extends boolean = false>(options: Options<FanMissionsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<FanMissionsDeleteResponses, FanMissionsDeleteErrors, ThrowOnError>({
        url: '/api/v2/fanMissions/{uuid}',
        ...options
    });
};

/**
 * Updates descriptive fields on an existing fan mission submission (feedback, mediaURL, thumbnailURL, socialPlatform). Reward, state, and provenance columns are not writable through this route.
 */
export const fanMissionsUpdate = <ThrowOnError extends boolean = false>(options: Options<FanMissionsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<FanMissionsUpdateResponses, FanMissionsUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanMissions/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Edit a logged manual advocate activity
 *
 * Edits an admin-logged activity on the brand's MANUAL-type mission. Changing its points is refused with 409 and the details support needs.
 */
export const fanMissionsUpdateManual = <ThrowOnError extends boolean = false>(options: Options<FanMissionsUpdateManualData, ThrowOnError>) => {
    return (options.client ?? client).patch<FanMissionsUpdateManualResponses, FanMissionsUpdateManualErrors, ThrowOnError>({
        url: '/api/v2/fanMissions/{uuid}/updateManual',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a logged manual advocate activity
 *
 * Deletes an admin-logged activity on the brand's MANUAL-type mission. An activity that carries points is refused with 409 and the details support needs.
 */
export const fanMissionsDeleteManual = <ThrowOnError extends boolean = false>(options: Options<FanMissionsDeleteManualData, ThrowOnError>) => {
    return (options.client ?? client).post<FanMissionsDeleteManualResponses, FanMissionsDeleteManualErrors, ThrowOnError>({
        url: '/api/v2/fanMissions/{uuid}/deleteManual',
        ...options
    });
};

/**
 * Dismiss a rejected submission's auto-popup for the authenticated fan
 *
 * Marks one of the authenticated fan's rejected submissions as dismissed so the rejection auto-popup is not shown again.
 */
export const fanMissionsDismissRejection = <ThrowOnError extends boolean = false>(options: Options<FanMissionsDismissRejectionData, ThrowOnError>) => {
    return (options.client ?? client).post<FanMissionsDismissRejectionResponses, FanMissionsDismissRejectionErrors, ThrowOnError>({
        url: '/api/v2/fanMissions/dismissRejection',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get the authenticated fan's consolidated points ledger
 *
 * Returns the authenticated fan's current points balance plus a consolidated, bank-statement-style ledger of every point-earning event (missions, referrals, manual engagements, admin adjustments, badges) and point-spending event (redemptions), newest first, each with a running balance.
 */
export const fanPointsLedger = <ThrowOnError extends boolean = false>(options?: Options<FanPointsLedgerData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanPointsLedgerResponses, FanPointsLedgerErrors, ThrowOnError>({
        url: '/api/v2/fanPoints/ledger',
        ...options
    });
};

/**
 * Get recent activity for a fan user including missions, rewards, forum activity, and communications.
 */
export const fanUsersFanUserUuidActivity = <ThrowOnError extends boolean = false>(options: Options<FanUsersFanUserUuidActivityData, ThrowOnError>) => {
    return (options.client ?? client).get<FanUsersFanUserUuidActivityResponses, FanUsersFanUserUuidActivityErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUserActivity/{fanUserUuid}/activity',
        ...options
    });
};

/**
 * Get current fan user
 *
 * Returns the authenticated fan user's identity (uuid, name, email, picture). Use the returned `uuid` as the canonical FanUsers identifier — never the email.
 */
export const fanUsersMe = <ThrowOnError extends boolean = false>(options?: Options<FanUsersMeData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanUsersMeResponses, FanUsersMeErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/me',
        ...options
    });
};

/**
 * Update current fan user profile
 *
 * Updates the authenticated fan user's own profile: name, picture, phone number, email and job title. The member is the session; no identifier is accepted on the wire.
 */
export const fanUsersMeUpdate = <ThrowOnError extends boolean = false>(options: Options<FanUsersMeUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<FanUsersMeUpdateResponses, FanUsersMeUpdateErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/me',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bans a batch of this brand’s members: blocks their login and hides them from every read, while keeping their record and PII visible in the members table. Reversible with bulkUnban. Members already banned are reported as skipped; uuids outside the caller’s brand are reported as failed. The request resolves 200 unless validation fails.
 */
export const fanUsersBulkBanMany = <ThrowOnError extends boolean = false>(options: Options<FanUsersBulkBanManyData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersBulkBanManyResponses, FanUsersBulkBanManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/bulkBan',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Permanently erases a batch of this brand’s members: redacts their personal data, moves the address off the row so it can never be reached again, and records a block so it cannot re-register here. Optionally soft-deletes the forum content they wrote. This cannot be undone — use bulkBan for anything reversible. Members already erased are reported as skipped; uuids outside the caller’s brand are reported as failed.
 */
export const fanUsersBulkEraseMany = <ThrowOnError extends boolean = false>(options: Options<FanUsersBulkEraseManyData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersBulkEraseManyResponses, FanUsersBulkEraseManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/bulkErase',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Lifts a ban on a batch of this brand’s members, restoring their login and their forum memberships. Members who are not banned are reported as skipped; erased members cannot be unbanned and are reported as failed.
 */
export const fanUsersBulkUnbanMany = <ThrowOnError extends boolean = false>(options: Options<FanUsersBulkUnbanManyData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersBulkUnbanManyResponses, FanUsersBulkUnbanManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/bulkUnban',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add the current fan user to a segment
 *
 * Adds the authenticated fan user to a segment (Groups row), used to honour a segment invite link after sign-up. The fan user is taken from the JWT — never the request body — so a client cannot enroll an arbitrary user. Idempotent: a fan already in the segment returns alreadyMember=true without creating a duplicate.
 */
export const fanUsersJoinSegment = <ThrowOnError extends boolean = false>(options: Options<FanUsersJoinSegmentData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersJoinSegmentResponses, FanUsersJoinSegmentErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/joinSegment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a paginated, searchable, sortable list of the brand's advocates (fan users / community members). Search, sort (orderBy) and filters (incl. the reference pool via searchFields[referenceOptIn]) flow through the bracket-query lens. Use this for "list all advocates", "show our members / community", "find advocates who opted into references".
 */
export const fanUsersReadMany = <ThrowOnError extends boolean = false>(options?: Options<FanUsersReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanUsersReadManyResponses, FanUsersReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers',
        ...options
    });
};

/**
 * Manually create a single fan-user advocate with optional segment assignments, custom-field enrichments, and reference flag. Atomic — all rows land in one transaction.
 */
export const fanUsersCreate = <ThrowOnError extends boolean = false>(options: Options<FanUsersCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersCreateResponses, FanUsersCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Cursor-paginated full read of fan users (managed-package backstop for dropped webhooks).
 */
export const fanUsersSyncMany = <ThrowOnError extends boolean = false>(options?: Options<FanUsersSyncManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanUsersSyncManyResponses, FanUsersSyncManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/sync',
        ...options
    });
};

/**
 * Cursor-paginated id + version manifest of fan users for scan/diff (no full payloads).
 */
export const fanUsersManifestMany = <ThrowOnError extends boolean = false>(options?: Options<FanUsersManifestManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanUsersManifestManyResponses, FanUsersManifestManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/manifest',
        ...options
    });
};

/**
 * Bulk-create advocates for the brand from a list of contacts (idempotent upsert by email).
 */
export const fanUsersBulkImport = <ThrowOnError extends boolean = false>(options: Options<FanUsersBulkImportData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersBulkImportResponses, FanUsersBulkImportErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/bulkImport',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Register a new advocate fan user
 *
 * Self-registration for advocates. Owns Auth0 user creation (when password supplied), signup-guard evaluation, FanUser provisioning, and downstream side effects (forum init, segment enrollment, dynamic-group reconciliation, Member Joined notification). Replaces the legacy POST /register-user/add (type=fan) Express endpoint.
 */
export const fanUsersRegister = <ThrowOnError extends boolean = false>(options: Options<FanUsersRegisterData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersRegisterResponses, FanUsersRegisterErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Check whether an email is banned before login
 *
 * Resolves the FanUser for the email (userID is the global PK, so the ban is not brand-scoped) and throws USER_BANNED (403) if it is soft-deleted (banned). Lets the login screen surface the banned outcome before Auth0 returns an opaque invalid_grant.
 */
export const fanUsersCheckBanStatus = <ThrowOnError extends boolean = false>(options: Options<FanUsersCheckBanStatusData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersCheckBanStatusResponses, FanUsersCheckBanStatusErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/checkBanStatus',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get member directory for the current brand. Requires fan user authentication. Returns 403 if directory is disabled.
 */
export const fanUsersDirectoryMany = <ThrowOnError extends boolean = false>(options?: Options<FanUsersDirectoryManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanUsersDirectoryManyResponses, FanUsersDirectoryManyErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/directory',
        ...options
    });
};

/**
 * Get the top N users by points for the current brand, plus the authenticated user position if not in the top N.
 */
export const fanUsersLeaderboard = <ThrowOnError extends boolean = false>(options?: Options<FanUsersLeaderboardData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanUsersLeaderboardResponses, FanUsersLeaderboardErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/leaderboard',
        ...options
    });
};

/**
 * Updates an existing fan user profile. Supports name, picture, and system fields (jobTitle, companyDomain, phoneNumber) and the internal-staff flag (isInternal: null = derive from the brand internal email domains). Email cannot be changed.
 */
export const fanUsersUpdate = <ThrowOnError extends boolean = false>(options: Options<FanUsersUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<FanUsersUpdateResponses, FanUsersUpdateErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generate a JWT token for fan user authentication in embed contexts. Returns a short-lived token that can be used for subsequent API calls.
 */
export const fanUsersToken = <ThrowOnError extends boolean = false>(options: Options<FanUsersTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersTokenResponses, FanUsersTokenErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get fan users with referenceOptIn=true for a given reference request. No authentication required.
 */
export const fanUsersReferenceOptInMany = <ThrowOnError extends boolean = false>(options: Options<FanUsersReferenceOptInManyData, ThrowOnError>) => {
    return (options.client ?? client).get<FanUsersReferenceOptInManyResponses, FanUsersReferenceOptInManyErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/referenceOptIn',
        ...options
    });
};

/**
 * Get the paginated community members table: the brand's advocates (fan users / members) with person attributes, advocacy scores, and last-ask data. Rank/top-N advocates here: orderBy latestAdvocateScore.lastActivityAt (most active / most recent activity) or latestAdvocateScore.overallScore (highest score) descending, with a small pageSize. Use this for "the members table", "list advocates/members with their scores", "top/most active advocates", "rank advocates by activity or score".
 */
export const fanUsersMembersTableMany = <ThrowOnError extends boolean = false>(options?: Options<FanUsersMembersTableManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanUsersMembersTableManyResponses, FanUsersMembersTableManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/membersTable',
        ...options
    });
};

/**
 * Retrieve available filter options for the members table (segments, companies, titles, etc.)
 */
export const fanUsersMembersTableFilterOptionsMany = <ThrowOnError extends boolean = false>(options?: Options<FanUsersMembersTableFilterOptionsManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanUsersMembersTableFilterOptionsManyResponses, FanUsersMembersTableFilterOptionsManyErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/membersTableFilterOptions',
        ...options
    });
};

/**
 * Manually adjust an advocate's point balance. Positive amount adds points, negative subtracts.
 */
export const fanUsersAdjustPoints = <ThrowOnError extends boolean = false>(options: Options<FanUsersAdjustPointsData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersAdjustPointsResponses, FanUsersAdjustPointsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/{uuid}/adjustPoints',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Set a custom field value on an advocate (upserts the manual enrichment for that field).
 */
export const fanUsersSetCustomField = <ThrowOnError extends boolean = false>(options: Options<FanUsersSetCustomFieldData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersSetCustomFieldResponses, FanUsersSetCustomFieldErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/{uuid}/setCustomField',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Change an advocate's status (the advocateStatus custom field), recording the reason and appending an immutable status-history entry. A same-status request is a no-op.
 */
export const fanUsersAdvocateStatusChange = <ThrowOnError extends boolean = false>(options: Options<FanUsersAdvocateStatusChangeData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersAdvocateStatusChangeResponses, FanUsersAdvocateStatusChangeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/{uuid}/advocateStatusChange',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get analytics data for a fan user including profile, points, groups, enrichments, surveys, and season stats.
 */
export const fanUsersAnalytics = <ThrowOnError extends boolean = false>(options: Options<FanUsersAnalyticsData, ThrowOnError>) => {
    return (options.client ?? client).get<FanUsersAnalyticsResponses, FanUsersAnalyticsErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/{uuid}/analytics',
        ...options
    });
};

/**
 * Get a decorated fan user profile payload including analytics, raw integration data, resolved fields, content, notes, recent activity, and latest advocate score.
 */
export const fanUsersProfile = <ThrowOnError extends boolean = false>(options: Options<FanUsersProfileData, ThrowOnError>) => {
    return (options.client ?? client).get<FanUsersProfileResponses, FanUsersProfileErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/{uuid}/profile',
        ...options
    });
};

/**
 * Get all resolved custom field values for a fan user, including profile values and integration source alternatives.
 */
export const fanUsersResolvedFields = <ThrowOnError extends boolean = false>(options: Options<FanUsersResolvedFieldsData, ThrowOnError>) => {
    return (options.client ?? client).get<FanUsersResolvedFieldsResponses, FanUsersResolvedFieldsErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/{uuid}/resolvedFields',
        ...options
    });
};

/**
 * List fan user enrichments
 *
 * Retrieves all enrichments for a fan user with optional filters
 */
export const fanUsersFanUserEnrichmentsReadMany = <ThrowOnError extends boolean = false>(options: Options<FanUsersFanUserEnrichmentsReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<FanUsersFanUserEnrichmentsReadManyResponses, FanUsersFanUserEnrichmentsReadManyErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/{uuid}/fanUserEnrichments',
        ...options
    });
};

/**
 * Create fan user enrichment
 *
 * Creates a new enrichment for a fan user
 */
export const fanUsersFanUserEnrichmentsCreate = <ThrowOnError extends boolean = false>(options: Options<FanUsersFanUserEnrichmentsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersFanUserEnrichmentsCreateResponses, FanUsersFanUserEnrichmentsCreateErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/{uuid}/fanUserEnrichments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Refresh fan user enrichment data
 *
 * Triggers a one-time re-enrichment for a fan user by calling Workato webhooks for all configured integrations
 */
export const fanUsersFanUserEnrichmentsRefresh = <ThrowOnError extends boolean = false>(options: Options<FanUsersFanUserEnrichmentsRefreshData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersFanUserEnrichmentsRefreshResponses, FanUsersFanUserEnrichmentsRefreshErrors, ThrowOnError>({
        url: '/api/v2/fanUsers/{uuid}/fanUserEnrichments/refresh',
        ...options
    });
};

/**
 * List fan user notes
 *
 * Lists a fan user's notes, newest first.
 */
export const fanUsersNotesReadMany = <ThrowOnError extends boolean = false>(options: Options<FanUsersNotesReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<FanUsersNotesReadManyResponses, FanUsersNotesReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/{uuid}/notes',
        ...options
    });
};

/**
 * Add a fan user note
 *
 * Appends a timestamped, attributed note to a fan user (never overwrites prior notes).
 */
export const fanUsersNoteCreate = <ThrowOnError extends boolean = false>(options: Options<FanUsersNoteCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersNoteCreateResponses, FanUsersNoteCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanUsers/{uuid}/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get list of featured fan users for the current brand.
 */
export const featuredFanUsersReadMany = <ThrowOnError extends boolean = false>(options?: Options<FeaturedFanUsersReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FeaturedFanUsersReadManyResponses, FeaturedFanUsersReadManyErrors, ThrowOnError>({
        url: '/api/v2/featuredFanUsers',
        ...options
    });
};

/**
 * Create a new featured fan user.
 */
export const featuredFanUsersCreate = <ThrowOnError extends boolean = false>(options: Options<FeaturedFanUsersCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<FeaturedFanUsersCreateResponses, FeaturedFanUsersCreateErrors, ThrowOnError>({
        url: '/api/v2/featuredFanUsers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a featured fan user by UUID.
 */
export const featuredFanUsersDelete = <ThrowOnError extends boolean = false>(options: Options<FeaturedFanUsersDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<FeaturedFanUsersDeleteResponses, FeaturedFanUsersDeleteErrors, ThrowOnError>({
        url: '/api/v2/featuredFanUsers/{uuid}',
        ...options
    });
};

/**
 * Generate a presigned S3 URL for file upload. Requires an authenticated brand or fan user.
 */
export const filesPresignedUrl = <ThrowOnError extends boolean = false>(options: Options<FilesPresignedUrlData, ThrowOnError>) => {
    return (options.client ?? client).post<FilesPresignedUrlResponses, FilesPresignedUrlErrors, ThrowOnError>({
        url: '/api/v2/files/presignedUrl',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Fetch a public image server-side and return it as a data URL, so the browser can draw images from hosts that do not send CORS headers. Only http(s) URLs that resolve to public addresses are fetched, on every redirect hop; the response must be an image of at most 10 MB, the same limit as image uploads.
 */
export const filesImageProxy = <ThrowOnError extends boolean = false>(options: Options<FilesImageProxyData, ThrowOnError>) => {
    return (options.client ?? client).get<FilesImageProxyResponses, FilesImageProxyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/files/imageProxy',
        ...options
    });
};

/**
 * Start rendering a testimonial video on Remotion Lambda. The Lambda function, region, site and bucket are fixed server-side; every media URL must be https and resolve to a public address.
 */
export const videoRendersStart = <ThrowOnError extends boolean = false>(options: Options<VideoRendersStartData, ThrowOnError>) => {
    return (options.client ?? client).post<VideoRendersStartResponses, VideoRendersStartErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/videoRenders/start',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Read the progress of a video render started by the caller's brand.
 */
export const videoRendersProgress = <ThrowOnError extends boolean = false>(options: Options<VideoRendersProgressData, ThrowOnError>) => {
    return (options.client ?? client).get<VideoRendersProgressResponses, VideoRendersProgressErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/videoRenders/progress',
        ...options
    });
};

/**
 * Performs visits action on ForumGroups.
 */
export const forumGroupsVisitsMany = <ThrowOnError extends boolean = false>(options?: Options<ForumGroupsVisitsManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<ForumGroupsVisitsManyResponses, ForumGroupsVisitsManyErrors, ThrowOnError>({
        url: '/api/v2/forumGroup/visits',
        ...options
    });
};

/**
 * Retrieves a list of Posts for a ForumGroup.
 */
export const forumGroupsPostsReadMany = <ThrowOnError extends boolean = false>(options: Options<ForumGroupsPostsReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<ForumGroupsPostsReadManyResponses, ForumGroupsPostsReadManyErrors, ThrowOnError>({
        url: '/api/v2/forumGroup/{uuid}/posts',
        ...options
    });
};

/**
 * Creates a new Post for a ForumGroup.
 */
export const forumGroupsPostCreate = <ThrowOnError extends boolean = false>(options: Options<ForumGroupsPostCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<ForumGroupsPostCreateResponses, ForumGroupsPostCreateErrors, ThrowOnError>({
        url: '/api/v2/forumGroup/{uuid}/posts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieves a list of ForumGroups.
 */
export const forumGroupsReadMany = <ThrowOnError extends boolean = false>(options?: Options<ForumGroupsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<ForumGroupsReadManyResponses, ForumGroupsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/v2/forumGroup',
        ...options
    });
};

/**
 * Retrieves an existing ForumGroup.
 */
export const forumGroupsRead = <ThrowOnError extends boolean = false>(options: Options<ForumGroupsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<ForumGroupsReadResponses, ForumGroupsReadErrors, ThrowOnError>({
        url: '/api/v2/forumGroup/{uuid}',
        ...options
    });
};

/**
 * Performs join action on ForumGroup.
 */
export const forumGroupsJoin = <ThrowOnError extends boolean = false>(options: Options<ForumGroupsJoinData, ThrowOnError>) => {
    return (options.client ?? client).post<ForumGroupsJoinResponses, ForumGroupsJoinErrors, ThrowOnError>({
        url: '/api/v2/forumGroup/{uuid}/join',
        ...options
    });
};

/**
 * Performs leave action on ForumGroup.
 */
export const forumGroupsLeave = <ThrowOnError extends boolean = false>(options: Options<ForumGroupsLeaveData, ThrowOnError>) => {
    return (options.client ?? client).post<ForumGroupsLeaveResponses, ForumGroupsLeaveErrors, ThrowOnError>({
        url: '/api/v2/forumGroup/{uuid}/leave',
        ...options
    });
};

/**
 * Link segments to a private or secret space. Current segment members are added now; future members join and leave automatically.
 */
export const forumGroupsLinkGroups = <ThrowOnError extends boolean = false>(options: Options<ForumGroupsLinkGroupsData, ThrowOnError>) => {
    return (options.client ?? client).post<ForumGroupsLinkGroupsResponses, ForumGroupsLinkGroupsErrors, ThrowOnError>({
        url: '/api/v2/forumGroup/{uuid}/linkGroups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Performs markSeen action on ForumGroup.
 */
export const forumGroupsMarkSeen = <ThrowOnError extends boolean = false>(options: Options<ForumGroupsMarkSeenData, ThrowOnError>) => {
    return (options.client ?? client).post<ForumGroupsMarkSeenResponses, ForumGroupsMarkSeenErrors, ThrowOnError>({
        url: '/api/v2/forumGroup/{uuid}/markSeen',
        ...options
    });
};

/**
 * Retrieves a list of GroupForumUsers for a ForumGroup.
 */
export const forumGroupsGroupForumUsersReadMany = <ThrowOnError extends boolean = false>(options: Options<ForumGroupsGroupForumUsersReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<ForumGroupsGroupForumUsersReadManyResponses, ForumGroupsGroupForumUsersReadManyErrors, ThrowOnError>({
        url: '/api/v2/forumGroup/{uuid}/groupForumUsers',
        ...options
    });
};

/**
 * Initialize forum user
 *
 * Create or get forum user profile for the current user. Also creates personal info if provided.
 */
export const forumUsersInit = <ThrowOnError extends boolean = false>(options: Options<ForumUsersInitData, ThrowOnError>) => {
    return (options.client ?? client).post<ForumUsersInitResponses, ForumUsersInitErrors, ThrowOnError>({
        url: '/api/v2/forumUser/init',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Search forum users for mentions
 *
 * Search for forum users within the same brand by name. Used for @mention dropdown.
 */
export const forumUsersSearchMany = <ThrowOnError extends boolean = false>(options: Options<ForumUsersSearchManyData, ThrowOnError>) => {
    return (options.client ?? client).get<ForumUsersSearchManyResponses, ForumUsersSearchManyErrors, ThrowOnError>({
        url: '/api/v2/forumUser/search',
        ...options
    });
};

/**
 * Retrieves an existing ForumUser.
 */
export const forumUsersRead = <ThrowOnError extends boolean = false>(options: Options<ForumUsersReadData, ThrowOnError>) => {
    return (options.client ?? client).get<ForumUsersReadResponses, ForumUsersReadErrors, ThrowOnError>({
        url: '/api/v2/forumUser/{uuid}',
        ...options
    });
};

/**
 * Update current forum user profile
 *
 * Update the current user's forum profile (personal info).
 */
export const forumUsersMe = <ThrowOnError extends boolean = false>(options: Options<ForumUsersMeData, ThrowOnError>) => {
    return (options.client ?? client).patch<ForumUsersMeResponses, ForumUsersMeErrors, ThrowOnError>({
        url: '/api/v2/forumUser/me',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Performs activity action on ForumUser.
 */
export const forumUsersActivity = <ThrowOnError extends boolean = false>(options: Options<ForumUsersActivityData, ThrowOnError>) => {
    return (options.client ?? client).get<ForumUsersActivityResponses, ForumUsersActivityErrors, ThrowOnError>({
        url: '/api/v2/forumUser/{uuid}/activity',
        ...options
    });
};

/**
 * Retrieves a list of ForumGroups for a ForumUser.
 */
export const forumUsersForumGroupsReadMany = <ThrowOnError extends boolean = false>(options: Options<ForumUsersForumGroupsReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<ForumUsersForumGroupsReadManyResponses, ForumUsersForumGroupsReadManyErrors, ThrowOnError>({
        url: '/api/v2/forumUser/{uuid}/forumGroups',
        ...options
    });
};

/**
 * List the brand's segments (groups), paginated — the general-purpose segment list, not a picker-specific feed, so segment-list consumers can migrate onto it. Reference-pool groups are excluded; a segment's conditions come from groupsRead, not from here.
 */
export const groupsReadMany = <ThrowOnError extends boolean = false>(options?: Options<GroupsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<GroupsReadManyResponses, GroupsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/v2/groups',
        ...options
    });
};

/**
 * Create a new segment (group) — a saved, reusable audience of advocates. Membership can be static or driven by dynamic rules, via `conditions` or a natural-language `conditionsPrompt`. Use for "create a segment", "new advocate group", "build an audience".
 */
export const groupsCreate = <ThrowOnError extends boolean = false>(options: Options<GroupsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<GroupsCreateResponses, GroupsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/groups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get conditions schema for segment builder
 *
 * Returns the segment conditions field schema with runtime fields hydrated per brand (integration maps, survey questions, missions, badges, application fields).
 */
export const groupsConditionsSchema = <ThrowOnError extends boolean = false>(options?: Options<GroupsConditionsSchemaData, ThrowOnError>) => {
    return (options?.client ?? client).get<GroupsConditionsSchemaResponses, GroupsConditionsSchemaErrors, ThrowOnError>({
        url: '/api/v2/groups/conditionsSchema',
        ...options
    });
};

/**
 * Lists the brand's segments whose rules cannot currently be evaluated, with the reason
 */
export const groupsDegraded = <ThrowOnError extends boolean = false>(options?: Options<GroupsDegradedData, ThrowOnError>) => {
    return (options?.client ?? client).get<GroupsDegradedResponses, GroupsDegradedErrors, ThrowOnError>({
        url: '/api/v2/groups/degraded',
        ...options
    });
};

/**
 * Estimates how many users match the given conditions without persisting anything
 */
export const groupsEstimatedReach = <ThrowOnError extends boolean = false>(options: Options<GroupsEstimatedReachData, ThrowOnError>) => {
    return (options.client ?? client).post<GroupsEstimatedReachResponses, GroupsEstimatedReachErrors, ThrowOnError>({
        url: '/api/v2/groups/estimatedReach',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generates lens-valid segment conditions from a natural-language prompt without persisting anything
 */
export const groupsGenerateConditions = <ThrowOnError extends boolean = false>(options: Options<GroupsGenerateConditionsData, ThrowOnError>) => {
    return (options.client ?? client).post<GroupsGenerateConditionsResponses, GroupsGenerateConditionsErrors, ThrowOnError>({
        url: '/api/v2/groups/generateConditions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a segment (group) and clean up its advocate memberships. Use for "delete a segment", "remove a group", "delete an audience".
 */
export const groupsDelete = <ThrowOnError extends boolean = false>(options: Options<GroupsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<GroupsDeleteResponses, GroupsDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/groups/{uuid}',
        ...options
    });
};

/**
 * Retrieves a segment (group) including its conditions
 */
export const groupsRead = <ThrowOnError extends boolean = false>(options: Options<GroupsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<GroupsReadResponses, GroupsReadErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/groups/{uuid}',
        ...options
    });
};

/**
 * Update an existing segment (group) — rename it or edit its membership rules/conditions. Use for "edit a segment", "change group conditions", "update an audience".
 */
export const groupsUpdate = <ThrowOnError extends boolean = false>(options: Options<GroupsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<GroupsUpdateResponses, GroupsUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/groups/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Triggers reconciliation of dynamic segment membership based on current conditions
 */
export const groupsReconcile = <ThrowOnError extends boolean = false>(options: Options<GroupsReconcileData, ThrowOnError>) => {
    return (options.client ?? client).post<GroupsReconcileResponses, GroupsReconcileErrors, ThrowOnError>({
        url: '/api/v2/groups/{uuid}/reconcile',
        ...options
    });
};

/**
 * Add advocates to a segment (group) by email address. On a static segment this is the member list; with source "manual" it pins advocates into any live segment, dynamic included, as membership rows the rules never evict. Use for "add advocates to a segment", "pin an advocate", "enroll members by email".
 */
export const groupsAddMembers = <ThrowOnError extends boolean = false>(options: Options<GroupsAddMembersData, ThrowOnError>) => {
    return (options.client ?? client).post<GroupsAddMembersResponses, GroupsAddMembersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/groups/{uuid}/addMembers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Remove advocates from a static segment (group) by email address or advocate uuid. Use for "remove advocates from a segment", "take people out of a group".
 */
export const groupsRemoveMembers = <ThrowOnError extends boolean = false>(options: Options<GroupsRemoveMembersData, ThrowOnError>) => {
    return (options.client ?? client).post<GroupsRemoveMembersResponses, GroupsRemoveMembersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/groups/{uuid}/removeMembers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add advocates matching a free-text query (name, email, company, title) to a static segment
 */
export const groupsAddMatching = <ThrowOnError extends boolean = false>(options: Options<GroupsAddMatchingData, ThrowOnError>) => {
    return (options.client ?? client).post<GroupsAddMatchingResponses, GroupsAddMatchingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/groups/{uuid}/addMatching',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the advocates (members) in a segment (group) — paginated, searchable, and sortable. Use for "who is in this segment", "list group members", "segment membership".
 */
export const groupsFanUsersReadMany = <ThrowOnError extends boolean = false>(options: Options<GroupsFanUsersReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<GroupsFanUsersReadManyResponses, GroupsFanUsersReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/groups/{uuid}/fanUsers',
        ...options
    });
};

/**
 * Remove one hand-managed advocate from a segment (group): un-pin a pinned advocate, or remove an invite-link enrolment — the rows reconciliation never evicts. Works on dynamic segments, unlike removeMembers. Use for "un-pin an advocate", "remove someone who joined by invite link".
 */
export const groupsRemoveManualMember = <ThrowOnError extends boolean = false>(options: Options<GroupsRemoveManualMemberData, ThrowOnError>) => {
    return (options.client ?? client).post<GroupsRemoveManualMemberResponses, GroupsRemoveManualMemberErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/groups/{uuid}/removeManualMember',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mints a five-minute handoff token that signs the current brand user into the external changelog site as an admin.
 */
export const changelogHandoffsCreate = <ThrowOnError extends boolean = false>(options?: Options<ChangelogHandoffsCreateData, ThrowOnError>) => {
    return (options?.client ?? client).post<ChangelogHandoffsCreateResponses, ChangelogHandoffsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/changelogHandoffs',
        ...options
    });
};

/**
 * Creates an impersonation session and returns a one-time advocate-portal URL. Super-admin only.
 */
export const impersonationSessionsCreate = <ThrowOnError extends boolean = false>(options: Options<ImpersonationSessionsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<ImpersonationSessionsCreateResponses, ImpersonationSessionsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/impersonationSessions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the brand's integration maps — the rules that map an external source's field or value onto an internal custom field. Use this to answer "list integration maps" or "how are the Salesforce/CSV columns mapped".
 */
export const integrationMapsReadMany = <ThrowOnError extends boolean = false>(options?: Options<IntegrationMapsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<IntegrationMapsReadManyResponses, IntegrationMapsReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrationMap',
        ...options
    });
};

/**
 * Creates a new integration map for the brand, or if one already exists for the same (brand, customFieldDefinition, integrationSource) tuple, merges the provided aliasKeys into the existing map instead of creating a duplicate (idempotent — safe to call repeatedly). On a duplicate call, only aliasKeys are merged; other fields (target, type, syncType, etc.) on the existing map are left unchanged.
 */
export const integrationMapsCreate = <ThrowOnError extends boolean = false>(options: Options<IntegrationMapsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<IntegrationMapsCreateResponses, IntegrationMapsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrationMap',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete an integration map by UUID. Defaults to soft-delete (archive). Pass ?hard=true to permanently delete the map and all its enrichment data.
 */
export const integrationMapsDelete = <ThrowOnError extends boolean = false>(options: Options<IntegrationMapsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<IntegrationMapsDeleteResponses, IntegrationMapsDeleteErrors, ThrowOnError>({
        url: '/api/v2/integrationMap/{uuid}',
        ...options
    });
};

/**
 * Update an existing integration map.
 */
export const integrationMapsUpdate = <ThrowOnError extends boolean = false>(options: Options<IntegrationMapsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<IntegrationMapsUpdateResponses, IntegrationMapsUpdateErrors, ThrowOnError>({
        url: '/api/v2/integrationMap/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Promote an alias to become the new label for the linked field. The old label is added to this map's aliasKeys.
 */
export const integrationMapsPromoteAlias = <ThrowOnError extends boolean = false>(options: Options<IntegrationMapsPromoteAliasData, ThrowOnError>) => {
    return (options.client ?? client).post<IntegrationMapsPromoteAliasResponses, IntegrationMapsPromoteAliasErrors, ThrowOnError>({
        url: '/api/v2/integrationMap/{uuid}/promoteAlias',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add alternate external field/value keys (aliases) to an existing integration map so more incoming source values resolve to the same internal custom field. Deduplicates automatically.
 */
export const integrationMapsAddAliases = <ThrowOnError extends boolean = false>(options: Options<IntegrationMapsAddAliasesData, ThrowOnError>) => {
    return (options.client ?? client).post<IntegrationMapsAddAliasesResponses, IntegrationMapsAddAliasesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrationMap/{uuid}/addAliases',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Remove aliases from this integration map. Auto-promotes next alias if current label is removed. Returns 400 if removing would leave no aliases.
 */
export const integrationMapsRemoveAliases = <ThrowOnError extends boolean = false>(options: Options<IntegrationMapsRemoveAliasesData, ThrowOnError>) => {
    return (options.client ?? client).post<IntegrationMapsRemoveAliasesResponses, IntegrationMapsRemoveAliasesErrors, ThrowOnError>({
        url: '/api/v2/integrationMap/{uuid}/removeAliases',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the brand's integration sources — the external data feeds (CSV import, Salesforce, etc.) that supply advocate/contact data. Use this to answer "list integration sources" or "what data sources are connected".
 */
export const integrationSourcesReadMany = <ThrowOnError extends boolean = false>(options?: Options<IntegrationSourcesReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<IntegrationSourcesReadManyResponses, IntegrationSourcesReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrationSource',
        ...options
    });
};

/**
 * Create a custom integration source for the brand — an external data feed (CSV import, Salesforce, etc.) that supplies advocate/contact data. Use this to "add an integration source" or "connect a new data source".
 */
export const integrationSourcesCreate = <ThrowOnError extends boolean = false>(options: Options<IntegrationSourcesCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<IntegrationSourcesCreateResponses, IntegrationSourcesCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrationSource',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Set up a CSV import: create or reuse an integration source and define how spreadsheet columns map to fan-user fields and custom fields. Call this to configure the column-to-field mapping before importing.
 */
export const integrationSourcesConfigureImport = <ThrowOnError extends boolean = false>(options: Options<IntegrationSourcesConfigureImportData, ThrowOnError>) => {
    return (options.client ?? client).post<IntegrationSourcesConfigureImportResponses, IntegrationSourcesConfigureImportErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrationSource/configureImport',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Import a CSV of advocates/contacts: upload the file and create or update fan users (with enrichments) using the source's configured column-to-field mappings. Use this to "import a CSV of advocates".
 */
export const integrationSourcesImport = <ThrowOnError extends boolean = false>(options: Options<IntegrationSourcesImportData, ThrowOnError>) => {
    return (options.client ?? client).post<IntegrationSourcesImportResponses, IntegrationSourcesImportErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrationSource/{uuid}/import',
        ...options
    });
};

/**
 * Sets a brand's Salesforce sync direction. Cutting over to push is refused while records remain that would duplicate in Salesforce on the first writeback.
 */
export const integrationSourcesSetSyncDirection = <ThrowOnError extends boolean = false>(options: Options<IntegrationSourcesSetSyncDirectionData, ThrowOnError>) => {
    return (options.client ?? client).post<IntegrationSourcesSetSyncDirectionResponses, IntegrationSourcesSetSyncDirectionErrors, ThrowOnError>({
        url: '/api/v2/integrationSource/{uuid}/setSyncDirection',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a custom integration source by UUID. Defaults to soft-delete (archive). Pass ?hard=true to permanently delete the source, its maps, and all enrichment data.
 */
export const integrationSourcesDelete = <ThrowOnError extends boolean = false>(options: Options<IntegrationSourcesDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<IntegrationSourcesDeleteResponses, IntegrationSourcesDeleteErrors, ThrowOnError>({
        url: '/api/v2/integrationSource/{uuid}',
        ...options
    });
};

/**
 * Update an existing custom integration source.
 */
export const integrationSourcesUpdate = <ThrowOnError extends boolean = false>(options: Options<IntegrationSourcesUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<IntegrationSourcesUpdateResponses, IntegrationSourcesUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/integrationSource/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Notify mentioned users
 *
 * Parse mentions from text and send in-app notifications to mentioned users.
 */
export const mentionsNotify = <ThrowOnError extends boolean = false>(options: Options<MentionsNotifyData, ThrowOnError>) => {
    return (options.client ?? client).post<MentionsNotifyResponses, MentionsNotifyErrors, ThrowOnError>({
        url: '/api/v2/mentions/notify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Send a notification to users via all configured channels for the event
 */
export const notificationsSend = <ThrowOnError extends boolean = false>(options: Options<NotificationsSendData, ThrowOnError>) => {
    return (options.client ?? client).post<NotificationsSendResponses, NotificationsSendErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Internal-Service-Token',
                type: 'apiKey'
            }
        ],
        url: '/api/v2/notifications/send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List a brand's notifications with per-notification delivery metrics — the v2 Communication Hub read surface. Scope to one reference request with ?searchFields[referenceID][equals]= for the reference detail drawer.
 */
export const notificationsReadMany = <ThrowOnError extends boolean = false>(options?: Options<NotificationsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<NotificationsReadManyResponses, NotificationsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/notifications',
        ...options
    });
};

/**
 * List the per-recipient delivery records for one notification — who it was sent to and whether each email/SMS delivered, bounced or failed. Use this for "who received this communication" and delivery status.
 */
export const notificationsNotificationLogsReadMany = <ThrowOnError extends boolean = false>(options: Options<NotificationsNotificationLogsReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<NotificationsNotificationLogsReadManyResponses, NotificationsNotificationLogsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/notifications/{uuid}/notificationLogs',
        ...options
    });
};

/**
 * Process and send the weekly digest for a brand (missions/rewards) via configured notification channels
 */
export const notificationsWeeklyDigest = <ThrowOnError extends boolean = false>(options: Options<NotificationsWeeklyDigestData, ThrowOnError>) => {
    return (options.client ?? client).post<NotificationsWeeklyDigestResponses, NotificationsWeeklyDigestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/notifications/weeklyDigest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Read the current week's weekly digest selections (missions/rewards) for the brand
 */
export const notificationsWeeklyDigestRead = <ThrowOnError extends boolean = false>(options?: Options<NotificationsWeeklyDigestReadData, ThrowOnError>) => {
    return (options?.client ?? client).get<NotificationsWeeklyDigestReadResponses, NotificationsWeeklyDigestReadErrors, ThrowOnError>({
        url: '/api/v2/notifications/weeklyDigestRead',
        ...options
    });
};

/**
 * Replace the current week's weekly digest selections for a brand (atomic; dedupes and caps per type)
 */
export const notificationsWeeklyDigestReplace = <ThrowOnError extends boolean = false>(options: Options<NotificationsWeeklyDigestReplaceData, ThrowOnError>) => {
    return (options.client ?? client).put<NotificationsWeeklyDigestReplaceResponses, NotificationsWeeklyDigestReplaceErrors, ThrowOnError>({
        url: '/api/v2/notifications/weeklyDigestReplace',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Send a one-time password to verify email ownership
 */
export const otpsSend = <ThrowOnError extends boolean = false>(options: Options<OtpsSendData, ThrowOnError>) => {
    return (options.client ?? client).post<OtpsSendResponses, OtpsSendErrors, ThrowOnError>({
        url: '/api/v2/otp/send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Verify a one-time password and receive an authentication token
 */
export const otpsVerify = <ThrowOnError extends boolean = false>(options: Options<OtpsVerifyData, ThrowOnError>) => {
    return (options.client ?? client).post<OtpsVerifyResponses, OtpsVerifyErrors, ThrowOnError>({
        url: '/api/v2/otp/verify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieves a list of Posts.
 */
export const postsSubscriptionsMany = <ThrowOnError extends boolean = false>(options?: Options<PostsSubscriptionsManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<PostsSubscriptionsManyResponses, PostsSubscriptionsManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/v2/post/subscriptions',
        ...options
    });
};

/**
 * Retrieves a list of Comments for a Post.
 */
export const postsCommentsReadMany = <ThrowOnError extends boolean = false>(options: Options<PostsCommentsReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<PostsCommentsReadManyResponses, PostsCommentsReadManyErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}/comments',
        ...options
    });
};

/**
 * Creates a new Comment for a Post.
 */
export const postsCommentCreate = <ThrowOnError extends boolean = false>(options: Options<PostsCommentCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<PostsCommentCreateResponses, PostsCommentCreateErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}/comments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Deletes an existing Post.
 */
export const postsDelete = <ThrowOnError extends boolean = false>(options: Options<PostsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<PostsDeleteResponses, PostsDeleteErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}',
        ...options
    });
};

/**
 * Retrieves an existing Post.
 */
export const postsRead = <ThrowOnError extends boolean = false>(options: Options<PostsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<PostsReadResponses, PostsReadErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}',
        ...options
    });
};

/**
 * Updates an existing Post.
 */
export const postsUpdate = <ThrowOnError extends boolean = false>(options: Options<PostsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<PostsUpdateResponses, PostsUpdateErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieves a list of Posts.
 */
export const postsReadMany = <ThrowOnError extends boolean = false>(options?: Options<PostsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<PostsReadManyResponses, PostsReadManyErrors, ThrowOnError>({
        url: '/api/v2/post',
        ...options
    });
};

/**
 * Performs moveToGroup action on Post.
 */
export const postsMoveToGroup = <ThrowOnError extends boolean = false>(options: Options<PostsMoveToGroupData, ThrowOnError>) => {
    return (options.client ?? client).post<PostsMoveToGroupResponses, PostsMoveToGroupErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}/moveToGroup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Performs pin action on Post.
 */
export const postsPin = <ThrowOnError extends boolean = false>(options: Options<PostsPinData, ThrowOnError>) => {
    return (options.client ?? client).post<PostsPinResponses, PostsPinErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}/pin',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Performs like action on Post.
 */
export const postsLike = <ThrowOnError extends boolean = false>(options: Options<PostsLikeData, ThrowOnError>) => {
    return (options.client ?? client).post<PostsLikeResponses, PostsLikeErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}/like',
        ...options
    });
};

/**
 * Performs unlike action on Post.
 */
export const postsUnlike = <ThrowOnError extends boolean = false>(options: Options<PostsUnlikeData, ThrowOnError>) => {
    return (options.client ?? client).post<PostsUnlikeResponses, PostsUnlikeErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}/unlike',
        ...options
    });
};

/**
 * Performs subscribe action on Post.
 */
export const postsSubscribe = <ThrowOnError extends boolean = false>(options: Options<PostsSubscribeData, ThrowOnError>) => {
    return (options.client ?? client).post<PostsSubscribeResponses, PostsSubscribeErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}/subscribe',
        ...options
    });
};

/**
 * Performs unsubscribe action on Post.
 */
export const postsUnsubscribe = <ThrowOnError extends boolean = false>(options: Options<PostsUnsubscribeData, ThrowOnError>) => {
    return (options.client ?? client).post<PostsUnsubscribeResponses, PostsUnsubscribeErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}/unsubscribe',
        ...options
    });
};

/**
 * Performs vote action on Post.
 */
export const postsVote = <ThrowOnError extends boolean = false>(options: Options<PostsVoteData, ThrowOnError>) => {
    return (options.client ?? client).post<PostsVoteResponses, PostsVoteErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}/vote',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Performs unvote action on Post.
 */
export const postsUnvote = <ThrowOnError extends boolean = false>(options: Options<PostsUnvoteData, ThrowOnError>) => {
    return (options.client ?? client).post<PostsUnvoteResponses, PostsUnvoteErrors, ThrowOnError>({
        url: '/api/v2/post/{uuid}/unvote',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Look up privacy-request data facets by email
 *
 * Performs lookup action on PrivacyRequest.
 */
export const privacyRequestsLookup = <ThrowOnError extends boolean = false>(options: Options<PrivacyRequestsLookupData, ThrowOnError>) => {
    return (options.client ?? client).post<PrivacyRequestsLookupResponses, PrivacyRequestsLookupErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/privacyRequest/lookup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Erase brand-scoped personal data by email
 *
 * Performs delete action on PrivacyRequest.
 */
export const privacyRequestsDelete = <ThrowOnError extends boolean = false>(options: Options<PrivacyRequestsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).post<PrivacyRequestsDeleteResponses, PrivacyRequestsDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/privacyRequest/delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk import reference opt-ins from CSV data.
 */
export const referenceOptInsImport = <ThrowOnError extends boolean = false>(options: Options<ReferenceOptInsImportData, ThrowOnError>) => {
    return (options.client ?? client).post<ReferenceOptInsImportResponses, ReferenceOptInsImportErrors, ThrowOnError>({
        url: '/api/v2/referenceOptIns/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the channels in this brand's Slack workspace
 *
 * Lists public and private channels for the brand's connected Slack app, for populating a channel picker. Private channels are only visible where the bot is a member, so a brand newly migrated to Evi sees fewer private channels until Evi is invited. Distinct from POST /channels/readMany, which resolves already-known channel IDs to names.
 */
export const slacksChannelsList = <ThrowOnError extends boolean = false>(options?: Options<SlacksChannelsListData, ThrowOnError>) => {
    return (options?.client ?? client).get<SlacksChannelsListResponses, SlacksChannelsListErrors, ThrowOnError>({
        url: '/api/v2/slack/channels',
        ...options
    });
};

/**
 * Resolve Slack destination IDs to names
 *
 * Resolves a list of saved Slack destination IDs to their display names. A channel ID resolves via conversations.info; an @-prefixed direct-message ID (@U…) resolves via users.info. Used to render saved selections without enumerating the workspace. Failed lookups (deleted, bot not invited, etc.) come back with name: null so the UI can fall back to the raw ID.
 */
export const slacksChannelsReadMany = <ThrowOnError extends boolean = false>(options: Options<SlacksChannelsReadManyData, ThrowOnError>) => {
    return (options.client ?? client).post<SlacksChannelsReadManyResponses, SlacksChannelsReadManyErrors, ThrowOnError>({
        url: '/api/v2/slack/channels/readMany',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a durable Evi install link for the current brand
 *
 * Create a repeatable, time-limited Evi Slack install link for the current brand. Brand identity comes from authenticated context and only a superadmin may mint the link.
 */
export const slackEviInstallLinkCreate = <ThrowOnError extends boolean = false>(options?: Options<SlackEviInstallLinkCreateData, ThrowOnError>) => {
    return (options?.client ?? client).post<SlackEviInstallLinkCreateResponses, SlackEviInstallLinkCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/slack/eviInstallLink',
        ...options
    });
};

/**
 * Revoke Evi install links for the current brand
 *
 * Revoke all active Evi Slack install links for the current brand. Brand identity comes from authenticated context and only a superadmin may revoke links.
 */
export const slackEviInstallLinkRevoke = <ThrowOnError extends boolean = false>(options?: Options<SlackEviInstallLinkRevokeData, ThrowOnError>) => {
    return (options?.client ?? client).post<SlackEviInstallLinkRevokeResponses, SlackEviInstallLinkRevokeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/slack/eviInstallLinkRevoke',
        ...options
    });
};

/**
 * Start a Slack install for the current brand
 *
 * Mints a single-use, short-lived opaque OAuth state bound to the caller’s brand and returns the Slack authorize URL carrying it. The brand comes from the authenticated session, never from the request, so the install callback never has to trust anything in the URL. `app` selects which Slack app is installed; it falls back to `legacy` only so the previously body-less contract keeps working during the deploy window, and `evi` is superadmin-only because completing it binds the workspace and grants Evi scopes.
 */
export const slackInstallStart = <ThrowOnError extends boolean = false>(options: Options<SlackInstallStartData, ThrowOnError>) => {
    return (options.client ?? client).post<SlackInstallStartResponses, SlackInstallStartErrors, ThrowOnError>({
        url: '/api/v2/slack/installStart',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Report which Slack app serves this brand
 *
 * Reports whether the brand has a Slack integration and which app serves it. `transport` is 'evi' once the brand is migrated, 'legacy' while it is still on the original app, and null when no Slack app is connected. The brand comes from request context; no brandID is accepted.
 */
export const slacksStatus = <ThrowOnError extends boolean = false>(options?: Options<SlacksStatusData, ThrowOnError>) => {
    return (options?.client ?? client).get<SlacksStatusResponses, SlacksStatusErrors, ThrowOnError>({
        url: '/api/v2/slack/status',
        ...options
    });
};

/**
 * Create a referral submission for the current advocate.
 */
export const referralsCreate = <ThrowOnError extends boolean = false>(options: Options<ReferralsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<ReferralsCreateResponses, ReferralsCreateErrors, ThrowOnError>({
        url: '/api/v2/referrals',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List referral submissions for the current advocate.
 */
export const referralsMineMany = <ThrowOnError extends boolean = false>(options?: Options<ReferralsMineManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<ReferralsMineManyResponses, ReferralsMineManyErrors, ThrowOnError>({
        url: '/api/v2/referrals/mine',
        ...options
    });
};

/**
 * Read referral summary statistics for the current brand.
 */
export const adminReferralsStatsStats = <ThrowOnError extends boolean = false>(options?: Options<AdminReferralsStatsStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminReferralsStatsStatsResponses, AdminReferralsStatsStatsErrors, ThrowOnError>({
        url: '/api/v2/admin/referrals/stats',
        ...options
    });
};

/**
 * List all referrals for the current brand.
 */
export const adminReferralsReadMany = <ThrowOnError extends boolean = false>(options?: Options<AdminReferralsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminReferralsReadManyResponses, AdminReferralsReadManyErrors, ThrowOnError>({
        url: '/api/v2/admin/referrals',
        ...options
    });
};

/**
 * Read referral milestone reward settings for the current brand.
 */
export const adminReferralsMilestoneRewardSettings = <ThrowOnError extends boolean = false>(options?: Options<AdminReferralsMilestoneRewardSettingsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminReferralsMilestoneRewardSettingsResponses, AdminReferralsMilestoneRewardSettingsErrors, ThrowOnError>({
        url: '/api/v2/admin/referrals/milestone-reward-settings',
        ...options
    });
};

/**
 * Update referral milestone reward settings for the current brand.
 */
export const adminReferralsMilestoneRewardSettings2 = <ThrowOnError extends boolean = false>(options: Options<AdminReferralsMilestoneRewardSettings2Data, ThrowOnError>) => {
    return (options.client ?? client).put<AdminReferralsMilestoneRewardSettings2Responses, AdminReferralsMilestoneRewardSettings2Errors, ThrowOnError>({
        url: '/api/v2/admin/referrals/milestone-reward-settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Call Workato get-leads recipe with all referral emails for the current brand.
 */
export const adminReferralsSyncLeads = <ThrowOnError extends boolean = false>(options?: Options<AdminReferralsSyncLeadsData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminReferralsSyncLeadsResponses, AdminReferralsSyncLeadsErrors, ThrowOnError>({
        url: '/api/v2/admin/referrals/sync-leads',
        ...options
    });
};

/**
 * Machine webhook for Workato to update referral lead status. Not an admin UI call: it sits outside the admin guard and is verified by the WORKATO_WEBHOOK_SECRET shared secret in X-Internal-Service-Token; the brand comes from the verified payload.
 */
export const adminReferralsWorkatoLeadStatusWebhook = <ThrowOnError extends boolean = false>(options?: Options<AdminReferralsWorkatoLeadStatusWebhookData, ThrowOnError>) => {
    return (options?.client ?? client).post<AdminReferralsWorkatoLeadStatusWebhookResponses, AdminReferralsWorkatoLeadStatusWebhookErrors, ThrowOnError>({
        security: [
            {
                name: 'X-Internal-Service-Token',
                type: 'apiKey'
            }
        ],
        url: '/api/v2/admin/referrals/workato-lead-status-webhook',
        ...options
    });
};

/**
 * Read a single referral for the current brand.
 */
export const adminReferralsRead = <ThrowOnError extends boolean = false>(options: Options<AdminReferralsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminReferralsReadResponses, AdminReferralsReadErrors, ThrowOnError>({
        url: '/api/v2/admin/referrals/{uuid}',
        ...options
    });
};

/**
 * Update referral pipeline status.
 */
export const adminReferralsStatus = <ThrowOnError extends boolean = false>(options: Options<AdminReferralsStatusData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminReferralsStatusResponses, AdminReferralsStatusErrors, ThrowOnError>({
        url: '/api/v2/admin/referrals/{uuid}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List and filter the brand's full reference-request board: all reference requests (reference calls) with status, requester, matched advocate, opportunity and scheduling. Filter by status (e.g. meeting_completed = a successful/completed reference call) and search/sort via searchFields. Use this to answer "the reference board", "all reference requests", or "which references were successful".
 */
export const brandReferenceRequestsReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandReferenceRequestsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandReferenceRequestsReadManyResponses, BrandReferenceRequestsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest',
        ...options
    });
};

/**
 * Returns the chosen-and-pinned advocate for each of the brand's references at the mission_created ("Awaiting Advocate") stage. The legacy board query sources the advocate from ReferenceScheduling, which is empty until the advocate submits times, so the admin board merges these in to show the advocate as soon as they are matched.
 */
export const brandReferenceRequestsPinnedAdvocates = <ThrowOnError extends boolean = false>(options?: Options<BrandReferenceRequestsPinnedAdvocatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandReferenceRequestsPinnedAdvocatesResponses, BrandReferenceRequestsPinnedAdvocatesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/pinnedAdvocates',
        ...options
    });
};

/**
 * Reference program funnel / analytics for a time window: how many references were requested, how many completed (a recorded completed call), the completion rate, average days to complete, declines, and the current-status breakdown of the cohort. This is the aggregate view — use it to answer "how did the reference program do this quarter" without listing and counting rows by hand.
 */
export const brandReferenceRequestsFunnel = <ThrowOnError extends boolean = false>(options?: Options<BrandReferenceRequestsFunnelData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandReferenceRequestsFunnelResponses, BrandReferenceRequestsFunnelErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/funnel',
        ...options
    });
};

/**
 * Cursor-paginated full read of reference requests (managed-package backstop for dropped webhooks).
 */
export const brandReferenceRequestsSyncMany = <ThrowOnError extends boolean = false>(options?: Options<BrandReferenceRequestsSyncManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandReferenceRequestsSyncManyResponses, BrandReferenceRequestsSyncManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/sync',
        ...options
    });
};

/**
 * Cursor-paginated id + version manifest of reference requests for scan/diff (no full payloads).
 */
export const brandReferenceRequestsManifestMany = <ThrowOnError extends boolean = false>(options?: Options<BrandReferenceRequestsManifestManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandReferenceRequestsManifestManyResponses, BrandReferenceRequestsManifestManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/manifest',
        ...options
    });
};

/**
 * Delete a single reference request (a reference-call request) from the brand's reference board by UUID. Use for "remove this reference request", "cancel/delete a reference".
 */
export const brandReferenceRequestsDelete = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandReferenceRequestsDeleteResponses, BrandReferenceRequestsDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}',
        ...options
    });
};

/**
 * Get a reference request by UUID, with its opportunity, joins, resolved enrichments, and audit timeline.
 */
export const brandReferenceRequestsRead = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandReferenceRequestsReadResponses, BrandReferenceRequestsReadErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}',
        ...options
    });
};

/**
 * Edit a reference request. Status is not editable here — use the transition action.
 */
export const brandReferenceRequestsUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandReferenceRequestsUpdateResponses, BrandReferenceRequestsUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Record a reference state change the brand observed (board drag, status selector, cancel, revive). Moves one lifecycle stage at a time, carries what the target stage collects in stage (an activation, offered times, or an agreed call time and length), and sends only what sends names; illegal or skipped moves 409 with a reason. Every side effect rides brandReferenceRequest.statusChanged.
 */
export const brandReferenceRequestsTransition = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsTransitionData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsTransitionResponses, BrandReferenceRequestsTransitionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/transition',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mints a fresh scheduling link for the party the reference request is waiting on at its current stage.
 */
export const brandReferenceRequestsSchedulingLink = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsSchedulingLinkData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandReferenceRequestsSchedulingLinkResponses, BrandReferenceRequestsSchedulingLinkErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/schedulingLink',
        ...options
    });
};

/**
 * Fire the brand's reference-request notification workflow. If the brand has no dedicated request workflow but does have defaultReferenceRequestChannel set, self-heal by creating the workflow on the fly before executing.
 */
export const brandReferenceRequestsTriggerRequestNotificationWorkflow = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsTriggerRequestNotificationWorkflowData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsTriggerRequestNotificationWorkflowResponses, BrandReferenceRequestsTriggerRequestNotificationWorkflowErrors, ThrowOnError>({
        url: '/api/v2/brandReferenceRequest/triggerRequestNotificationWorkflow',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add a single advocate to a reference request's ranked candidate queue as a pending candidate (the waterfall of advocates who could take the reference call). Use for "add this advocate to the reference", "queue someone for a reference request".
 */
export const brandReferenceRequestsBrandReferenceRequestFanUserCreate = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsBrandReferenceRequestFanUserCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsBrandReferenceRequestFanUserCreateResponses, BrandReferenceRequestsBrandReferenceRequestFanUserCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/brandReferenceRequestFanUsers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Replace the entire ranked advocate queue for a reference request in one call (the "waterfall send"): submit the advocates in rank order and position 1 becomes the active ask that gets outreach. Use for "set/reorder the reference queue", "choose who to ask for this reference, in order".
 */
export const brandReferenceRequestsBrandReferenceRequestFanUserSet = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsBrandReferenceRequestFanUserSetData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsBrandReferenceRequestFanUserSetResponses, BrandReferenceRequestsBrandReferenceRequestFanUserSetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/brandReferenceRequestFanUsers/set',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Rank eligible advocates for a reference request using the deterministic three-bucket matcher.
 */
export const brandReferenceRequestsMatchAdvocates = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsMatchAdvocatesData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsMatchAdvocatesResponses, BrandReferenceRequestsMatchAdvocatesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/matchAdvocates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generate one human "Why this match" phrase per matched advocate card, batched in a single AI call and cached per criteria.
 */
export const brandReferenceRequestsMatchExplanations = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsMatchExplanationsData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsMatchExplanationsResponses, BrandReferenceRequestsMatchExplanationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/matchExplanations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Ask AI questions about an advocate in the context of this reference request, using their profile and integrated data.
 */
export const brandReferenceRequestsAskAboutAdvocate = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsAskAboutAdvocateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsAskAboutAdvocateResponses, BrandReferenceRequestsAskAboutAdvocateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/askAboutAdvocate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generate key strengths, potential concerns and a short write-up for one matched advocate, grounded in the same fact sheet as the card's match phrase and cached per advocate fact sheet.
 */
export const brandReferenceRequestsAdvocateAnalysis = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsAdvocateAnalysisData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsAdvocateAnalysisResponses, BrandReferenceRequestsAdvocateAnalysisErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/advocateAnalysis',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Draft the three match-filter buckets from a natural-language prompt. Returns the drafted filters only — no advocate matching, no persistence.
 */
export const brandReferenceRequestsDraftMatchFilters = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsDraftMatchFiltersData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsDraftMatchFiltersResponses, BrandReferenceRequestsDraftMatchFiltersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/draftMatchFilters',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Creates a scheduled meeting (Zoom/Nylas) from advocate-provided time slots.
 */
export const brandReferenceRequestsSchedulingCreateMeeting = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsSchedulingCreateMeetingData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsSchedulingCreateMeetingResponses, BrandReferenceRequestsSchedulingCreateMeetingErrors, ThrowOnError>({
        url: '/api/v2/brandReferenceRequest/{uuid}/schedulingCreateMeeting',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Rejects the current time slots and requests new ones from the advocate.
 */
export const brandReferenceRequestsSchedulingReject = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsSchedulingRejectData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsSchedulingRejectResponses, BrandReferenceRequestsSchedulingRejectErrors, ThrowOnError>({
        url: '/api/v2/brandReferenceRequest/{uuid}/schedulingReject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Cancels an existing scheduled meeting and notifies participants.
 */
export const brandReferenceRequestsSchedulingCancel = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsSchedulingCancelData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsSchedulingCancelResponses, BrandReferenceRequestsSchedulingCancelErrors, ThrowOnError>({
        url: '/api/v2/brandReferenceRequest/{uuid}/schedulingCancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Advocate opts out of a reference request before submitting timeslots.
 */
export const brandReferenceRequestsSchedulingDecline = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsSchedulingDeclineData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsSchedulingDeclineResponses, BrandReferenceRequestsSchedulingDeclineErrors, ThrowOnError>({
        url: '/api/v2/brandReferenceRequest/{uuid}/schedulingDecline',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Submits available time slots for a reference scheduling.
 */
export const brandReferenceRequestsSchedulingSubmitSlot = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsSchedulingSubmitSlotData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsSchedulingSubmitSlotResponses, BrandReferenceRequestsSchedulingSubmitSlotErrors, ThrowOnError>({
        url: '/api/v2/brandReferenceRequest/{uuid}/schedulingSubmitSlot',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieves available time slots and reference status.
 */
export const brandReferenceRequestsSchedulingReadSlotsReferenceId = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsSchedulingReadSlotsReferenceIdData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandReferenceRequestsSchedulingReadSlotsReferenceIdResponses, BrandReferenceRequestsSchedulingReadSlotsReferenceIdErrors, ThrowOnError>({
        url: '/api/v2/brandReferenceRequest/schedulingReadSlots/{referenceID}',
        ...options
    });
};

/**
 * List reference request notes
 *
 * Lists a reference request's notes, newest first.
 */
export const brandReferenceRequestsNotesReadMany = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsNotesReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandReferenceRequestsNotesReadManyResponses, BrandReferenceRequestsNotesReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/notes',
        ...options
    });
};

/**
 * Add a reference request note
 *
 * Appends a timestamped, attributed note to a reference request (never overwrites prior notes).
 */
export const brandReferenceRequestsNoteCreate = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsNoteCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsNoteCreateResponses, BrandReferenceRequestsNoteCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List a reference request’s timeline entries
 *
 * Lists a reference request's system events and staff notes as one chronological feed, newest first.
 */
export const brandReferenceRequestsTimelineEntriesReadMany = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsTimelineEntriesReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandReferenceRequestsTimelineEntriesReadManyResponses, BrandReferenceRequestsTimelineEntriesReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequest/{uuid}/timelineEntries',
        ...options
    });
};

/**
 * Legacy managed-package compat: create a reference request (POST /references/request).
 *
 * Performs legacyReferenceRequest action on BrandReferenceRequest.
 */
export const brandReferenceRequestsLegacyReferenceRequest = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestsLegacyReferenceRequestData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestsLegacyReferenceRequestResponses, BrandReferenceRequestsLegacyReferenceRequestErrors, ThrowOnError>({
        url: '/api/v2/legacyCompat/legacyReferenceRequest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Legacy managed-package compat: read an opportunity reference row by Salesforce opportunity id.
 */
export const legacyOpportunityByIdRead = <ThrowOnError extends boolean = false>(options: Options<LegacyOpportunityByIdReadData, ThrowOnError>) => {
    return (options.client ?? client).get<LegacyOpportunityByIdReadResponses, LegacyOpportunityByIdReadErrors, ThrowOnError>({
        url: '/api/v2/legacyCompat/references/opportunity/by-id/{sfOpportunityId}',
        ...options
    });
};

/**
 * Legacy managed-package compat: read the advocate fan-users targeted by a mission.
 */
export const legacyAdvocatesByMissionRead = <ThrowOnError extends boolean = false>(options: Options<LegacyAdvocatesByMissionReadData, ThrowOnError>) => {
    return (options.client ?? client).get<LegacyAdvocatesByMissionReadResponses, LegacyAdvocatesByMissionReadErrors, ThrowOnError>({
        url: '/api/v2/legacyCompat/references/advocates/by-mission/{brandMissionID}',
        ...options
    });
};

/**
 * Legacy managed-package compat: read the calling brand's reference settings.
 *
 * The calling brand's selfServeReferenceRequest tri-state (null when unset) and its CRM display policy: hide advocate email, hide reference title and description, and show suggested advocates.
 */
export const legacyBrandConfigRead = <ThrowOnError extends boolean = false>(options?: Options<LegacyBrandConfigReadData, ThrowOnError>) => {
    return (options?.client ?? client).get<LegacyBrandConfigReadResponses, LegacyBrandConfigReadErrors, ThrowOnError>({
        url: '/api/v2/legacyCompat/brand-config',
        ...options
    });
};

/**
 * Cursor-paginated full read of reference-request advocates (managed-package backstop for dropped webhooks).
 */
export const brandReferenceRequestFanUsersSyncMany = <ThrowOnError extends boolean = false>(options?: Options<BrandReferenceRequestFanUsersSyncManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandReferenceRequestFanUsersSyncManyResponses, BrandReferenceRequestFanUsersSyncManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequestFanUser/sync',
        ...options
    });
};

/**
 * Cursor-paginated id + version manifest of reference-request advocates for scan/diff (no full payloads).
 */
export const brandReferenceRequestFanUsersManifestMany = <ThrowOnError extends boolean = false>(options?: Options<BrandReferenceRequestFanUsersManifestManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandReferenceRequestFanUsersManifestManyResponses, BrandReferenceRequestFanUsersManifestManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequestFanUser/manifest',
        ...options
    });
};

/**
 * Remove an advocate from the queue (soft delete; orderedList compacts the remaining order).
 */
export const brandReferenceRequestFanUsersDelete = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestFanUsersDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandReferenceRequestFanUsersDeleteResponses, BrandReferenceRequestFanUsersDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequestFanUser/{uuid}',
        ...options
    });
};

/**
 * Update a queued advocate — reorder via position, or change status (e.g. mark declined).
 */
export const brandReferenceRequestFanUsersUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestFanUsersUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandReferenceRequestFanUsersUpdateResponses, BrandReferenceRequestFanUsersUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequestFanUser/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Make this candidate the active ask (manual advocate assignment). Parks the current active candidate; 409 if one has already accepted.
 */
export const brandReferenceRequestFanUsersActivate = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestFanUsersActivateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestFanUsersActivateResponses, BrandReferenceRequestFanUsersActivateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequestFanUser/{uuid}/activate',
        ...options
    });
};

/**
 * Mark this candidate declined (admin-recorded refusal). Keeps their place in the queue history; the sourcing recompute promotes the next pending candidate if the decliner held the active ask.
 */
export const brandReferenceRequestFanUsersDecline = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestFanUsersDeclineData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestFanUsersDeclineResponses, BrandReferenceRequestFanUsersDeclineErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequestFanUser/{uuid}/decline',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Skip the active candidate (admin-initiated). Retires them as superseded without notifying the advocate; the sourcing recompute promotes the next pending candidate, or falls the reference to needs_people when the queue is exhausted. 409 if the candidate is not the active ask.
 */
export const brandReferenceRequestFanUsersSupersede = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestFanUsersSupersedeData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestFanUsersSupersedeResponses, BrandReferenceRequestFanUsersSupersedeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequestFanUser/{uuid}/supersede',
        ...options
    });
};

/**
 * Make this candidate the active ask, whatever their position in the queue. Supersedes whoever held the ask, cancels a booked meeting, releases any offered times, and returns the reference to awaiting-advocate before sending the new outreach. 409 on a sealed, cancelled, moderation-locked or mid-booking reference.
 */
export const brandReferenceRequestFanUsersPromote = <ThrowOnError extends boolean = false>(options: Options<BrandReferenceRequestFanUsersPromoteData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandReferenceRequestFanUsersPromoteResponses, BrandReferenceRequestFanUsersPromoteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandReferenceRequestFanUser/{uuid}/promote',
        ...options
    });
};

/**
 * List and filter the brand's opportunities — the sales deals / prospect accounts that reference requests hang off. Search, filter and sort by name, prospect email, deadline, status or external id (e.g. Salesforce). Use this to answer "all opportunities", "open deals", or "which prospects need references".
 */
export const opportunitiesReadMany = <ThrowOnError extends boolean = false>(options?: Options<OpportunitiesReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<OpportunitiesReadManyResponses, OpportunitiesReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/opportunity',
        ...options
    });
};

/**
 * Create an opportunity — a sales deal or prospect account that reference requests hang off. Capture the prospect name, email, deadline and notes. Use this to add a new deal or prospect to the reference program.
 */
export const opportunitiesCreate = <ThrowOnError extends boolean = false>(options: Options<OpportunitiesCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<OpportunitiesCreateResponses, OpportunitiesCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/opportunity',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Cursor-paginated list and filter of the brand's opportunities — same filters, search and picks as the offset-paginated list (GET /v2/opportunity), but walked via an opaque cursor instead of page/pageSize. Use this for scan/diff style traversal of the full opportunity set.
 */
export const opportunitiesCursorMany = <ThrowOnError extends boolean = false>(options?: Options<OpportunitiesCursorManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<OpportunitiesCursorManyResponses, OpportunitiesCursorManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/opportunity/cursor',
        ...options
    });
};

/**
 * Cursor-paginated full read of opportunities (managed-package backstop for dropped webhooks).
 */
export const opportunitiesSyncMany = <ThrowOnError extends boolean = false>(options?: Options<OpportunitiesSyncManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<OpportunitiesSyncManyResponses, OpportunitiesSyncManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/opportunity/sync',
        ...options
    });
};

/**
 * Cursor-paginated id + version manifest of opportunities for scan/diff (no full payloads).
 */
export const opportunitiesManifestMany = <ThrowOnError extends boolean = false>(options?: Options<OpportunitiesManifestManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<OpportunitiesManifestManyResponses, OpportunitiesManifestManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/opportunity/manifest',
        ...options
    });
};

/**
 * Soft-delete an opportunity (a sales deal / prospect account) by UUID, removing the deal from the reference program. Use this to remove or archive a deal or prospect.
 */
export const opportunitiesDelete = <ThrowOnError extends boolean = false>(options: Options<OpportunitiesDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<OpportunitiesDeleteResponses, OpportunitiesDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/opportunity/{uuid}',
        ...options
    });
};

/**
 * Fetch a single opportunity (a sales deal / prospect account) by UUID, with its reference requests, origin integration source and enrichment fields. Use this to look up one deal or prospect and its details.
 */
export const opportunitiesRead = <ThrowOnError extends boolean = false>(options: Options<OpportunitiesReadData, ThrowOnError>) => {
    return (options.client ?? client).get<OpportunitiesReadResponses, OpportunitiesReadErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/opportunity/{uuid}',
        ...options
    });
};

/**
 * Update an existing opportunity (a sales deal / prospect account) — edit its name, prospect email, deadline or notes. Use this to change a deal or prospect's details.
 */
export const opportunitiesUpdate = <ThrowOnError extends boolean = false>(options: Options<OpportunitiesUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<OpportunitiesUpdateResponses, OpportunitiesUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/opportunity/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a reference request (a reference call) under an opportunity, kicking off finding and matching an advocate to reference for that sales deal / prospect. Use this to request a reference for a deal. Before you call it, read the brand's reference request form: call customFieldDefinitionsReadMany with targetModel=BrandReferenceRequest. Ask the user, by label, for each field with required: true that they have not given yet. Skip fields with isReadOnly: true. Ask for a field that has a showIf only when the answer to the field it names matches. Send a field with isSystem: true as a top-level property named by its fieldKey; Prospect Contact goes in opportunityContactsChosen as one email address, not a name. Deadline (opportunityDeadline) is the opportunity's deadline, not the request's; opportunitiesRead returns it. If the opportunity has one, show it, do not ask for a new one, and send that date. If not, send the date given as YYYY-MM-DD; it becomes the opportunity's deadline. Send every other field inside enrichments, keyed by its fieldKey. If the create fails with 422 'Missing required custom fields', details.fields gives the fieldKey and label of each missing field: ask for those and try again.
 */
export const opportunitiesBrandReferenceRequestCreate = <ThrowOnError extends boolean = false>(options: Options<OpportunitiesBrandReferenceRequestCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<OpportunitiesBrandReferenceRequestCreateResponses, OpportunitiesBrandReferenceRequestCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/opportunity/{uuid}/brandReferenceRequests',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Log a reference call that already happened offline: creates the reference under the opportunity, records the advocate manual activity (with its reward), and completes it — atomically.
 */
export const opportunitiesBrandReferenceRequestsManualMany = <ThrowOnError extends boolean = false>(options: Options<OpportunitiesBrandReferenceRequestsManualManyData, ThrowOnError>) => {
    return (options.client ?? client).post<OpportunitiesBrandReferenceRequestsManualManyResponses, OpportunitiesBrandReferenceRequestsManualManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/opportunity/{uuid}/brandReferenceRequests/manual',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieves all events for the brand with their assigned segments
 */
export const brandEventsReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandEventsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandEventsReadManyResponses, BrandEventsReadManyErrors, ThrowOnError>({
        url: '/api/v2/brandEvents',
        ...options
    });
};

/**
 * Creates a new event for the brand
 */
export const brandEventsCreate = <ThrowOnError extends boolean = false>(options: Options<BrandEventsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandEventsCreateResponses, BrandEventsCreateErrors, ThrowOnError>({
        url: '/api/v2/brandEvents',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Soft deletes an event by setting isActive to false
 */
export const brandEventsDelete = <ThrowOnError extends boolean = false>(options: Options<BrandEventsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandEventsDeleteResponses, BrandEventsDeleteErrors, ThrowOnError>({
        url: '/api/v2/brandEvents/{uuid}',
        ...options
    });
};

/**
 * Retrieves a single event by UUID with its assigned segments
 */
export const brandEventsRead = <ThrowOnError extends boolean = false>(options: Options<BrandEventsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandEventsReadResponses, BrandEventsReadErrors, ThrowOnError>({
        url: '/api/v2/brandEvents/{uuid}',
        ...options
    });
};

/**
 * Updates an existing event
 */
export const brandEventsUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandEventsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandEventsUpdateResponses, BrandEventsUpdateErrors, ThrowOnError>({
        url: '/api/v2/brandEvents/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieves events visible to the current fan user based on their segment membership
 */
export const fanEventsReadMany = <ThrowOnError extends boolean = false>(options?: Options<FanEventsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanEventsReadManyResponses, FanEventsReadManyErrors, ThrowOnError>({
        url: '/api/v2/fanEvents',
        ...options
    });
};

/**
 * Retrieves a single event by UUID, verifying the fan user has access via segment membership
 */
export const fanEventsRead = <ThrowOnError extends boolean = false>(options: Options<FanEventsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<FanEventsReadResponses, FanEventsReadErrors, ThrowOnError>({
        url: '/api/v2/fanEvents/{uuid}',
        ...options
    });
};

/**
 * List the brand's levels with the rewards and badges each awards, ordered by level number. Use this to answer "the level programme" or "what does each tier give".
 */
export const brandLevelsReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandLevelsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandLevelsReadManyResponses, BrandLevelsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevels',
        ...options
    });
};

/**
 * Create a level in the brand's advocacy programme — the tier an advocate reaches at a points threshold. Attach the rewards and badges it awards with POST /v2/brandLevels/{uuid}/createReward and /createBadge; a level may hold several of each.
 */
export const brandLevelsCreate = <ThrowOnError extends boolean = false>(options: Options<BrandLevelsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandLevelsCreateResponses, BrandLevelsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevels',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Soft delete a level by UUID. The soft-delete cascade tombstones its benefit attachments with it, so the record of what the level awarded survives.
 */
export const brandLevelsDelete = <ThrowOnError extends boolean = false>(options: Options<BrandLevelsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandLevelsDeleteResponses, BrandLevelsDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevels/{uuid}',
        ...options
    });
};

/**
 * Fetch a single level by UUID with the rewards and badges it awards. A soft-deleted level is not found.
 */
export const brandLevelsRead = <ThrowOnError extends boolean = false>(options: Options<BrandLevelsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandLevelsReadResponses, BrandLevelsReadErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevels/{uuid}',
        ...options
    });
};

/**
 * Update a level in the brand's advocacy programme — its name, image, number or points threshold. The rewards and badges it awards are managed through their own endpoints.
 */
export const brandLevelsUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandLevelsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandLevelsUpdateResponses, BrandLevelsUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevels/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Attach a reward to a level, so advocates who reach the tier earn it. A level may award several rewards. Detach with DELETE /v2/brandLevelRewards/{uuid}. Attaching the same reward twice is a no-op that returns the existing attachment.
 */
export const brandLevelsCreateReward = <ThrowOnError extends boolean = false>(options: Options<BrandLevelsCreateRewardData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandLevelsCreateRewardResponses, BrandLevelsCreateRewardErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevels/{uuid}/createReward',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Attach a badge to a level, so advocates who reach the tier earn it. A level may award several badges. Detach with DELETE /v2/brandLevelBadges/{uuid}. Attaching the same badge twice is a no-op that returns the existing attachment.
 */
export const brandLevelsCreateBadge = <ThrowOnError extends boolean = false>(options: Options<BrandLevelsCreateBadgeData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandLevelsCreateBadgeResponses, BrandLevelsCreateBadgeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevels/{uuid}/createBadge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * The brand's level ladder as it applies to the calling advocate: every level, with the benefits they are eligible for at each.
 */
export const brandLevelsMe = <ThrowOnError extends boolean = false>(options?: Options<BrandLevelsMeData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandLevelsMeResponses, BrandLevelsMeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevels/me',
        ...options
    });
};

/**
 * The brand's level ladder for an anonymous caller: every level, with only the benefits that carry no segment targeting. Identity is never read on this route — an authenticated advocate receives the same unresolved view.
 */
export const brandLevelsPublic = <ThrowOnError extends boolean = false>(options?: Options<BrandLevelsPublicData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandLevelsPublicResponses, BrandLevelsPublicErrors, ThrowOnError>({
        url: '/api/v2/brandLevels/public',
        ...options
    });
};

/**
 * Detach a reward from its level. Hard delete — the unique on (brandLevelUuid, brandRewardUuid) has no deletedAt arm, so a tombstone would block re-attaching the same reward.
 */
export const brandLevelRewardsDelete = <ThrowOnError extends boolean = false>(options: Options<BrandLevelRewardsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandLevelRewardsDeleteResponses, BrandLevelRewardsDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevelRewards/{uuid}',
        ...options
    });
};

/**
 * Replace the segment targeting of a level-reward attachment. Pass the complete group uuid set; [] clears targeting, which offers the reward to every advocate who reaches the level. Targeting is per attachment, so the same reward can be offered to different segments on different levels.
 */
export const brandLevelRewardsUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandLevelRewardsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandLevelRewardsUpdateResponses, BrandLevelRewardsUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevelRewards/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Detach a badge from its level. Hard delete — see brandLevelRewardsDelete.
 */
export const brandLevelBadgesDelete = <ThrowOnError extends boolean = false>(options: Options<BrandLevelBadgesDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandLevelBadgesDeleteResponses, BrandLevelBadgesDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevelBadges/{uuid}',
        ...options
    });
};

/**
 * Replace the segment targeting of a level-badge attachment. Pass the complete group uuid set; [] clears targeting, which offers the badge to every advocate who reaches the level. Targeting is per attachment, so the same badge can be offered to different segments on different levels.
 */
export const brandLevelBadgesUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandLevelBadgesUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandLevelBadgesUpdateResponses, BrandLevelBadgesUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandLevelBadges/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List and filter the brand's rewards catalog — the items advocates can redeem with points. Search and sort by title, reward type, point cost or created date. Serves both the admin catalog and the advocate-facing store. Use this to answer "all rewards", "the rewards catalog", or "what can advocates redeem".
 */
export const brandRewardsReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandRewardsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandRewardsReadManyResponses, BrandRewardsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/v2/brandRewards',
        ...options
    });
};

/**
 * Create a reward in the brand's rewards catalog — an item advocates can redeem with their points. Set its title, description, image, point cost, redemption limits and segment/level targeting. Use this to add a new reward advocates can earn.
 */
export const brandRewardsCreate = <ThrowOnError extends boolean = false>(options: Options<BrandRewardsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandRewardsCreateResponses, BrandRewardsCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandRewards',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Remove the background from a reward image before it is uploaded. Accepts a base64-encoded PNG or JPEG up to the reward-image storage limit and returns the processed image as base64. The image-processing provider is called server-side with a platform-held key.
 */
export const brandRewardsRemoveBackground = <ThrowOnError extends boolean = false>(options: Options<BrandRewardsRemoveBackgroundData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandRewardsRemoveBackgroundResponses, BrandRewardsRemoveBackgroundErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandRewards/removeBackground',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get reward with eligibility
 *
 * Fetches a reward by UUID and checks if the user is eligible for a direct reward.
 */
export const brandRewardsRead = <ThrowOnError extends boolean = false>(options: Options<BrandRewardsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandRewardsReadResponses, BrandRewardsReadErrors, ThrowOnError>({
        url: '/api/v2/brandRewards/{uuid}',
        ...options
    });
};

/**
 * Update a reward in the brand's rewards catalog — edit its title, description, point cost, redemption limits or segment/level targeting. Use this to change an existing reward advocates can redeem.
 */
export const brandRewardsUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandRewardsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandRewardsUpdateResponses, BrandRewardsUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandRewards/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Redeem a reward
 *
 * Redeems the reward for the authenticated fan. Identity, brand and eligibility are resolved server-side.
 */
export const brandRewardsRedeem = <ThrowOnError extends boolean = false>(options: Options<BrandRewardsRedeemData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandRewardsRedeemResponses, BrandRewardsRedeemErrors, ThrowOnError>({
        url: '/api/v2/brandRewards/{uuid}/redeem',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get the authenticated fan's reward redemption history
 *
 * Returns the authenticated fan's own reward redemptions, newest first. Identity comes from the JWT — the fan never supplies their own identifier.
 */
export const fanRewardsMe = <ThrowOnError extends boolean = false>(options?: Options<FanRewardsMeData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanRewardsMeResponses, FanRewardsMeErrors, ThrowOnError>({
        url: '/api/v2/fanRewards/me',
        ...options
    });
};

/**
 * Lists reward redemptions for the authenticated brand with optional status filtering. Supports pagination.
 */
export const fanRewardsReadMany = <ThrowOnError extends boolean = false>(options?: Options<FanRewardsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanRewardsReadManyResponses, FanRewardsReadManyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanRewards',
        ...options
    });
};

/**
 * Approves a reward redemption that is pending approval. Updates status to requested and fires webhook notifications.
 */
export const fanRewardsApprove = <ThrowOnError extends boolean = false>(options: Options<FanRewardsApproveData, ThrowOnError>) => {
    return (options.client ?? client).post<FanRewardsApproveResponses, FanRewardsApproveErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanRewards/{uuid}/approve',
        ...options
    });
};

/**
 * Rejects a reward redemption that is pending approval. Returns points to the advocate and records an optional rejection note.
 */
export const fanRewardsReject = <ThrowOnError extends boolean = false>(options: Options<FanRewardsRejectData, ThrowOnError>) => {
    return (options.client ?? client).post<FanRewardsRejectResponses, FanRewardsRejectErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanRewards/{uuid}/reject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * The calling advocate's badges: the ones they have earned and the ones still available to earn, each list already ordered by the level that grants the badge and then the brand catalogue's own order.
 */
export const fanBadgesMe = <ThrowOnError extends boolean = false>(options?: Options<FanBadgesMeData, ThrowOnError>) => {
    return (options?.client ?? client).get<FanBadgesMeResponses, FanBadgesMeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/fanBadges/me',
        ...options
    });
};

/**
 * List brand users
 *
 * Returns a paginated list of active brand users for the authenticated user's brand.
 */
export const brandUsersReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandUsersReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandUsersReadManyResponses, BrandUsersReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/v2/brandUsers',
        ...options
    });
};

/**
 * Get current brand user profile
 *
 * Returns the authenticated brand user's profile including permissions
 */
export const brandUsersMe = <ThrowOnError extends boolean = false>(options?: Options<BrandUsersMeData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandUsersMeResponses, BrandUsersMeErrors, ThrowOnError>({
        url: '/api/v2/brandUsers/me',
        ...options
    });
};

/**
 * Update current brand user profile
 *
 * Updates the authenticated brand user's profile picture.
 */
export const brandUsersMeUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandUsersMeUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandUsersMeUpdateResponses, BrandUsersMeUpdateErrors, ThrowOnError>({
        url: '/api/v2/brandUsers/me',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Register new brand user
 *
 * Creates or verifies a brand user account during signup/login flows. No authentication required.
 */
export const brandUsersRegister = <ThrowOnError extends boolean = false>(options: Options<BrandUsersRegisterData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandUsersRegisterResponses, BrandUsersRegisterErrors, ThrowOnError>({
        url: '/api/v2/brandUsers/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Select active workspace
 *
 * Updates the active workspace for the current super admin.
 */
export const brandUsersWorkspacesSelect = <ThrowOnError extends boolean = false>(options: Options<BrandUsersWorkspacesSelectData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandUsersWorkspacesSelectResponses, BrandUsersWorkspacesSelectErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v2/brandUsers/workspaces/select',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Send admin invitation email
 *
 * Sends an admin invitation email to the specified email address for the current brand
 */
export const brandUsersInvite = <ThrowOnError extends boolean = false>(options: Options<BrandUsersInviteData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandUsersInviteResponses, BrandUsersInviteErrors, ThrowOnError>({
        url: '/api/v2/brandUsers/invite',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Remove brand admin
 *
 * Removes a brand admin from the authenticated user's brand (soft delete).
 */
export const brandUsersDelete = <ThrowOnError extends boolean = false>(options: Options<BrandUsersDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BrandUsersDeleteResponses, BrandUsersDeleteErrors, ThrowOnError>({
        url: '/api/v2/brandUsers/{uuid}',
        ...options
    });
};

/**
 * Public: webhook signing public key + deliverable models.
 */
export const webhookSubscriptionsInfo = <ThrowOnError extends boolean = false>(options?: Options<WebhookSubscriptionsInfoData, ThrowOnError>) => {
    return (options?.client ?? client).get<WebhookSubscriptionsInfoResponses, WebhookSubscriptionsInfoErrors, ThrowOnError>({
        url: '/api/v2/webhookSubscription/info',
        ...options
    });
};

/**
 * List the brand’s webhook subscriptions.
 */
export const webhookSubscriptionsReadMany = <ThrowOnError extends boolean = false>(options?: Options<WebhookSubscriptionsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<WebhookSubscriptionsReadManyResponses, WebhookSubscriptionsReadManyErrors, ThrowOnError>({
        url: '/api/v2/webhookSubscription',
        ...options
    });
};

/**
 * Register a webhook subscription for the brand.
 */
export const webhookSubscriptionsCreate = <ThrowOnError extends boolean = false>(options: Options<WebhookSubscriptionsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<WebhookSubscriptionsCreateResponses, WebhookSubscriptionsCreateErrors, ThrowOnError>({
        url: '/api/v2/webhookSubscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Re-emit this subscription’s deliveries over a time window (current state; deletes replay the logged payload).
 */
export const webhookSubscriptionsReplay = <ThrowOnError extends boolean = false>(options: Options<WebhookSubscriptionsReplayData, ThrowOnError>) => {
    return (options.client ?? client).post<WebhookSubscriptionsReplayResponses, WebhookSubscriptionsReplayErrors, ThrowOnError>({
        url: '/api/v2/webhookSubscription/{uuid}/replay',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Soft delete a webhook subscription by UUID.
 */
export const webhookSubscriptionsDelete = <ThrowOnError extends boolean = false>(options: Options<WebhookSubscriptionsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<WebhookSubscriptionsDeleteResponses, WebhookSubscriptionsDeleteErrors, ThrowOnError>({
        url: '/api/v2/webhookSubscription/{uuid}',
        ...options
    });
};

/**
 * Update a webhook subscription (url or active state).
 */
export const webhookSubscriptionsUpdate = <ThrowOnError extends boolean = false>(options: Options<WebhookSubscriptionsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<WebhookSubscriptionsUpdateResponses, WebhookSubscriptionsUpdateErrors, ThrowOnError>({
        url: '/api/v2/webhookSubscription/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Creates a new Workflows.
 */
export const workflowsCreate = <ThrowOnError extends boolean = false>(options: Options<WorkflowsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<WorkflowsCreateResponses, WorkflowsCreateErrors, ThrowOnError>({
        url: '/api/v2/workflows',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieves an existing Workflows.
 */
export const workflowsRead = <ThrowOnError extends boolean = false>(options: Options<WorkflowsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<WorkflowsReadResponses, WorkflowsReadErrors, ThrowOnError>({
        url: '/api/v2/workflows/{uuid}',
        ...options
    });
};

/**
 * Updates an existing Workflows.
 */
export const workflowsUpdate = <ThrowOnError extends boolean = false>(options: Options<WorkflowsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<WorkflowsUpdateResponses, WorkflowsUpdateErrors, ThrowOnError>({
        url: '/api/v2/workflows/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieves an existing Workflow by workflowID.
 */
export const workflowsReadByWorkflowId = <ThrowOnError extends boolean = false>(options: Options<WorkflowsReadByWorkflowIdData, ThrowOnError>) => {
    return (options.client ?? client).get<WorkflowsReadByWorkflowIdResponses, WorkflowsReadByWorkflowIdErrors, ThrowOnError>({
        url: '/api/v2/workflows/by-workflow-id/{workflowID}',
        ...options
    });
};

/**
 * Execute a workflow from the Trigger step
 */
export const workflowsExecute = <ThrowOnError extends boolean = false>(options: Options<WorkflowsExecuteData, ThrowOnError>) => {
    return (options.client ?? client).post<WorkflowsExecuteResponses, WorkflowsExecuteErrors, ThrowOnError>({
        url: '/api/v2/workflows/execute',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Marks a brand as moved to server-started embed sessions (POST /fanUsers/embed), or moves it back onto the legacy POST /fanUsers/token mint. A migrated brand is served only by the embed route; a moved-back brand is allowlisted for the legacy mint. Moving back a brand that was never migrated and is not allowlisted is refused with 409 and changes nothing. Super admin only.
 */
export const brandConfigsEmbedMigration = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsEmbedMigrationData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandConfigsEmbedMigrationResponses, BrandConfigsEmbedMigrationErrors, ThrowOnError>({
        url: '/api/admin/brandConfig/embedMigration',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List brand sending domains for administration.
 */
export const brandSendingDomainsReadMany = <ThrowOnError extends boolean = false>(options?: Options<BrandSendingDomainsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<BrandSendingDomainsReadManyResponses, BrandSendingDomainsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/admin/brandSendingDomains',
        ...options
    });
};

/**
 * Provision a sending domain through the configured email provider.
 */
export const brandSendingDomainsCreate = <ThrowOnError extends boolean = false>(options: Options<BrandSendingDomainsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandSendingDomainsCreateResponses, BrandSendingDomainsCreateErrors, ThrowOnError>({
        url: '/api/admin/brandSendingDomains',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Read a brand sending domain and its provider DNS records.
 */
export const brandSendingDomainsRead = <ThrowOnError extends boolean = false>(options: Options<BrandSendingDomainsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<BrandSendingDomainsReadResponses, BrandSendingDomainsReadErrors, ThrowOnError>({
        url: '/api/admin/brandSendingDomains/{uuid}',
        ...options
    });
};

/**
 * Update a brand sending domain pacing rate.
 */
export const brandSendingDomainsUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandSendingDomainsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<BrandSendingDomainsUpdateResponses, BrandSendingDomainsUpdateErrors, ThrowOnError>({
        url: '/api/admin/brandSendingDomains/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Ask the configured email provider to verify a brand sending domain.
 */
export const brandSendingDomainsVerify = <ThrowOnError extends boolean = false>(options: Options<BrandSendingDomainsVerifyData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandSendingDomainsVerifyResponses, BrandSendingDomainsVerifyErrors, ThrowOnError>({
        url: '/api/admin/brandSendingDomains/{uuid}/verify',
        ...options
    });
};

/**
 * Activate a verified brand sending domain.
 */
export const brandSendingDomainsActivate = <ThrowOnError extends boolean = false>(options: Options<BrandSendingDomainsActivateData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandSendingDomainsActivateResponses, BrandSendingDomainsActivateErrors, ThrowOnError>({
        url: '/api/admin/brandSendingDomains/{uuid}/activate',
        ...options
    });
};

/**
 * Pause an active or halted sending domain. A paused brand row falls through to house; a paused house row falls through to legacy.
 */
export const brandSendingDomainsPause = <ThrowOnError extends boolean = false>(options: Options<BrandSendingDomainsPauseData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandSendingDomainsPauseResponses, BrandSendingDomainsPauseErrors, ThrowOnError>({
        url: '/api/admin/brandSendingDomains/{uuid}/pause',
        ...options
    });
};

/**
 * Halt an active or verified sending domain with an operator reason. Sends fail closed until resumed or paused. Resuming a halted domain makes it active, including one that was only verified before the halt.
 */
export const brandSendingDomainsHalt = <ThrowOnError extends boolean = false>(options: Options<BrandSendingDomainsHaltData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandSendingDomainsHaltResponses, BrandSendingDomainsHaltErrors, ThrowOnError>({
        url: '/api/admin/brandSendingDomains/{uuid}/halt',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resume a paused or halted sending domain (whole row)
 */
export const brandSendingDomainsResume = <ThrowOnError extends boolean = false>(options: Options<BrandSendingDomainsResumeData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandSendingDomainsResumeResponses, BrandSendingDomainsResumeErrors, ThrowOnError>({
        url: '/api/admin/brandSendingDomains/{uuid}/resume',
        ...options
    });
};

/**
 * Resume one brand on a shared house domain
 */
export const brandSendingDomainsResumeBrand = <ThrowOnError extends boolean = false>(options: Options<BrandSendingDomainsResumeBrandData, ThrowOnError>) => {
    return (options.client ?? client).post<BrandSendingDomainsResumeBrandResponses, BrandSendingDomainsResumeBrandErrors, ThrowOnError>({
        url: '/api/admin/brandSendingDomains/{uuid}/resumeBrand',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Clear cache entries by key/pattern, or flush all. Super admin only.
 */
export const cachesClear = <ThrowOnError extends boolean = false>(options: Options<CachesClearData, ThrowOnError>) => {
    return (options.client ?? client).post<CachesClearResponses, CachesClearErrors, ThrowOnError>({
        url: '/api/admin/cache/clear',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all cron jobs
 */
export const cronJobsReadMany = <ThrowOnError extends boolean = false>(options?: Options<CronJobsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<CronJobsReadManyResponses, CronJobsReadManyErrors, ThrowOnError>({
        url: '/api/admin/cronJobs',
        ...options
    });
};

/**
 * Creates a new cron job
 */
export const cronJobsCreate = <ThrowOnError extends boolean = false>(options: Options<CronJobsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<CronJobsCreateResponses, CronJobsCreateErrors, ThrowOnError>({
        url: '/api/admin/cronJobs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a cron job
 */
export const cronJobsDelete = <ThrowOnError extends boolean = false>(options: Options<CronJobsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<CronJobsDeleteResponses, CronJobsDeleteErrors, ThrowOnError>({
        url: '/api/admin/cronJobs/{uuid}',
        ...options
    });
};

/**
 * Get a cron job by UUID
 */
export const cronJobsRead = <ThrowOnError extends boolean = false>(options: Options<CronJobsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<CronJobsReadResponses, CronJobsReadErrors, ThrowOnError>({
        url: '/api/admin/cronJobs/{uuid}',
        ...options
    });
};

/**
 * Update a cron job
 */
export const cronJobsUpdate = <ThrowOnError extends boolean = false>(options: Options<CronJobsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<CronJobsUpdateResponses, CronJobsUpdateErrors, ThrowOnError>({
        url: '/api/admin/cronJobs/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Manually triggers a cron job to run immediately
 */
export const cronJobsTrigger = <ThrowOnError extends boolean = false>(options: Options<CronJobsTriggerData, ThrowOnError>) => {
    return (options.client ?? client).post<CronJobsTriggerResponses, CronJobsTriggerErrors, ThrowOnError>({
        url: '/api/admin/cronJobs/{uuid}/trigger',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List platform MJML email components. Super admin only.
 */
export const adminEmailComponentsReadMany = <ThrowOnError extends boolean = false>(options?: Options<AdminEmailComponentsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminEmailComponentsReadManyResponses, AdminEmailComponentsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/admin/emailComponent',
        ...options
    });
};

/**
 * Create a platform MJML email component. Super admin only.
 */
export const adminEmailComponentsCreate = <ThrowOnError extends boolean = false>(options: Options<AdminEmailComponentsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminEmailComponentsCreateResponses, AdminEmailComponentsCreateErrors, ThrowOnError>({
        url: '/api/admin/emailComponent',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a platform MJML email component and report template impact. Super admin only.
 */
export const adminEmailComponentDelete = <ThrowOnError extends boolean = false>(options: Options<AdminEmailComponentDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminEmailComponentDeleteResponses, AdminEmailComponentDeleteErrors, ThrowOnError>({
        url: '/api/admin/emailComponent/{uuid}',
        ...options
    });
};

/**
 * Update a platform MJML email component. Super admin only.
 */
export const adminEmailComponentUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminEmailComponentUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminEmailComponentUpdateResponses, AdminEmailComponentUpdateErrors, ThrowOnError>({
        url: '/api/admin/emailComponent/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List platform MJML email templates. Super admin only.
 */
export const adminEmailTemplatesReadMany = <ThrowOnError extends boolean = false>(options?: Options<AdminEmailTemplatesReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminEmailTemplatesReadManyResponses, AdminEmailTemplatesReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/admin/emailTemplate',
        ...options
    });
};

/**
 * Create a platform MJML email template. Super admin only.
 */
export const adminEmailTemplatesCreate = <ThrowOnError extends boolean = false>(options: Options<AdminEmailTemplatesCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminEmailTemplatesCreateResponses, AdminEmailTemplatesCreateErrors, ThrowOnError>({
        url: '/api/admin/emailTemplate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a platform MJML email template and report brand-override impact. Super admin only.
 */
export const adminEmailTemplateDelete = <ThrowOnError extends boolean = false>(options: Options<AdminEmailTemplateDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminEmailTemplateDeleteResponses, AdminEmailTemplateDeleteErrors, ThrowOnError>({
        url: '/api/admin/emailTemplate/{uuid}',
        ...options
    });
};

/**
 * Update a platform MJML email template. Super admin only.
 */
export const adminEmailTemplateUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminEmailTemplateUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminEmailTemplateUpdateResponses, AdminEmailTemplateUpdateErrors, ThrowOnError>({
        url: '/api/admin/emailTemplate/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Merges two fan user accounts. The primary account retains its identity while all data from the secondary account is transferred to it. The secondary account is soft-deleted after the merge. Super admin only.
 */
export const fanUsersMerge = <ThrowOnError extends boolean = false>(options: Options<FanUsersMergeData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersMergeResponses, FanUsersMergeErrors, ThrowOnError>({
        url: '/api/admin/fanUsers/merge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bans a fan user by setting deletedAt and blocking them in Auth0. PII is retained. Reversible. Super admin only.
 */
export const fanUsersBan = <ThrowOnError extends boolean = false>(options: Options<FanUsersBanData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersBanResponses, FanUsersBanErrors, ThrowOnError>({
        url: '/api/admin/fanUsers/ban',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Unbans a fan user by clearing deletedAt/bannedReason and unblocking them in Auth0. GDPR-deleted users cannot be unbanned. Super admin only.
 */
export const fanUsersUnban = <ThrowOnError extends boolean = false>(options: Options<FanUsersUnbanData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersUnbanResponses, FanUsersUnbanErrors, ThrowOnError>({
        url: '/api/admin/fanUsers/unban',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Lifts the block a ban left behind when the banned member was erased, so the address can join the brand again. The address is hashed and matched; it is never stored. Super admin only.
 */
export const fanUsersLiftBanBlock = <ThrowOnError extends boolean = false>(options: Options<FanUsersLiftBanBlockData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersLiftBanBlockResponses, FanUsersLiftBanBlockErrors, ThrowOnError>({
        url: '/api/admin/fanUsers/liftBanBlock',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Permanently deletes a fan user by redacting all PII and setting deletedAt. Content is retained. Irreversible. Super admin only.
 */
export const fanUsersGdprDelete = <ThrowOnError extends boolean = false>(options: Options<FanUsersGdprDeleteData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersGdprDeleteResponses, FanUsersGdprDeleteErrors, ThrowOnError>({
        url: '/api/admin/fanUsers/gdprDelete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Permanently deletes a batch of fan users by redacting PII and setting deletedAt on each. Optionally soft-deletes their forum content. Per-user failures are collected and returned; the request as a whole still resolves 200 unless validation fails. Super admin only.
 */
export const fanUsersBulkGdprDeleteMany = <ThrowOnError extends boolean = false>(options: Options<FanUsersBulkGdprDeleteManyData, ThrowOnError>) => {
    return (options.client ?? client).post<FanUsersBulkGdprDeleteManyResponses, FanUsersBulkGdprDeleteManyErrors, ThrowOnError>({
        url: '/api/admin/fanUsers/bulkGdprDelete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Enqueues a resumable sweep of every Opportunity in a LIVE Salesforce source through the opportunity intake path (identity-deduped against package pushes). The source must have opted in with an opportunity sync cursor row (a restart creates it). Super admin only.
 */
export const integrationSourcesSalesforceOpportunitySweep = <ThrowOnError extends boolean = false>(options: Options<IntegrationSourcesSalesforceOpportunitySweepData, ThrowOnError>) => {
    return (options.client ?? client).post<IntegrationSourcesSalesforceOpportunitySweepResponses, IntegrationSourcesSalesforceOpportunitySweepErrors, ThrowOnError>({
        url: '/api/admin/integrationSources/salesforceOpportunitySweep',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Enqueue an ad-hoc background job
 */
export const jobsCreate = <ThrowOnError extends boolean = false>(options: Options<JobsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<JobsCreateResponses, JobsCreateErrors, ThrowOnError>({
        url: '/api/admin/jobs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Run an NRQL query through the platform New Relic credential. Requires SINCE and LIMIT clauses. Super admin only.
 */
export const newRelicsQuery = <ThrowOnError extends boolean = false>(options: Options<NewRelicsQueryData, ThrowOnError>) => {
    return (options.client ?? client).post<NewRelicsQueryResponses, NewRelicsQueryErrors, ThrowOnError>({
        url: '/api/admin/newRelic/query',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrigger missed rewardRedeemed notifications for specific FanReward IDs
 */
export const notificationsRetriggerRewardNotifications = <ThrowOnError extends boolean = false>(options: Options<NotificationsRetriggerRewardNotificationsData, ThrowOnError>) => {
    return (options.client ?? client).post<NotificationsRetriggerRewardNotificationsResponses, NotificationsRetriggerRewardNotificationsErrors, ThrowOnError>({
        url: '/api/admin/notifications/retriggerRewardNotifications',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrigger existing notifications by UUID — re-invokes the Lambda writer for delivery
 */
export const notificationsRetrigger = <ThrowOnError extends boolean = false>(options: Options<NotificationsRetriggerData, ThrowOnError>) => {
    return (options.client ?? client).post<NotificationsRetriggerResponses, NotificationsRetriggerErrors, ThrowOnError>({
        url: '/api/admin/notifications/retrigger',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List platform alert destinations.
 */
export const platformAlertDestinationsReadMany = <ThrowOnError extends boolean = false>(options?: Options<PlatformAlertDestinationsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<PlatformAlertDestinationsReadManyResponses, PlatformAlertDestinationsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/admin/platformAlertDestinations',
        ...options
    });
};

/**
 * Create a platform alert destination for an audience.
 */
export const platformAlertDestinationsCreate = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertDestinationsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<PlatformAlertDestinationsCreateResponses, PlatformAlertDestinationsCreateErrors, ThrowOnError>({
        url: '/api/admin/platformAlertDestinations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a platform alert destination. Refused with 422 when it is the last enabled destination of an audience that enabled rules route to.
 */
export const platformAlertDestinationsDelete = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertDestinationsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<PlatformAlertDestinationsDeleteResponses, PlatformAlertDestinationsDeleteErrors, ThrowOnError>({
        url: '/api/admin/platformAlertDestinations/{uuid}',
        ...options
    });
};

/**
 * Update a platform alert destination. Refused with 422 when it is the last enabled destination of an audience that enabled rules route to.
 */
export const platformAlertDestinationsUpdate = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertDestinationsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<PlatformAlertDestinationsUpdateResponses, PlatformAlertDestinationsUpdateErrors, ThrowOnError>({
        url: '/api/admin/platformAlertDestinations/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List platform alert incidents with their rule summary.
 */
export const platformAlertIncidentsReadMany = <ThrowOnError extends boolean = false>(options?: Options<PlatformAlertIncidentsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<PlatformAlertIncidentsReadManyResponses, PlatformAlertIncidentsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/admin/platformAlertIncidents',
        ...options
    });
};

/**
 * Read a platform alert incident with its rule summary.
 */
export const platformAlertIncidentsRead = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertIncidentsReadData, ThrowOnError>) => {
    return (options.client ?? client).get<PlatformAlertIncidentsReadResponses, PlatformAlertIncidentsReadErrors, ThrowOnError>({
        url: '/api/admin/platformAlertIncidents/{uuid}',
        ...options
    });
};

/**
 * Acknowledge a pending or firing platform alert incident as the acting superadmin.
 */
export const platformAlertIncidentsAcknowledge = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertIncidentsAcknowledgeData, ThrowOnError>) => {
    return (options.client ?? client).post<PlatformAlertIncidentsAcknowledgeResponses, PlatformAlertIncidentsAcknowledgeErrors, ThrowOnError>({
        url: '/api/admin/platformAlertIncidents/{uuid}/acknowledge',
        ...options
    });
};

/**
 * Assign an open incident to a superadmin, or clear the assignee with null.
 */
export const platformAlertIncidentsAssign = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertIncidentsAssignData, ThrowOnError>) => {
    return (options.client ?? client).post<PlatformAlertIncidentsAssignResponses, PlatformAlertIncidentsAssignErrors, ThrowOnError>({
        url: '/api/admin/platformAlertIncidents/{uuid}/assign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resolve an open incident with an optional note; frees the open fence for its rule and scope.
 */
export const platformAlertIncidentsResolve = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertIncidentsResolveData, ThrowOnError>) => {
    return (options.client ?? client).post<PlatformAlertIncidentsResolveResponses, PlatformAlertIncidentsResolveErrors, ThrowOnError>({
        url: '/api/admin/platformAlertIncidents/{uuid}/resolve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add a note to a platform alert incident
 *
 * Appends a timestamped, attributed note to the incident timeline.
 */
export const platformAlertIncidentsNoteCreate = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertIncidentsNoteCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<PlatformAlertIncidentsNoteCreateResponses, PlatformAlertIncidentsNoteCreateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/platformAlertIncidents/{uuid}/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Incident timeline: audited state changes and notes, newest first.
 */
export const platformAlertIncidentsTimelineEntriesReadMany = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertIncidentsTimelineEntriesReadManyData, ThrowOnError>) => {
    return (options.client ?? client).get<PlatformAlertIncidentsTimelineEntriesReadManyResponses, PlatformAlertIncidentsTimelineEntriesReadManyErrors, ThrowOnError>({
        url: '/api/admin/platformAlertIncidents/{uuid}/timelineEntries',
        ...options
    });
};

/**
 * Signal-lens surface for the threshold rule builder, plus the registered signal providers.
 */
export const platformAlertRulesConditionsSchema = <ThrowOnError extends boolean = false>(options?: Options<PlatformAlertRulesConditionsSchemaData, ThrowOnError>) => {
    return (options?.client ?? client).get<PlatformAlertRulesConditionsSchemaResponses, PlatformAlertRulesConditionsSchemaErrors, ThrowOnError>({
        url: '/api/admin/platformAlertRules/conditionsSchema',
        ...options
    });
};

/**
 * A model's lens surface and groupable scopeBy columns for the dataState builder.
 */
export const platformAlertRulesModelConditionsSchema = <ThrowOnError extends boolean = false>(options?: Options<PlatformAlertRulesModelConditionsSchemaData, ThrowOnError>) => {
    return (options?.client ?? client).get<PlatformAlertRulesModelConditionsSchemaResponses, PlatformAlertRulesModelConditionsSchemaErrors, ThrowOnError>({
        url: '/api/admin/platformAlertRules/modelConditionsSchema',
        ...options
    });
};

/**
 * Evaluate an unsaved rule now and return which scopes would breach. Writes nothing.
 */
export const platformAlertRulesDryRunDraft = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertRulesDryRunDraftData, ThrowOnError>) => {
    return (options.client ?? client).post<PlatformAlertRulesDryRunDraftResponses, PlatformAlertRulesDryRunDraftErrors, ThrowOnError>({
        url: '/api/admin/platformAlertRules/dryRunDraft',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List platform alert rules.
 */
export const platformAlertRulesReadMany = <ThrowOnError extends boolean = false>(options?: Options<PlatformAlertRulesReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<PlatformAlertRulesReadManyResponses, PlatformAlertRulesReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/admin/platformAlertRules',
        ...options
    });
};

/**
 * Create a platform alert rule. Refused with 422 when the rule could not be evaluated.
 */
export const platformAlertRulesCreate = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertRulesCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<PlatformAlertRulesCreateResponses, PlatformAlertRulesCreateErrors, ThrowOnError>({
        url: '/api/admin/platformAlertRules',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a platform alert rule and its incidents.
 */
export const platformAlertRulesDelete = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertRulesDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<PlatformAlertRulesDeleteResponses, PlatformAlertRulesDeleteErrors, ThrowOnError>({
        url: '/api/admin/platformAlertRules/{uuid}',
        ...options
    });
};

/**
 * Read a platform alert rule.
 */
export const platformAlertRulesRead = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertRulesReadData, ThrowOnError>) => {
    return (options.client ?? client).get<PlatformAlertRulesReadResponses, PlatformAlertRulesReadErrors, ThrowOnError>({
        url: '/api/admin/platformAlertRules/{uuid}',
        ...options
    });
};

/**
 * Update a platform alert rule. The merged rule must still be evaluable; newRelic rules only toggle isEnabled.
 */
export const platformAlertRulesUpdate = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertRulesUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<PlatformAlertRulesUpdateResponses, PlatformAlertRulesUpdateErrors, ThrowOnError>({
        url: '/api/admin/platformAlertRules/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Evaluate a saved rule now and return which scopes would breach. Writes nothing.
 */
export const platformAlertRulesDryRun = <ThrowOnError extends boolean = false>(options: Options<PlatformAlertRulesDryRunData, ThrowOnError>) => {
    return (options.client ?? client).post<PlatformAlertRulesDryRunResponses, PlatformAlertRulesDryRunErrors, ThrowOnError>({
        url: '/api/admin/platformAlertRules/{uuid}/dryRun',
        ...options
    });
};

/**
 * List the platform system prompts, one per key. Super admin only.
 */
export const adminPromptsReadMany = <ThrowOnError extends boolean = false>(options?: Options<AdminPromptsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminPromptsReadManyResponses, AdminPromptsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/prompt',
        ...options
    });
};

/**
 * Update a platform system prompt. The deploy seed rewrites every platform prompt from code, so an edit here lasts until the next deploy. Super admin only.
 */
export const adminPromptsUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminPromptsUpdateData, ThrowOnError>) => {
    return (options.client ?? client).patch<AdminPromptsUpdateResponses, AdminPromptsUpdateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/prompt/{uuid}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List the webhook subscriptions that have no brand.
 */
export const adminWebhookSubscriptionsReadMany = <ThrowOnError extends boolean = false>(options?: Options<AdminWebhookSubscriptionsReadManyData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminWebhookSubscriptionsReadManyResponses, AdminWebhookSubscriptionsReadManyErrors, ThrowOnError>({
        querySerializer: {
            parameters: {
                searchFields: {
                    object: {
                        style: 'form'
                    }
                }
            }
        },
        url: '/api/admin/webhookSubscription',
        ...options
    });
};

/**
 * Subscribe a URL to a platform model (PlatformAlertIncident). Registering a URL again revives it.
 */
export const adminWebhookSubscriptionsCreate = <ThrowOnError extends boolean = false>(options: Options<AdminWebhookSubscriptionsCreateData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminWebhookSubscriptionsCreateResponses, AdminWebhookSubscriptionsCreateErrors, ThrowOnError>({
        url: '/api/admin/webhookSubscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Soft delete a webhook subscription that has no brand.
 */
export const adminWebhookSubscriptionsDelete = <ThrowOnError extends boolean = false>(options: Options<AdminWebhookSubscriptionsDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminWebhookSubscriptionsDeleteResponses, AdminWebhookSubscriptionsDeleteErrors, ThrowOnError>({
        url: '/api/admin/webhookSubscription/{uuid}',
        ...options
    });
};
